// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2720%27 height=%2720%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%235C5F58%27 stroke-width=%272%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2720%27 height=%2720%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23A5A89F%27 stroke-width=%272%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   TuraQuant - Global Styles
   ============================================ */

/* --- CSS Custom Properties --- */
:root {
  color-scheme: light;

  /* ══ Turacoz brand ══
     Taken from the Vista portal (vista.turacoz.com). The brand ramp runs
     green → teal → blue; the portal uses ink for primary buttons with a green
     hover, blue for links, and green as the live accent. No gradients. */
  --brand-green-1: #98CA3C;
  --brand-green-2: #87C541;
  --brand-green-3: #65BC46;
  --brand-green-4: #3EA151;
  --brand-teal: #3E8E8D;
  --brand-blue: #3A57A7;
  --brand-ink: #0A0203;

  /* ── Interactive ──
     --color-primary is the living accent: active nav, icons, focus, links.
     Primary BUTTONS are ink with a green hover, matching the portal — that rule
     lives on .btn-primary rather than here, so the two do not fight. */
  --color-primary: #3EA151;
  --color-primary-dark: #2C7139;
  --color-primary-light: #98CA3C;
  --color-primary-bg: #EEF4E0;
  --color-primary-contrast: #FFFFFF;
  --color-secondary: #0A0203;
  --color-accent: #3E8E8D;
  --color-link: #3A57A7;

  /* ── Status ── */
  --color-success: #3EA151;
  --color-success-bg: #E9F3E2;
  --color-success-text: #2C7139;
  --color-warning: #C97A00;
  --color-warning-bg: #FBF1DE;
  --color-warning-text: #8A5400;
  --color-error: #C4362C;
  --color-error-bg: #FAEBE9;
  --color-error-text: #932720;
  --color-danger: #C4362C;
  --color-info: #3A57A7;
  --color-info-bg: #E4E8F2;
  --color-info-text: #2C4384;

  /* ── Categorical ──
     Chart series, data-source badges and role tags need more hues than the
     brand ramp provides, and those hues must stay distinguishable rather than
     harmonised. They are tokens all the same, so they can be re-tuned for dark
     mode — the deep violet and pink below are unreadable on a dark ground. */
  --color-violet: #6D28D9;
  --color-violet-bg: #EDE9FE;
  --color-pink: #C0246A;
  --color-pink-bg: #FBE7F0;

  /* ── Text. Warm, olive-leaning greys — not slate. ── */
  --color-text: #0A0203;
  --color-text-secondary: #5C5F58;
  --color-text-light: #8E918A;
  --color-text-inverse: #FAFAF7;

  /* ── Surfaces ──
     --color-bg is the page, --color-surface a card on it, --color-surface-raised
     a control nested on the card. Named by role, not by "white", which is what
     lets the dark theme swap them wholesale. */
  --color-bg: #FAFAF7;
  --color-surface: #FFFFFF;
  --color-surface-raised: #F4F4F0;
  --color-surface-sunken: #ECECE6;
  --color-surface-hover: #ECECE6;
  --color-overlay: rgba(10, 2, 3, 0.55);
  --color-white: #FFFFFF;

  /* ── Lines ── */
  --color-border: #E5E5DF;
  --color-border-light: #F4F4F0;
  --color-border-strong: #D0D0C8;
  --color-focus-ring: rgba(62, 161, 81, 0.35);

  /* ── Elevation. Ink-tinted, as on the portal — a neutral black shadow reads
     grey and muddy against a warm off-white ground. ── */
  --shadow-sm: 0 1px 2px rgba(10, 2, 3, 0.04), 0 1px 4px rgba(10, 2, 3, 0.04);
  --shadow: 0 2px 6px rgba(10, 2, 3, 0.05), 0 1px 3px rgba(10, 2, 3, 0.04);
  --shadow-md: 0 6px 22px rgba(10, 2, 3, 0.06), 0 2px 6px rgba(10, 2, 3, 0.04);
  --shadow-lg: 0 20px 60px rgba(10, 2, 3, 0.12), 0 4px 16px rgba(10, 2, 3, 0.06);
  --shadow-xl: 0 28px 80px rgba(10, 2, 3, 0.16), 0 8px 24px rgba(10, 2, 3, 0.08);

  /* ── Radii, matching the portal: 10px fields, 14–18px cards, pill buttons. ── */
  --radius-sm: 8px;
  --radius: 10px;
  --radius-md: 14px;
  --radius-lg: 18px;
  --radius-xl: 24px;
  --radius-full: 100px;

  /* ── Spacing ── */
  --spacing-xs: 4px;
  --spacing-sm: 8px;
  --spacing-md: 16px;
  --spacing-lg: 24px;
  --spacing-xl: 32px;
  --spacing-2xl: 48px;
  --spacing-3xl: 64px;

  /* ── Type ── */
  --font-sans: 'Montserrat', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  --font-mono: 'JetBrains Mono', 'Fira Code', ui-monospace, SFMono-Regular, Menlo, monospace;

  --text-xs: 0.72rem;
  --text-sm: 0.82rem;
  --text-base: 0.92rem;
  --text-md: 1rem;
  --text-lg: 1.12rem;
  --text-xl: 1.35rem;
  --text-2xl: 1.7rem;
  --text-3xl: 2.2rem;
  --text-4xl: 2.9rem;

  --leading-tight: 1.25;
  --leading-snug: 1.4;
  --leading-normal: 1.6;

  /* Montserrat is geometric and runs wide — large sizes need negative tracking
     or headings sprawl, and uppercase eyebrows need a lot of positive tracking,
     which is exactly how the portal sets them (0.22em). */
  --tracking-tight: -0.02em;
  --tracking-snug: -0.01em;
  --tracking-normal: 0;
  --tracking-eyebrow: 0.22em;

  --ease: cubic-bezier(0.2, 0.7, 0.2, 1);
  --transition: 180ms cubic-bezier(0.2, 0.7, 0.2, 1);
  --transition-slow: 320ms cubic-bezier(0.2, 0.7, 0.2, 1);
}

/* ══ Dark theme ══
   Only the tokens change; nothing below this block knows which theme is active.
   The neutrals stay warm rather than going blue-black, so the brand still reads
   as the same product. Surfaces lift as they come closer to the user — the
   inverse of light mode. Borders lighten rather than darken, because a darker
   line is invisible on a dark ground. The greens and blue are raised: #3EA151
   and #3A57A7 are both too dark to carry text on a near-black background. */
[data-theme='dark'] {
  color-scheme: dark;

  --color-primary: #7FC456;
  --color-primary-dark: #98CA3C;
  --color-primary-light: #B4DC72;
  --color-primary-bg: #1B2A14;
  --color-primary-contrast: #0A0203;
  --color-secondary: #F4F4F0;
  --color-accent: #5FB3B2;
  --color-link: #8FA5E0;

  --color-success: #7FC456;
  --color-success-bg: #16240F;
  --color-success-text: #A8DA80;
  --color-warning: #E0A33A;
  --color-warning-bg: #2A1E07;
  --color-warning-text: #F0C476;
  --color-error: #E8705F;
  --color-error-bg: #2C120F;
  --color-error-text: #F2A093;
  --color-danger: #E8705F;
  --color-info: #8FA5E0;
  --color-info-bg: #151B2E;
  --color-info-text: #B3C2EC;

  --color-violet: #B49BF5;
  --color-violet-bg: #241A3D;
  --color-pink: #F08BB6;
  --color-pink-bg: #351324;

  --color-text: #F4F4F0;
  --color-text-secondary: #A5A89F;
  --color-text-light: #7E817A;
  --color-text-inverse: #0A0203;

  --color-bg: #0E0E0C;
  --color-surface: #171714;
  --color-surface-raised: #20201C;
  --color-surface-sunken: #121210;
  --color-surface-hover: #292923;
  --color-overlay: rgba(0, 0, 0, 0.72);
  --color-white: #171714;

  --color-border: #2B2B26;
  --color-border-light: #20201C;
  --color-border-strong: #403F38;
  --color-focus-ring: rgba(127, 196, 86, 0.4);

  /* On a dark ground depth comes from the surface ramp above, not from shadow;
     these are deepened so they still register at all. */
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.5);
  --shadow: 0 2px 6px rgba(0, 0, 0, 0.55), 0 1px 3px rgba(0, 0, 0, 0.4);
  --shadow-md: 0 6px 22px rgba(0, 0, 0, 0.6), 0 2px 6px rgba(0, 0, 0, 0.45);
  --shadow-lg: 0 20px 60px rgba(0, 0, 0, 0.65), 0 4px 16px rgba(0, 0, 0, 0.5);
  --shadow-xl: 0 28px 80px rgba(0, 0, 0, 0.72), 0 8px 24px rgba(0, 0, 0, 0.55);
}

/* --- Reset & Base --- */
*, *::before, *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scroll-behavior: smooth;
}

body {
  font-family: var(--font-sans);
  color: var(--color-text);
  background-color: var(--color-bg);
  font-size: var(--text-base);
  line-height: var(--leading-normal);
  letter-spacing: var(--tracking-snug);
  min-height: 100vh;
  /* The theme swap should not strobe. Colours cross-fade; nothing else. */
  transition: background-color var(--transition-slow), color var(--transition-slow);
}

/* Inter ships tabular figures — use them wherever numbers are compared in a
   column (scores, tables), so digits line up instead of jittering. */
table, .score-meter-value, .stat-value, .metric-value {
  font-variant-numeric: tabular-nums;
}

a {
  color: var(--color-primary);
  text-decoration: none;
  transition: color var(--transition);
}

a:hover {
  color: var(--color-primary-dark);
}

h1, h2, h3, h4, h5, h6 {
  font-weight: 600;
  line-height: var(--leading-tight);
  color: var(--color-text);
  text-wrap: balance;
}

/* Tracking tightens as size grows — Inter set large at default tracking reads
   loose and webby. Weight drops from 700 to 600 at display sizes for the same
   reason: at 2.25rem, 700 is heavier than it needs to be to read as a heading. */
h1 { font-size: var(--text-3xl); letter-spacing: var(--tracking-tight); }
h2 { font-size: var(--text-2xl); letter-spacing: var(--tracking-tight); }
h3 { font-size: var(--text-xl); letter-spacing: var(--tracking-snug); }
h4 { font-size: var(--text-lg); letter-spacing: var(--tracking-snug); font-weight: 600; }
h5 { font-size: var(--text-md); letter-spacing: var(--tracking-snug); font-weight: 600; }
h6 { font-size: var(--text-base); letter-spacing: var(--tracking-normal); font-weight: 600; }

/* Long-form paragraphs get a measure cap; without one, text on a wide monitor
   runs to 200 characters a line and becomes hard to track. */
p { text-wrap: pretty; }

::selection {
  background: var(--color-primary);
  color: var(--color-primary-contrast);
}

/* One visible focus style everywhere, rather than the browser default that some
   resets had already suppressed. */
:where(a, button, input, select, textarea, [tabindex]):focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
  border-radius: var(--radius-sm);
}

@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}

img { max-width: 100%; height: auto; }

/* --- Layout --- */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-lg);
}

.container-sm {
  max-width: 640px;
  margin: 0 auto;
  padding: 0 var(--spacing-lg);
}

.page {
  /* Was \`100vh - 64px\` for the old top navbar. The sidebar is beside the page,
     not above it, so the page owns the full height. */
  min-height: 100vh;
  padding: var(--spacing-xl) 0;
}

@media (max-width: 900px) {
  .page {
    min-height: calc(100vh - var(--appbar-h));
    padding: var(--spacing-lg) 0;
  }
}

.page-header {
  margin-bottom: var(--spacing-lg);
}

/* Visually hidden, still read aloud and still in the document outline. Used for
   page titles that the app bar already displays — the heading must exist, it
   just must not be printed twice. */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.page-header h1 {
  margin-bottom: var(--spacing-sm);
}

.page-header p {
  color: var(--color-text-secondary);
  font-size: 1.05rem;
}

.content {
  flex: 1 1;
  padding: var(--spacing-xl);
}

.flex { display: flex; }
.flex-col { flex-direction: column; }
.items-center { align-items: center; }
.justify-between { justify-content: space-between; }
.gap-sm { gap: var(--spacing-sm); }
.gap-md { gap: var(--spacing-md); }
.gap-lg { gap: var(--spacing-lg); }
.text-center { text-align: center; }

/* --- Navbar --- */
/* ============================================
   App shell — fixed left sidebar, main column beside it
   ============================================ */
:root {
  --sidebar-w: 264px;
  --sidebar-w-collapsed: 76px;
  --appbar-h: 60px;
}

.app-shell {
  min-height: 100vh;
}

.app-main {
  margin-left: var(--sidebar-w);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  /* The page used to sit flush against the rail with no breathing room, which
     read as one undivided slab. The main column now floats on the page ground
     with a gutter on every side. */
  padding: var(--spacing-md) var(--spacing-lg) var(--spacing-lg);
  transition: margin-left var(--transition-slow);
}

.app-shell.sidebar-collapsed .app-main {
  margin-left: var(--sidebar-w-collapsed);
}

.app-content {
  flex: 1 1;
}

/* --- App bar: breadcrumbs + sidebar control --- */
.appbar {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  height: var(--appbar-h);
  flex: none;
  /* Sticky, and pulled out to the full width of the column so its background
     covers content scrolling underneath rather than leaving a transparent
     strip at the sides. */
  position: sticky;
  top: 0;
  z-index: 90;
  margin: calc(var(--spacing-md) * -1) calc(var(--spacing-lg) * -1) var(--spacing-md);
  padding: 0 var(--spacing-lg);
  background: var(--color-bg);
  border-bottom: 1px solid var(--color-border);
}

.appbar-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex: none;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  background: var(--color-surface);
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: background var(--transition), color var(--transition), border-color var(--transition);
}

.appbar-icon-btn:hover {
  background: var(--color-surface-hover);
  color: var(--color-text);
  border-color: var(--color-border-strong);
}

.appbar-logout:hover {
  background: var(--color-error-bg);
  border-color: var(--color-error);
  color: var(--color-error);
}

/* One slot, two controls: collapse on desktop, drawer on mobile. */
.appbar-drawer { display: none; }

.appbar-actions {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  margin-left: auto;
}

.appbar-user {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: var(--radius-full);
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  color: var(--color-text-secondary);
  font-size: var(--text-sm);
  font-weight: 500;
  max-width: 200px;
}

.appbar-username {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* --- Settings layout ---
   Eleven tabs in a horizontal strip wrapped onto two rows and read as a wall.
   A vertical rail holds them all in one column, grouped, with room for a label
   that is not abbreviated. */
.settings-layout {
  display: grid;
  grid-template-columns: 232px minmax(0, 1fr);
  gap: var(--spacing-lg);
  align-items: start;
}

.settings-nav {
  position: sticky;
  top: calc(var(--appbar-h) + var(--spacing-md));
  display: flex;
  flex-direction: column;
  gap: 2px;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: var(--spacing-sm);
  max-height: calc(100vh - var(--appbar-h) - var(--spacing-2xl));
  overflow-y: auto;
}

.settings-group-label {
  font-size: var(--text-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.09em;
  color: var(--color-text-light);
  padding: var(--spacing-md) var(--spacing-md) 6px;
}

.settings-group-label:first-child { padding-top: var(--spacing-sm); }

.settings-tab {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px var(--spacing-md);
  border: none;
  border-radius: var(--radius-sm);
  background: none;
  font-family: inherit;
  font-size: var(--text-base);
  font-weight: 500;
  color: var(--color-text-secondary);
  text-align: left;
  cursor: pointer;
  transition: background var(--transition), color var(--transition);
}

.settings-tab svg { flex: none; }

.settings-tab:hover {
  background: var(--color-surface-hover);
  color: var(--color-text);
}

.settings-tab.active {
  background: var(--color-primary-bg);
  color: var(--color-primary-dark);
  font-weight: 600;
}

@media (max-width: 900px) {
  .settings-layout {
    grid-template-columns: minmax(0, 1fr);
  }

  /* Stacked, the rail becomes a scrolling strip rather than a tall list that
     pushes the content it controls off the screen. */
  .settings-nav {
    position: static;
    flex-direction: row;
    overflow-x: auto;
    max-height: none;
    gap: var(--spacing-xs);
  }

  .settings-group-label { display: none; }

  .settings-tab { white-space: nowrap; width: auto; }
}

/* --- Breadcrumbs --- */
.breadcrumbs {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  overflow: hidden;
  font-size: var(--text-md);
}

.breadcrumb-home {
  display: inline-flex;
  align-items: center;
  color: var(--color-text-light);
  flex: none;
  transition: color var(--transition);
}

.breadcrumb-home:hover { color: var(--color-primary-dark); }

.breadcrumb-sep {
  color: var(--color-text-light);
  flex: none;
}

.breadcrumb-link {
  color: var(--color-text-secondary);
  white-space: nowrap;
  transition: color var(--transition);
}

.breadcrumb-link:hover { color: var(--color-primary-dark); }

.breadcrumb-current {
  color: var(--color-text);
  font-weight: 600;
  font-size: var(--text-lg);
  letter-spacing: var(--tracking-snug);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* --- Sidebar --- */
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: var(--sidebar-w);
  display: flex;
  flex-direction: column;
  background: var(--color-surface);
  border-right: 1px solid var(--color-border);
  z-index: 120;
  transition: width var(--transition-slow), transform var(--transition-slow);
}

.sidebar.is-collapsed {
  width: var(--sidebar-w-collapsed);
}

/* The label is what collapses; the icon column stays put, so nothing shifts
   sideways when the rail narrows. */
.sidebar.is-collapsed .sidebar-label {
  opacity: 0;
  width: 0;
  overflow: hidden;
  pointer-events: none;
}

.sidebar-label {
  white-space: nowrap;
  opacity: 1;
  transition: opacity var(--transition);
}

.sidebar-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-sm);
  height: var(--appbar-h);
  padding: 0 var(--spacing-md);
  border-bottom: 1px solid var(--color-border-light);
  flex: none;
}

.sidebar-brand {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  font-weight: 700;
  font-size: var(--text-base);
  letter-spacing: var(--tracking-snug);
  color: var(--color-text);
  /* min-width:0 lets a flex child actually shrink; without it the label was
     clipped mid-letter by the close button instead of ellipsing. */
  min-width: 0;
  overflow: hidden;
}

.sidebar-brand .sidebar-label {
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-brand svg {
  width: 22px;
  height: 22px;
  color: var(--color-primary);
  flex: none;
}

.sidebar-close {
  display: none;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: none;
  border-radius: var(--radius-sm);
  color: var(--color-text-secondary);
  cursor: pointer;
}

/* Section heading inside the rail. Grouping the modules is also what stopped
   the sidebar reading as a short list floating in a tall empty column. */
.sidebar-group-label {
  font-size: var(--text-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.09em;
  color: var(--color-text-light);
  padding: var(--spacing-md) var(--spacing-md) 4px;
  white-space: nowrap;
}

/* Collapsed, the labels are gone, so a heading would be an unexplained gap —
   a hairline rule separates the groups instead. */
.sidebar.is-collapsed .sidebar-group-label {
  padding: var(--spacing-sm) var(--spacing-sm) 0;
  margin: var(--spacing-xs) var(--spacing-sm) 0;
  border-top: 1px solid var(--color-border-light);
}

.sidebar-soon {
  /* Deliberately NOT \`margin-left: auto\`: that claims all the free space in the
     row, which forces the label to shrink and truncates it even when there is
     plenty of room. Sitting directly after the label keeps both intact. */
  font-size: 0.58rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 2px 5px;
  border-radius: var(--radius-full);
  background: var(--color-surface-raised);
  color: var(--color-text-light);
  flex: none;
}

.sidebar-link.active .sidebar-soon {
  background: var(--color-surface);
  color: var(--color-primary-dark);
}

.sidebar-foot {
  flex: none;
  padding: var(--spacing-sm);
  border-top: 1px solid var(--color-border-light);
}

.sidebar-help {
  color: var(--color-text-light);
}

.sidebar-nav {
  flex: 1 1;
  overflow-y: auto;
  padding: var(--spacing-md) var(--spacing-sm);
  display: flex;
  flex-direction: column;
  /* Explicit: without it the links sized to their content (199px in a 248px
     rail), which left the label competing with the "soon" badge for space and
     truncating it even though the rail had room to spare. */
  align-items: stretch;
  gap: 2px;
}

.sidebar-link {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  padding: 10px var(--spacing-md);
  border-radius: var(--radius);
  color: var(--color-text-secondary);
  font-weight: 500;
  font-size: var(--text-base);
  white-space: nowrap;
  /* Without min-width:0 the label refuses to shrink and shoves the "soon"
     badge off the edge of the rail — which clipped it on one item and lost it
     entirely on the longest label. */
  min-width: 0;
  /* Explicit rather than relying on align-items: the row was sizing to its
     content (199px inside a 248px track), which starved the label. */
  width: 100%;
  transition: background var(--transition), color var(--transition);
}

/* Takes the row's spare width so the badge sits at the end, and only ellipses
   if the label genuinely cannot fit. \`:not(.sidebar-soon)\` matters: the badge
   also carries .sidebar-label (so it collapses with the rail), and without the
   exclusion this rule made the badge stretch too. */
.sidebar-link > .sidebar-label:not(.sidebar-soon) {
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.sidebar-link svg { flex: none; }

.sidebar-link:hover {
  background: var(--color-surface-hover);
  color: var(--color-text);
}

/* The active item gets a tinted pill plus a left marker — colour alone is not
   enough to read at a glance in a list of six. */
.sidebar-link.active {
  background: var(--color-primary-bg);
  /* --color-primary is only 2.9:1 on its own tint; the dark step clears 4.5. */
  color: var(--color-primary-dark);
  font-weight: 600;
  position: relative;
}

.sidebar-link.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 20px;
  border-radius: 0 3px 3px 0;
  background: var(--color-primary-dark);
}










/* When collapsed, everything centres on the icon column. */
.sidebar.is-collapsed .sidebar-head,
.sidebar.is-collapsed .sidebar-link {
  justify-content: center;
  padding-left: var(--spacing-sm);
  padding-right: var(--spacing-sm);
  gap: 0;
}


/* Scrim behind the mobile drawer. */
.sidebar-scrim {
  position: fixed;
  inset: 0;
  background: var(--color-overlay);
  z-index: 115;
}

/* --- Theme toggle --- */
.theme-toggle {
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  line-height: 0;
  border-radius: var(--radius-full);
  flex: none;
}

.theme-toggle-track {
  display: flex;
  align-items: center;
  width: 46px;
  height: 26px;
  padding: 3px;
  border-radius: var(--radius-full);
  background: var(--color-surface-raised);
  border: 1px solid var(--color-border);
  transition: background var(--transition), border-color var(--transition);
}

.theme-toggle:hover .theme-toggle-track {
  border-color: var(--color-border-strong);
}

.theme-toggle-thumb {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: var(--radius-full);
  background: var(--color-surface);
  color: var(--color-warning);
  box-shadow: var(--shadow-sm);
  transform: translateX(0);
  transition: transform var(--transition-slow), color var(--transition), background var(--transition);
}

[data-theme='dark'] .theme-toggle-thumb {
  transform: translateX(20px);
  color: var(--color-primary);
  background: var(--color-surface-raised);
}

/* Floating toggle for the screens with no shell — login, register, landing and
   every public token page. */
.theme-toggle-floating {
  position: fixed;
  top: var(--spacing-md);
  right: var(--spacing-md);
  z-index: 200;
}

/* Below 900px the sidebar becomes an off-canvas drawer and the top bar appears. */
@media (max-width: 900px) {
  .app-main,
  .app-shell.sidebar-collapsed .app-main {
    margin-left: 0;
  }

  .appbar-collapse { display: none; }
  .appbar-drawer { display: inline-flex; }

  .app-main {
    padding: var(--spacing-sm) var(--spacing-md) var(--spacing-md);
  }

  /* The name is the first thing to drop when the bar gets tight. */
  .appbar-username { display: none; }

  .sidebar {
    width: var(--sidebar-w);
    transform: translateX(-100%);
    box-shadow: var(--shadow-lg);
  }

  .sidebar.is-open { transform: translateX(0); }

  /* Collapsed is a desktop affordance; in the drawer it would hide the labels
     with no way to bring them back. */
  .sidebar.is-collapsed { width: var(--sidebar-w); }
  .sidebar.is-collapsed .sidebar-label { opacity: 1; width: auto; }
  .sidebar.is-collapsed .sidebar-head,
  .sidebar.is-collapsed .sidebar-link {
    justify-content: flex-start;
    padding-left: var(--spacing-md);
    padding-right: var(--spacing-md);
    gap: var(--spacing-md);
  }

  .sidebar-close { display: inline-flex; }
}

/* --- Buttons --- */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm);
  padding: 10px 22px;
  font-size: var(--text-base);
  font-weight: 600;
  letter-spacing: var(--tracking-snug);
  font-family: var(--font-sans);
  border: 1px solid transparent;
  /* Pill buttons, as on the Vista portal. */
  border-radius: var(--radius-full);
  cursor: pointer;
  transition: all var(--transition);
  text-decoration: none;
  line-height: 1.4;
  white-space: nowrap;
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn svg {
  width: 18px;
  height: 18px;
}

/* Ink, going green on hover — the portal's primary button, not a green fill.
   --color-primary stays the live accent for nav, icons and focus. */
.btn-primary {
  background: var(--color-secondary);
  color: var(--color-text-inverse);
  border-color: var(--color-secondary);
}

.btn-primary:hover:not(:disabled) {
  background: var(--color-primary);
  border-color: var(--color-primary);
  color: #FFFFFF;
  box-shadow: var(--shadow-md);
  transform: translateY(-1px);
}

.btn-secondary {
  background: var(--color-bg);
  color: var(--color-text);
  border-color: var(--color-border);
}

.btn-secondary:hover:not(:disabled) {
  background: var(--color-white);
  border-color: var(--color-primary-light);
  color: var(--color-primary);
}

.btn-danger {
  background: var(--color-error);
  color: var(--color-white);
  border-color: var(--color-error);
}

.btn-danger:hover:not(:disabled) {
  background: var(--color-error);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
}

.btn-outline {
  background: transparent;
  color: var(--color-primary);
  border-color: var(--color-primary);
}

.btn-outline:hover:not(:disabled) {
  background: var(--color-primary);
  color: var(--color-white);
}

.btn-ghost {
  background: transparent;
  color: var(--color-text-secondary);
  border-color: transparent;
}

.btn-ghost:hover:not(:disabled) {
  background: var(--color-bg);
  color: var(--color-text);
}

.btn-sm {
  padding: 6px 14px;
  font-size: 0.85rem;
}

.btn-lg {
  padding: 14px 28px;
  font-size: 1.1rem;
}

.btn-block {
  width: 100%;
}

/* --- Cards --- */
.card {
  background: var(--color-white);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  transition: box-shadow var(--transition);
}

.card:hover {
  box-shadow: var(--shadow-md);
}

.card-header {
  padding: var(--spacing-md) var(--spacing-lg);
  border-bottom: 1px solid var(--color-border-light);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card-header h3,
.card-header h4 {
  margin: 0;
}

.card-body {
  padding: var(--spacing-lg);
}

/* Sub-heading that groups a band of tiles or panels on a dashboard. */
.section-heading {
  font-size: var(--text-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.09em;
  color: var(--color-text-light);
  margin: var(--spacing-lg) 0 var(--spacing-sm);
}

.section-heading:first-of-type { margin-top: 0; }

/* --- Stat tiles ---
   One tile style for every module dashboard. The value leads, the label sits
   under it, and the icon is a tinted chip in the corner — so a row of tiles
   scans as a row of NUMBERS rather than a row of icons. Grid stretch keeps them
   equal height even when one label wraps to two lines. */
.stat-grid {
  display: grid;
  /* auto-FILL, not auto-fit: with a single permitted module, auto-fit collapsed
     the empty tracks and stretched that one tile across the whole row. */
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: var(--spacing-md);
  margin-bottom: var(--spacing-lg);
  align-items: stretch;
}

.stat-card {
  position: relative;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: var(--spacing-md) var(--spacing-lg) var(--spacing-lg);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  min-height: 118px;
  text-decoration: none;
  color: inherit;
  transition: border-color var(--transition), box-shadow var(--transition), transform var(--transition);
}

/* Only tiles that go somewhere react to the pointer. A hover lift on a static
   number promises a click that never happens. */
a.stat-card:hover {
  border-color: var(--color-border-strong);
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
}

.stat-card .stat-icon {
  position: absolute;
  top: var(--spacing-md);
  right: var(--spacing-md);
  width: 34px;
  height: 34px;
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-surface-raised);
  color: var(--color-text-secondary);
}

.stat-card .stat-icon svg { width: 17px; height: 17px; }

.stat-card .stat-value {
  font-size: var(--text-3xl);
  font-weight: 700;
  letter-spacing: var(--tracking-tight);
  color: var(--color-text);
  line-height: 1.1;
}

.stat-card .stat-label {
  font-size: var(--text-xs);
  color: var(--color-text-secondary);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  /* Reserve the icon's column so a long label never runs under it. */
  padding-right: 42px;
  order: -1;
  /* Two lines' worth, always. Without it a label that wraps pushes its number
     down and the row of figures stops lining up — which is the one thing a row
     of KPI tiles exists to do. */
  min-height: 2.4em;
  line-height: 1.2;
  margin-bottom: var(--spacing-sm);
}

.stat-card .stat-sub {
  font-size: var(--text-xs);
  color: var(--color-text-light);
  margin-top: 2px;
}

.stat-card .stat-sub.is-live {
  color: var(--color-success);
  font-weight: 600;
}

.stat-card .stat-icon.primary { background: var(--color-primary-bg); color: var(--color-primary-dark); }
.stat-card .stat-icon.success { background: var(--color-success-bg); color: var(--color-success-text); }
.stat-card .stat-icon.warning { background: var(--color-warning-bg); color: var(--color-warning-text); }
.stat-card .stat-icon.info { background: var(--color-info-bg); color: var(--color-info-text); }
.stat-card .stat-icon.violet { background: var(--color-violet-bg); color: var(--color-violet); }
.stat-card .stat-icon.pink { background: var(--color-pink-bg); color: var(--color-pink); }

/* --- Forms --- */
.form-group {
  margin-bottom: var(--spacing-md);
}

.form-group label {
  display: block;
  font-size: var(--text-sm);
  font-weight: 600;
  color: var(--color-text);
  margin-bottom: 5px;
}

.form-group .form-hint {
  font-size: var(--text-xs);
  color: var(--color-text-light);
  margin-top: 4px;
}

.form-control,
input[type="text"],
input[type="email"],
input[type="password"],
input[type="number"],
input[type="url"],
select,
textarea {
  width: 100%;
  padding: 9px 13px;
  font-size: var(--text-base);
  font-family: var(--font-sans);
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  /* background-COLOR, never the \`background\` shorthand: the shorthand resets
     background-image/-repeat/-position, and this rule outranks the \`select\`
     rule that draws the dropdown chevron. Using the shorthand here wiped the
     chevron in light mode and left it tiling across the field in dark. */
  background-color: var(--color-surface);
  color: var(--color-text);
  transition: border-color var(--transition), box-shadow var(--transition), background-color var(--transition);
  outline: none;
}

.form-control::placeholder,
input::placeholder,
textarea::placeholder {
  color: var(--color-text-light);
}

.form-control:focus,
input:focus,
select:focus,
textarea:focus {
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px var(--color-focus-ring);
}

.form-control:disabled,
input:disabled,
select:disabled,
textarea:disabled {
  background-color: var(--color-surface-raised);
  color: var(--color-text-light);
  cursor: not-allowed;
}

/* Chrome paints autofilled fields with its own near-white background and black
   text, which is unreadable in dark mode. The inset shadow is the only way to
   override that background; -webkit-text-fill-color the only way to reach the
   text. The long delay keeps it from reverting on repaint. */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
select:-webkit-autofill {
  -webkit-text-fill-color: var(--color-text);
  box-shadow: 0 0 0 1000px var(--color-surface) inset;
  caret-color: var(--color-text);
  -webkit-transition: background-color 100000s ease-in-out 0s;
  transition: background-color 100000s ease-in-out 0s;
}

textarea {
  resize: vertical;
  min-height: 76px;
}

select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 18px 18px;
  padding-right: 36px;
}

/* A slate chevron disappears on a dark field — repaint it in the light ink. */
[data-theme='dark'] select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  font-size: 0.95rem;
  cursor: pointer;
  padding: var(--spacing-sm);
  border-radius: var(--radius-sm);
  transition: background var(--transition);
}

.checkbox-label:hover {
  background: var(--color-bg);
}

.checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: var(--color-primary);
  cursor: pointer;
}

.radio-group {
  display: flex;
  gap: var(--spacing-md);
  flex-wrap: wrap;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  font-size: 0.95rem;
  cursor: pointer;
  padding: var(--spacing-sm) var(--spacing-md);
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  transition: all var(--transition);
}

.radio-label:hover {
  border-color: var(--color-primary-light);
}

.radio-label.selected {
  border-color: var(--color-primary);
  background: var(--color-primary-bg);
  color: var(--color-primary);
}

.radio-label input[type="radio"] {
  width: 16px;
  height: 16px;
  accent-color: var(--color-primary);
  cursor: pointer;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-lg);
}

/* --- Tables --- */
.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;
}

.table th {
  text-align: left;
  padding: 12px 16px;
  font-weight: 600;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-text-secondary);
  background: var(--color-bg);
  border-bottom: 2px solid var(--color-border);
}

.table td {
  padding: 12px 16px;
  border-bottom: 1px solid var(--color-border-light);
  vertical-align: middle;
}

.table-striped tbody tr:nth-child(even) {
  background: var(--color-bg);
}

.table tbody tr {
  transition: background var(--transition);
}

.table tbody tr:hover {
  background: var(--color-primary-bg);
}

/* --- Badges --- */
.badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  font-size: 0.78rem;
  font-weight: 600;
  border-radius: 999px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
}

.badge-global {
  background: var(--brand-blue);
  color: #FFFFFF;
}

.badge-strategic {
  background: var(--color-info);
  color: var(--color-text-inverse);
}

.badge-national {
  background: var(--brand-teal);
  color: #FFFFFF;
}

.badge-emerging {
  background: var(--brand-green-4);
  color: #FFFFFF;
}

.badge-local {
  background: var(--color-warning);
  color: var(--color-text-inverse);
}

.badge-non-kol {
  background: var(--color-bg);
  color: var(--color-text-secondary);
  border: 1px solid var(--color-border);
}

/* --- Alerts --- */
.alert {
  padding: var(--spacing-md) var(--spacing-lg);
  border-radius: var(--radius);
  font-size: 0.95rem;
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-sm);
  margin-bottom: var(--spacing-lg);
}

.alert svg {
  flex-shrink: 0;
  margin-top: 2px;
}

.alert-success {
  background: var(--color-success-bg);
  color: var(--color-success-text);
  border: 1px solid var(--color-success-bg);
}

.alert-error {
  background: var(--color-error-bg);
  color: var(--color-error-text);
  border: 1px solid var(--color-error-bg);
}

.alert-warning {
  background: var(--color-warning-bg);
  color: var(--color-warning-text);
  border: 1px solid var(--color-warning-bg);
}

.alert-info {
  background: var(--color-info-bg);
  color: var(--color-info-text);
  border: 1px solid var(--color-info-bg);
}

/* --- Modals --- */
.modal-overlay {
  position: fixed;
  inset: 0;
  /* Ink-tinted rather than slate, to match the rest of the palette, and heavier
     so the dialog reads as the only live thing on screen. */
  background: var(--color-overlay);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-lg);
  z-index: 1000;
  animation: fadeIn 0.2s var(--ease);
}

.modal {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xl);
  width: 100%;
  max-width: 520px;
  /* The dialog itself no longer scrolls — the BODY does, so the header and the
     footer buttons stay put instead of scrolling out of reach on a long form. */
  max-height: min(88vh, 760px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: slideUp 0.25s var(--ease);
}

.modal-header {
  padding: var(--spacing-lg) var(--spacing-lg) var(--spacing-md);
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--spacing-md);
  flex: none;
}

.modal-header h2,
.modal-header h3,
.modal-header h4 {
  font-size: var(--text-lg);
  letter-spacing: var(--tracking-snug);
  margin: 0;
}

/* The close control is usually a bare <button> in the header. */
.modal-header > button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex: none;
  border: none;
  border-radius: var(--radius-sm);
  background: none;
  color: var(--color-text-light);
  cursor: pointer;
  transition: background var(--transition), color var(--transition);
}

.modal-header > button:hover {
  background: var(--color-surface-hover);
  color: var(--color-text);
}

.modal-body {
  padding: 0 var(--spacing-lg) var(--spacing-lg);
  overflow-y: auto;
  flex: 1 1;
}

.modal-footer {
  padding: var(--spacing-md) var(--spacing-lg);
  border-top: 1px solid var(--color-border-light);
  background: var(--color-surface-raised);
  display: flex;
  justify-content: flex-end;
  gap: var(--spacing-sm);
  flex: none;
}

/* A dialog pinned to the middle of a phone screen leaves dead space above and
   below and puts the actions mid-air. Below 600px it becomes a sheet. */
@media (max-width: 600px) {
  .modal-overlay {
    align-items: flex-end;
    padding: 0;
  }

  .modal {
    max-width: none;
    max-height: 92vh;
    border-radius: var(--radius-lg) var(--radius-lg) 0 0;
    border-bottom: none;
    animation: sheetUp 0.28s var(--ease);
  }

  .modal-footer > .btn {
    flex: 1 1;
  }
}

@keyframes sheetUp {
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
}

/* --- Dashboard Grid --- */
.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: var(--spacing-lg);
}

.stats-row {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: var(--spacing-md);
  margin-bottom: var(--spacing-lg);
  align-items: stretch;
}

/* --- Score Meter --- */
.score-meter {
  position: relative;
  width: 160px;
  height: 160px;
  margin: 0 auto var(--spacing-lg);
}

.score-meter-circle {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: 8px solid var(--color-border-light);
  position: relative;
}

.score-meter-value {
  font-size: 2.5rem;
  font-weight: 800;
  color: var(--color-primary);
  line-height: 1;
}

.score-meter-label {
  font-size: 0.8rem;
  color: var(--color-text-secondary);
  margin-top: 4px;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: var(--color-border-light);
  border-radius: 999px;
  overflow: hidden;
}

.progress-bar-fill {
  height: 100%;
  border-radius: 999px;
  background: var(--color-primary);
  transition: width 0.6s ease;
}

/* --- Spinner --- */
.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid var(--color-border);
  border-top-color: var(--color-primary);
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  margin: var(--spacing-xl) auto;
}

.spinner-sm {
  width: 18px;
  height: 18px;
  border-width: 2px;
  margin: 0;
  display: inline-block;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-3xl);
  color: var(--color-text-secondary);
}

/* --- Landing Page --- */
.landing-page {
  background: var(--color-white);
  min-height: 100vh;
}

.landing-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-lg) var(--spacing-xl);
  max-width: 1200px;
  margin: 0 auto;
}

.landing-nav-brand {
  font-weight: 700;
  font-size: 1.25rem;
  color: var(--color-primary);
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.hero {
  background: var(--color-secondary);
  color: var(--color-text-inverse);
  padding: 100px var(--spacing-xl) 120px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.hero::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: none;
}

.hero-content {
  position: relative;
  z-index: 1;
  max-width: 800px;
  margin: 0 auto;
}

.hero h1 {
  font-size: 3.25rem;
  font-weight: 800;
  color: var(--color-text-inverse);
  margin-bottom: var(--spacing-lg);
  line-height: 1.15;
  letter-spacing: -0.02em;
}

.hero p {
  font-size: 1.25rem;
  opacity: 0.9;
  max-width: 600px;
  margin: 0 auto var(--spacing-xl);
  line-height: 1.7;
}

.hero-buttons {
  display: flex;
  gap: var(--spacing-md);
  justify-content: center;
  flex-wrap: wrap;
}

.hero-buttons .btn-primary {
  background: var(--color-surface);
  color: var(--color-primary);
  border-color: var(--color-surface);
  padding: 14px 32px;
  font-size: 1.05rem;
}

.hero-buttons .btn-primary:hover {
  background: var(--color-primary-bg);
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0,0,0,0.2);
}

.hero-buttons .btn-outline {
  color: var(--color-text-inverse);
  border-color: rgba(255,255,255,0.4);
  padding: 14px 32px;
  font-size: 1.05rem;
}

.hero-buttons .btn-outline:hover {
  background: rgba(255,255,255,0.1);
  border-color: var(--color-surface);
  color: var(--color-text-inverse);
}

.features {
  padding: var(--spacing-3xl) var(--spacing-xl);
  max-width: 1200px;
  margin: 0 auto;
}

.features h2 {
  text-align: center;
  margin-bottom: var(--spacing-xs);
}

.features > p {
  text-align: center;
  color: var(--color-text-secondary);
  margin-bottom: var(--spacing-2xl);
  font-size: 1.1rem;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--spacing-lg);
}

.feature-card {
  padding: var(--spacing-xl);
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border);
  transition: all 0.3s ease;
  text-align: center;
}

.feature-card:hover {
  border-color: var(--color-primary-light);
  box-shadow: var(--shadow-lg);
  transform: translateY(-4px);
}

.feature-card .feature-icon {
  width: 56px;
  height: 56px;
  background: var(--color-primary-bg);
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto var(--spacing-md);
  color: var(--color-primary);
}

.feature-card h3 {
  font-size: 1.15rem;
  margin-bottom: var(--spacing-sm);
}

.feature-card p {
  color: var(--color-text-secondary);
  font-size: 0.95rem;
  line-height: 1.6;
}

.how-it-works {
  background: var(--color-bg);
  padding: var(--spacing-3xl) var(--spacing-xl);
}

.how-it-works-inner {
  max-width: 1200px;
  margin: 0 auto;
}

.how-it-works h2 {
  text-align: center;
  margin-bottom: var(--spacing-2xl);
}

.steps {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--spacing-xl);
}

.step {
  text-align: center;
  padding: var(--spacing-xl);
}

.step-number {
  width: 48px;
  height: 48px;
  background: var(--color-primary);
  color: var(--color-primary-contrast);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.25rem;
  margin: 0 auto var(--spacing-md);
}

.step h3 {
  margin-bottom: var(--spacing-sm);
}

.step p {
  color: var(--color-text-secondary);
}

.tier-section {
  padding: var(--spacing-3xl) var(--spacing-xl);
  max-width: 1200px;
  margin: 0 auto;
}

.tier-section h2 {
  text-align: center;
  margin-bottom: var(--spacing-sm);
}

.tier-section > p {
  text-align: center;
  color: var(--color-text-secondary);
  margin-bottom: var(--spacing-2xl);
  font-size: 1.05rem;
}

.tier-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--spacing-md);
}

.tier-card {
  padding: var(--spacing-lg);
  border-radius: var(--radius-md);
  text-align: center;
  color: var(--color-text-inverse);
  transition: transform 0.3s ease;
}

.tier-card:hover {
  transform: scale(1.03);
}

.tier-card h4 {
  color: var(--color-text-inverse);
  font-size: 1.15rem;
  margin-bottom: var(--spacing-xs);
}

.tier-card .tier-range {
  font-size: 1.5rem;
  font-weight: 800;
  margin-bottom: var(--spacing-xs);
}

.tier-card p {
  opacity: 0.9;
  font-size: 0.9rem;
}

.stats-section {
  background: var(--color-secondary);
  padding: var(--spacing-3xl) var(--spacing-xl);
  color: var(--color-text-inverse);
}

.stats-section-inner {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}

.stats-section h2 {
  color: var(--color-text-inverse);
  margin-bottom: var(--spacing-2xl);
}

.stats-numbers {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--spacing-xl);
}

.stats-numbers .stat-item .stat-num {
  font-size: 2.5rem;
  font-weight: 800;
  margin-bottom: var(--spacing-xs);
}

.stats-numbers .stat-item .stat-desc {
  opacity: 0.8;
  font-size: 0.95rem;
}

/* --- Landing Nav Links --- */
.landing-nav-links {
  display: flex;
  gap: var(--spacing-xl);
}

.landing-nav-links a {
  color: var(--color-text-secondary);
  font-weight: 500;
  font-size: 0.95rem;
  text-decoration: none;
  transition: color var(--transition);
}

.landing-nav-links a:hover {
  color: var(--color-primary);
}

/* --- Pricing Section --- */
.pricing-section {
  padding: var(--spacing-3xl) var(--spacing-xl);
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}

.pricing-section h2 {
  margin-bottom: var(--spacing-xs);
}

.pricing-section > p {
  color: var(--color-text-secondary);
  font-size: 1.1rem;
  margin-bottom: var(--spacing-xl);
}

.pricing-toggle {
  display: inline-flex;
  background: var(--color-bg);
  border-radius: 50px;
  padding: 4px;
  margin-bottom: var(--spacing-2xl);
  border: 1px solid var(--color-border);
}

.pricing-toggle-btn {
  padding: 10px 24px;
  border: none;
  background: none;
  border-radius: 50px;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: all var(--transition);
  display: flex;
  align-items: center;
  gap: 8px;
}

.pricing-toggle-btn.active {
  background: var(--color-primary);
  color: var(--color-primary-contrast);
  box-shadow: var(--shadow-sm);
}

.pricing-save-badge {
  font-size: 0.7rem;
  background: var(--color-success);
  color: var(--color-text-inverse);
  padding: 2px 8px;
  border-radius: 50px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.pricing-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--spacing-xl);
  text-align: left;
}

.pricing-card {
  background: var(--color-white);
  border: 2px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: var(--spacing-xl);
  position: relative;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
}

.pricing-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-lg);
}

.pricing-card.popular {
  border-color: var(--color-primary);
  box-shadow: 0 0 0 1px var(--color-primary), var(--shadow-lg);
  transform: scale(1.03);
}

.pricing-card.popular:hover {
  transform: scale(1.03) translateY(-4px);
}

.pricing-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--color-primary);
  color: var(--color-primary-contrast);
  padding: 4px 16px;
  border-radius: 50px;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

.pricing-card h3 {
  font-size: 1.35rem;
  margin-bottom: 6px;
}

.pricing-desc {
  color: var(--color-text-secondary);
  font-size: 0.9rem;
  margin-bottom: var(--spacing-lg);
}

.pricing-price {
  display: flex;
  align-items: baseline;
  gap: 2px;
  margin-bottom: 4px;
}

.pricing-currency {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--color-text);
}

.pricing-amount {
  font-size: 3rem;
  font-weight: 800;
  color: var(--color-secondary);
  line-height: 1;
}

.pricing-period {
  font-size: 1rem;
  color: var(--color-text-secondary);
  font-weight: 500;
}

.pricing-yearly-note {
  font-size: 0.82rem;
  color: var(--color-text-light);
  margin-bottom: var(--spacing-lg);
}

.pricing-card .btn-block {
  width: 100%;
  text-align: center;
  margin: var(--spacing-lg) 0;
  padding: 12px;
}

.pricing-features {
  list-style: none;
  padding: 0;
  margin: 0;
  flex: 1 1;
}

.pricing-features li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  font-size: 0.92rem;
  color: var(--color-text);
  border-top: 1px solid var(--color-border-light);
}

.pricing-check {
  color: var(--color-success);
  flex-shrink: 0;
}

.cta {
  padding: var(--spacing-3xl) var(--spacing-xl);
  text-align: center;
  background: var(--color-primary-bg);
}

.cta h2 {
  margin-bottom: var(--spacing-md);
}

.cta p {
  color: var(--color-text-secondary);
  margin-bottom: var(--spacing-xl);
  font-size: 1.1rem;
}

.landing-footer {
  background: var(--color-secondary);
  color: var(--color-text-light);
  padding: var(--spacing-xl);
  text-align: center;
  font-size: 0.9rem;
}

/* --- Section titles --- */
.section-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--color-secondary);
  margin-bottom: var(--spacing-md);
  padding-bottom: var(--spacing-sm);
  border-bottom: 2px solid var(--color-primary-bg);
}

/* --- File Upload --- */
.file-upload {
  border: 2px dashed var(--color-border);
  border-radius: var(--radius-md);
  padding: var(--spacing-xl);
  text-align: center;
  cursor: pointer;
  transition: all var(--transition);
  background: var(--color-bg);
}

.file-upload:hover {
  border-color: var(--color-primary-light);
  background: var(--color-primary-bg);
}

.file-upload.active {
  border-color: var(--color-primary);
  background: var(--color-primary-bg);
}

.file-upload svg {
  color: var(--color-text-light);
  margin-bottom: var(--spacing-sm);
}

.file-upload p {
  color: var(--color-text-secondary);
  font-size: 0.95rem;
}

.file-upload .file-name {
  color: var(--color-primary);
  font-weight: 600;
  margin-top: var(--spacing-sm);
}

/* --- Assessment Sections --- */
.assessment-section {
  background: var(--color-white);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  margin-bottom: var(--spacing-lg);
  overflow: hidden;
}

.assessment-section-header {
  background: var(--color-bg);
  padding: var(--spacing-md) var(--spacing-lg);
  font-weight: 700;
  font-size: 1rem;
  color: var(--color-secondary);
  border-bottom: 1px solid var(--color-border);
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.assessment-section-header .criterion-code {
  background: var(--color-primary);
  color: var(--color-primary-contrast);
  padding: 2px 10px;
  border-radius: var(--radius-sm);
  font-size: 0.8rem;
  font-weight: 700;
}

.assessment-section-body {
  padding: var(--spacing-lg);
}

/* --- Results Page --- */
.results-header {
  text-align: center;
  padding: var(--spacing-2xl);
  background: var(--color-primary-bg);
  border-radius: var(--radius-md);
  margin-bottom: var(--spacing-xl);
  border: 1px solid var(--color-border);
}

.results-breakdown {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-lg);
  margin-bottom: var(--spacing-xl);
}

.score-summary {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--spacing-md);
  margin-bottom: var(--spacing-xl);
}

.score-summary-item {
  text-align: center;
  padding: var(--spacing-lg);
  background: var(--color-white);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
}

.score-summary-item .score-label {
  font-size: 0.85rem;
  color: var(--color-text-secondary);
  margin-bottom: var(--spacing-xs);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 600;
}

.score-summary-item .score-number {
  font-size: 1.75rem;
  font-weight: 800;
  color: var(--color-primary);
}

/* --- Collapsible --- */
.collapsible-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: var(--spacing-md) var(--spacing-lg);
  background: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  cursor: pointer;
  font-weight: 600;
  font-size: 0.95rem;
  transition: all var(--transition);
  font-family: var(--font-sans);
  color: var(--color-text);
}

.collapsible-trigger:hover {
  background: var(--color-primary-bg);
}

.collapsible-content {
  padding: var(--spacing-lg);
  border: 1px solid var(--color-border);
  border-top: none;
  border-radius: 0 0 var(--radius) var(--radius);
  background: var(--color-white);
}

/* --- Auth Pages --- */
.auth-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-bg);
  padding: var(--spacing-lg);
}

.auth-card {
  background: var(--color-white);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xl);
  padding: var(--spacing-2xl);
  width: 100%;
  max-width: 440px;
}

.auth-card h2 {
  text-align: center;
  margin-bottom: var(--spacing-xs);
}

.auth-card .auth-subtitle {
  text-align: center;
  color: var(--color-text-secondary);
  margin-bottom: var(--spacing-xl);
}

.auth-card .auth-footer {
  text-align: center;
  margin-top: var(--spacing-lg);
  color: var(--color-text-secondary);
  font-size: 0.9rem;
}

.auth-brand {
  text-align: center;
  margin-bottom: var(--spacing-xl);
  color: var(--color-primary);
  font-size: 1.35rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm);
}

/* --- Confidence Flags --- */
.confidence-flags {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-sm);
}

.confidence-flag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  font-size: 0.8rem;
  background: var(--color-warning-bg);
  color: var(--color-warning-text);
  border-radius: var(--radius-sm);
  font-weight: 500;
}

.confidence-flag.ok {
  background: var(--color-success-bg);
  color: var(--color-success-text);
}

/* --- Animations --- */
@keyframes spin {
  to { transform: rotate(360deg); }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes floatBg {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(-2%, 1%); }
}

/* --- Responsive --- */
@media (max-width: 1024px) {
  .pricing-grid {
    grid-template-columns: 1fr;
    max-width: 450px;
    margin: 0 auto;
  }

  .pricing-card.popular {
    transform: none;
  }

  .landing-nav-links {
    display: none;
  }


  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .tier-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .results-breakdown {
    grid-template-columns: 1fr;
  }

  .stats-numbers {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  h1 { font-size: 1.75rem; }
  h2 { font-size: 1.5rem; }

  .hero h1 { font-size: 2.25rem; }
  .hero { padding: 60px var(--spacing-lg) 80px; }

  .stats-row {
    grid-template-columns: 1fr;
  }

  .features-grid,
  .steps,
  .tier-grid {
    grid-template-columns: 1fr;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .score-summary {
    grid-template-columns: 1fr;
  }

  .navbar {
    padding: 0 var(--spacing-md);
  }

  /* Was \`display: none\` with no replacement, which left the app with no
     navigation at all on a phone. It is now a panel the hamburger opens. */
  .navbar-links {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    flex-direction: column;
    align-items: stretch;
    gap: var(--spacing-xs);
    padding: var(--spacing-sm) var(--spacing-md) var(--spacing-md);
    background: var(--color-surface);
    border-bottom: 1px solid var(--color-border);
    box-shadow: var(--shadow-lg);
    display: none;
  }

  .navbar-links.is-open {
    display: flex;
  }

  .navbar-links a {
    padding: var(--spacing-md);
    font-size: var(--text-md);
  }

  .navbar-toggle {
    display: inline-flex;
  }

  .navbar {
    position: sticky;
  }

  .navbar-inner {
    position: relative;
  }

  /* The username is the first thing to go when the bar gets tight — the avatar
     of information nobody needs at 375px. */
  .navbar-username {
    display: none;
  }

  .container {
    padding: 0 var(--spacing-md);
  }

  .stats-numbers {
    grid-template-columns: 1fr 1fr;
    gap: var(--spacing-lg);
  }

  .hero-buttons {
    flex-direction: column;
    align-items: center;
  }

  .radio-group {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .hero h1 { font-size: 1.75rem; }

  .auth-card {
    padding: var(--spacing-lg);
  }

  .tier-grid {
    grid-template-columns: 1fr;
  }
}

/* ============================================
   Account Page
   ============================================ */




.account-card {
  background: var(--color-white);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  overflow: hidden;
}

.account-card-header {
  padding: var(--spacing-lg);
  border-bottom: 1px solid var(--color-border);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.account-card-header h3 {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.1rem;
}

.account-card-body {
  padding: var(--spacing-lg);
}

.profile-detail {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 0;
  border-bottom: 1px solid var(--color-border-light);
  font-size: 0.95rem;
}

.profile-detail:last-child {
  border-bottom: none;
}

.profile-label {
  color: var(--color-text-secondary);
  min-width: 120px;
  font-weight: 500;
}

.form-row-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-md);
}

/* Current Plan */
.current-plan-info {
  display: flex;
  align-items: baseline;
  gap: var(--spacing-lg);
  margin-bottom: var(--spacing-lg);
  padding-bottom: var(--spacing-lg);
  border-bottom: 1px solid var(--color-border-light);
}

.current-plan-name {
  font-size: 1.75rem;
  color: var(--color-primary);
  margin: 0;
}

.current-plan-price {
  font-size: 1.1rem;
  color: var(--color-text-secondary);
  font-weight: 600;
}

.current-plan-features h4 {
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-text-secondary);
  margin: var(--spacing-lg) 0 var(--spacing-sm);
}

.current-plan-features ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 24px;
}

.current-plan-features li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  padding: 4px 0;
}

/* Badges */
.badge-success {
  background: var(--color-success-bg);
  color: var(--color-success-text);
}

.badge-warning {
  background: var(--color-warning-bg);
  color: var(--color-warning-text);
}

.badge-danger {
  background: var(--color-error-bg);
  color: var(--color-error-text);
}

/* Invoice Table */
.invoice-table {
  width: 100%;
  border-collapse: collapse;
}

.invoice-table th {
  text-align: left;
  padding: 12px 16px;
  font-size: 0.78rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-text-secondary);
  background: var(--color-bg);
  border-bottom: 1px solid var(--color-border);
}

.invoice-table td {
  padding: 12px 16px;
  font-size: 0.9rem;
  border-bottom: 1px solid var(--color-border-light);
}

.invoice-table .font-mono {
  font-family: var(--font-mono);
  font-size: 0.82rem;
}

/* Subscribe Modal */
.subscribe-cycle-toggle {
  display: flex;
  justify-content: center;
  gap: 4px;
  background: var(--color-bg);
  border-radius: 50px;
  padding: 4px;
  margin-bottom: var(--spacing-xl);
  border: 1px solid var(--color-border);
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
}

.subscribe-plans-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: var(--spacing-md);
}

.subscribe-plan-card {
  border: 2px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: var(--spacing-lg);
  cursor: pointer;
  transition: all var(--transition);
  position: relative;
}

.subscribe-plan-card:hover {
  border-color: var(--color-primary-light);
}

.subscribe-plan-card.selected {
  border-color: var(--color-primary);
  background: var(--color-primary-bg);
}

.subscribe-plan-card.popular {
  border-color: var(--color-primary-light);
}

.subscribe-plan-card.current {
  opacity: 0.5;
  cursor: default;
}

.subscribe-plan-card h4 {
  margin: 0 0 8px;
}

.subscribe-price {
  font-size: 1.75rem;
  font-weight: 800;
  color: var(--color-secondary);
  margin-bottom: 12px;
}

.subscribe-price span {
  font-size: 1rem;
}

.subscribe-price small {
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--color-text-secondary);
}

.subscribe-features {
  list-style: none;
  padding: 0;
  margin: 0;
}

.subscribe-features li {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.82rem;
  padding: 3px 0;
  color: var(--color-text-secondary);
}

.subscribe-features li svg {
  color: var(--color-success);
  flex-shrink: 0;
}

.subscribe-features .more {
  color: var(--color-text-light);
  font-style: italic;
}

.subscribe-current-badge,
.subscribe-badge {
  position: absolute;
  top: -10px;
  right: 12px;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 2px 10px;
  border-radius: 50px;
  text-transform: uppercase;
}

.subscribe-current-badge {
  background: var(--color-text-secondary);
  color: var(--color-text-inverse);
}

.subscribe-badge {
  background: var(--color-primary);
  color: var(--color-primary-contrast);
}

.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@media (max-width: 768px) {
  .form-row-2 {
    grid-template-columns: 1fr;
  }
  .current-plan-features ul {
    grid-template-columns: 1fr;
  }
  .subscribe-plans-grid {
    grid-template-columns: 1fr;
  }
  .checkout-layout {
    flex-direction: column !important;
  }
  .checkout-summary {
    order: -1;
  }
  .new-assessment-grid {
    grid-template-columns: 1fr !important;
  }
}

/* ============================================
   Responsive foundation
   ============================================ */

/* Nothing should be able to push the page sideways. Scrolling belongs to the
   element that is too wide (a table, a code block), never to the document.

   \`clip\`, NOT \`hidden\`: overflow:hidden makes the box a scroll container, and a
   \`position: sticky\` child then sticks to THAT box instead of the viewport —
   which silently broke the sticky app bar. overflow:clip clips without creating
   a scrollport, so sticky keeps working. */
.app-main {
  overflow-x: clip;
}

/* Emails, tokens and URLs are unbreakable strings that otherwise widen their
   container until the layout gives. */
.table td,
.card-body p,
.page-header p {
  overflow-wrap: anywhere;
}

@media (max-width: 900px) {
  .container,
  .container-sm {
    padding: 0 var(--spacing-md);
  }
}

@media (max-width: 760px) {
  /* Tables had no overflow handling at all — a wide one simply broke the page.
     display:block turns the table itself into the scroll container, so it stays
     readable by swiping instead of shrinking columns into unreadable slivers. */
  .table {
    display: block;
    max-width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .page-header {
    margin-bottom: var(--spacing-lg);
  }

  /* Page headers are usually title-left / action-right; at this width the action
     belongs under the title, full width, where a thumb can reach it. */
  .page-header[style*="flex"] {
    flex-direction: column;
    align-items: stretch !important;
    gap: var(--spacing-md);
  }

  .btn {
    padding: 10px 18px;
  }
}

@media (max-width: 640px) {
  /* Inline grid templates are written in JS and cannot carry a media query.
     A stylesheet !important is the one declaration that outranks an inline
     style, so this is the only way to reach them. At this width a multi-column
     layout is wrong regardless of what the template says. Opt out with
     \`keep-grid\` on anything that genuinely must stay side by side. */
  [style*="grid-template-columns"]:not(.keep-grid) {
    grid-template-columns: 1fr !important;
  }

  h1 { font-size: var(--text-2xl); }
  h2 { font-size: var(--text-xl); }
  h3 { font-size: var(--text-lg); }

  .card-body,
  .card-header {
    padding: var(--spacing-md);
  }

  /* Full-width actions read better than a row of half-width buttons. */
  .btn-lg {
    width: 100%;
  }
}

/* --- Advisory Boards: meetings feed --- */
.ab-panel {
  padding: var(--spacing-md) var(--spacing-lg) var(--spacing-lg);
  margin-bottom: var(--spacing-md);
}

.ab-panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-sm);
  margin-bottom: 4px;
}

.ab-panel-head > span {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: var(--text-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-text-light);
}

.ab-panel-head svg { color: var(--color-primary); }

.ab-list { display: flex; flex-direction: column; }

.ab-row {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  padding: 10px 0;
  border-bottom: 1px solid var(--color-border-light);
}

.ab-row:last-child { border-bottom: none; }

.ab-row-main { flex: 1 1; min-width: 0; display: flex; flex-direction: column; }

.ab-row-title {
  font-weight: 600;
  font-size: var(--text-base);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ab-row-meta {
  font-size: var(--text-xs);
  color: var(--color-text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* A call happening right now should be the loudest thing on the row. */
.ab-live {
  flex: none;
  font-size: var(--text-xs);
  font-weight: 700;
  color: var(--color-success);
  white-space: nowrap;
}

/* --- Assessments: insights band --- */
.insights-toggle {
  border: none;
  background: none;
  padding: 0 0 var(--spacing-sm);
  font-family: inherit;
  font-size: var(--text-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-text-light);
  cursor: pointer;
}

.insights-toggle:hover { color: var(--color-primary-dark); }

.insights-grid {
  display: grid;
  /* 230px lets four cards share one row on a normal desktop instead of three
     plus an orphan, which left two empty columns. */
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: var(--spacing-md);
  margin-bottom: var(--spacing-md);
  /* stretch, NOT start: with \`start\` every card sized to its own content, so a
     two-row list sat beside a tall chart with a ragged gap underneath it. */
  align-items: stretch;
}

.insight-card {
  padding: var(--spacing-md) var(--spacing-lg) var(--spacing-lg);
  display: flex;
  flex-direction: column;
}

/* The body takes the slack in a stretched card, so a short list is spaced out
   rather than huddled at the top over dead space. */
.insight-card > .leader-list,
.insight-card > .rank-list,
.insight-card > .dist-chart {
  flex: 1 1;
  justify-content: space-evenly;
}

.insight-head {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: var(--text-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-text-light);
}

.insight-head svg { color: var(--color-primary); }

/* Inside a narrow insight card the default rank layout gave the bar most of the
   width and truncated the label it was describing. The label matters more than
   two extra pixels of bar. */
.insight-card .rank-row {
  /* The track is capped so a card that ends up full width (one insight card in
     the row) does not stretch a "0/1" bar across 600px. */
  grid-template-columns: minmax(0, 1.5fr) minmax(0, 1fr) auto;
  gap: 8px;
}

.insight-card .rank-track { max-width: 320px; }

.insight-card .rank-label { font-size: var(--text-xs); }

/* Section label inside an insight card that holds more than one list. */
.insight-subhead {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--color-text-light);
  margin: var(--spacing-md) 0 2px;
}

.insight-subhead:first-of-type { margin-top: var(--spacing-sm); }

.insight-note {
  font-size: var(--text-xs);
  color: var(--color-text-light);
  /* auto pushes it to the bottom of a stretched card instead of leaving the
     gap below it. */
  margin: auto 0 0;
  padding-top: var(--spacing-sm);
  border-top: 1px solid var(--color-border-light);
}

/* Leaderboard */
.leader-list { display: flex; flex-direction: column; gap: 8px; padding-top: 12px; }

.leader-row {
  display: flex;
  align-items: center;
  gap: 10px;
  color: inherit;
  text-decoration: none;
  padding: 3px 0;
}

.leader-row:hover .leader-name { color: var(--color-primary-dark); }

.leader-rank {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex: none;
  border-radius: var(--radius-full);
  background: var(--color-surface-raised);
  color: var(--color-text-secondary);
  font-size: 0.68rem;
  font-weight: 700;
}

/* Only the top three get a colour — a "rank" badge on every row is just noise. */
.leader-rank.rank-1 { background: var(--color-warning-bg); color: var(--color-warning-text); }
.leader-rank.rank-2 { background: var(--color-surface-hover); color: var(--color-text); }
.leader-rank.rank-3 { background: var(--color-primary-bg); color: var(--color-primary-dark); }

.leader-main { flex: 1 1; min-width: 0; display: flex; flex-direction: column; gap: 4px; }

.leader-name {
  font-size: var(--text-sm);
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.leader-bar {
  height: 6px;
  border-radius: var(--radius-full);
  background: var(--color-surface-raised);
  overflow: hidden;
}

.leader-fill {
  display: block;
  height: 100%;
  border-radius: var(--radius-full);
  background: var(--color-primary);
}

.leader-score {
  font-size: var(--text-sm);
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  flex: none;
}

/* Score distribution */
.dist-chart {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  padding-top: 14px;
}

.dist-col {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.dist-count {
  font-size: var(--text-xs);
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

/* The track gives every column one baseline and one ceiling, so bars are
   comparable instead of each being sized to its own content. */
.dist-track {
  width: 100%;
  height: 62px;
  display: flex;
  align-items: flex-end;
  background: var(--color-surface-raised);
  border-radius: var(--radius-sm);
  overflow: hidden;
}

.dist-bar {
  width: 100%;
  background: var(--color-primary);
  border-radius: var(--radius-sm) var(--radius-sm) 0 0;
  min-height: 2px;
  transition: height var(--transition-slow);
}

.dist-label {
  font-size: 0.65rem;
  color: var(--color-text-light);
  white-space: nowrap;
}

/* A rank row that is also a filter. */
.rank-row-btn {
  border: none;
  background: none;
  padding: 2px 0;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  border-radius: var(--radius-sm);
}

.rank-row-btn:hover .rank-label { color: var(--color-text); }
.rank-row-btn.is-active .rank-label { color: var(--color-primary-dark); font-weight: 600; }
.rank-row-btn.is-active .rank-fill { background: var(--color-primary-dark); }

/* --- Follow-up chips --- */
.flag-chips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-bottom: var(--spacing-md);
}

.flag-chips-label {
  font-size: var(--text-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-text-light);
  margin-right: 2px;
}

.flag-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 11px;
  border: 1px solid var(--color-warning);
  border-radius: var(--radius-full);
  background: var(--color-warning-bg);
  color: var(--color-warning-text);
  font-family: inherit;
  font-size: var(--text-xs);
  font-weight: 500;
  cursor: pointer;
  transition: background var(--transition), border-color var(--transition);
}

.flag-chip:hover { border-color: var(--color-warning-text); }

.flag-chip.is-active {
  background: var(--color-warning-text);
  border-color: var(--color-warning-text);
  color: var(--color-warning-bg);
}

.flag-chip strong { font-variant-numeric: tabular-nums; }

/* --- Card provenance flags --- */
.card-flags {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 8px;
}

.card-flag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: var(--radius-full);
  background: var(--color-surface-raised);
  color: var(--color-text-light);
  font-size: 0.68rem;
  font-weight: 600;
  /* Missing reads as absent rather than as an error — most of these are
     optional, and a wall of red would be wrong. */
  opacity: 0.55;
}

.card-flag.is-on {
  background: var(--color-success-bg);
  color: var(--color-success-text);
  opacity: 1;
}

/* --- Assessments: tier mix + filter toolbar --- */
/* One colour per tier, shared by the stacked bar and the legend dots so the
   two always agree. Ordered high → low. */
.tier-global_kol   { background: var(--brand-blue); }
.tier-strategic_kol{ background: var(--brand-teal); }
.tier-national_kol { background: var(--brand-green-4); }
.tier-emerging_kol { background: var(--brand-green-3); }
.tier-local_kol    { background: var(--brand-green-1); }
.tier-non_kol      { background: var(--color-text-light); }

.tier-mix {
  padding: var(--spacing-md) var(--spacing-lg);
  margin-bottom: var(--spacing-md);
}

.tier-mix-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 10px;
}

.tier-mix-title {
  font-size: var(--text-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.09em;
  color: var(--color-text-light);
}

.tier-mix-total {
  font-size: var(--text-xs);
  color: var(--color-text-light);
  font-variant-numeric: tabular-nums;
}

.tier-mix-bar {
  display: flex;
  height: 10px;
  border-radius: var(--radius-full);
  overflow: hidden;
  background: var(--color-surface-raised);
}

.tier-mix-seg { display: block; }

.tier-mix-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
}

/* Each legend entry is also the filter for that tier — the fastest way to
   answer "show me the Global KOLs". */
.tier-mix-key {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-full);
  background: var(--color-surface);
  color: var(--color-text-secondary);
  font-family: inherit;
  font-size: var(--text-xs);
  text-transform: capitalize;
  cursor: pointer;
  transition: border-color var(--transition), background var(--transition), color var(--transition);
}

.tier-mix-key:hover { border-color: var(--color-border-strong); color: var(--color-text); }

.tier-mix-key.is-active {
  border-color: var(--color-primary);
  background: var(--color-primary-bg);
  color: var(--color-primary-dark);
}

.tier-mix-key strong { font-variant-numeric: tabular-nums; }

.tier-dot {
  width: 8px;
  height: 8px;
  border-radius: var(--radius-full);
  flex: none;
}

.filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--spacing-sm);
  margin-bottom: var(--spacing-sm);
}

.filter-search {
  position: relative;
  flex: 1 1 260px;
  min-width: 200px;
  display: flex;
  align-items: center;
}

.filter-search svg {
  position: absolute;
  left: 12px;
  color: var(--color-text-light);
  pointer-events: none;
}

.filter-search .form-control { padding-left: 36px; }

.filter-select {
  width: auto;
  flex: 0 1 auto;
  min-width: 130px;
  max-width: 210px;
}

.filter-summary {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  margin-bottom: var(--spacing-md);
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
}

@media (max-width: 640px) {
  /* Stacked, the selects should use the full width rather than sitting in a
     ragged row of different sizes. */
  .filter-select,
  .filter-bar .btn {
    width: 100%;
    max-width: none;
  }
}

/* --- Ranked bar list (tier mix, top specialties) ---
   These classes were written for the admin panel first; the frontend used them
   without ever defining them, so the bars rendered as bare label+count text. */
.rank-list {
  display: flex;
  flex-direction: column;
  gap: 9px;
  padding: 10px 0 2px;
}

.rank-row {
  display: grid;
  grid-template-columns: minmax(78px, 1fr) minmax(0, 1.6fr) auto;
  align-items: center;
  gap: 10px;
}

.rank-label {
  font-size: var(--text-xs);
  color: var(--color-text-secondary);
  text-transform: capitalize;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rank-track {
  height: 8px;
  background: var(--color-surface-raised);
  border-radius: var(--radius-full);
  overflow: hidden;
}

.rank-fill {
  display: block;
  height: 100%;
  background: var(--color-primary);
  border-radius: var(--radius-full);
  transition: width var(--transition-slow);
}

.rank-count {
  font-size: var(--text-sm);
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  min-width: 20px;
  text-align: right;
}

/* --- Dashboard: quick actions, chips, panel notes --- */
.quick-actions {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 6px 0 2px;
}

.quick-action {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface);
  color: var(--color-text);
  font-size: var(--text-base);
  font-weight: 500;
  text-decoration: none;
  transition: border-color var(--transition), background var(--transition);
}

.quick-action:hover {
  border-color: var(--color-primary);
  background: var(--color-primary-bg);
  color: var(--color-primary-dark);
}

.quick-action-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex: none;
  border-radius: var(--radius-sm);
  background: var(--color-surface-raised);
  color: var(--color-primary-dark);
}

.quick-action:hover .quick-action-icon {
  background: var(--color-surface);
}

/* Nudges right on hover, so the row reads as "go somewhere". */
.quick-action-arrow {
  margin-left: auto;
  flex: none;
  opacity: 0;
  transform: translateX(-4px);
  transition: opacity var(--transition), transform var(--transition);
}

.quick-action:hover .quick-action-arrow {
  opacity: 1;
  transform: translateX(0);
}

.panel-note {
  font-size: var(--text-xs);
  color: var(--color-text-light);
  font-variant-numeric: tabular-nums;
}

.panel-subhead {
  font-size: var(--text-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-text-light);
  margin: var(--spacing-md) 0 var(--spacing-sm);
  padding-top: var(--spacing-sm);
  border-top: 1px solid var(--color-border-light);
}

.chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: var(--radius-full);
  background: var(--color-surface-raised);
  color: var(--color-text-secondary);
  font-size: var(--text-xs);
  font-weight: 500;
}

.chip-count {
  font-weight: 700;
  color: var(--color-text);
  font-variant-numeric: tabular-nums;
}

/* --- Dashboard list rows (recent assessments, most answered, boards) --- */
.dash-list {
  display: flex;
  flex-direction: column;
}

.dash-row {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  padding: 11px 2px;
  border-bottom: 1px solid var(--color-border-light);
  color: inherit;
  text-decoration: none;
  transition: background var(--transition);
}

.dash-row:last-child { border-bottom: none; }

.dash-row:hover {
  background: var(--color-surface-hover);
  color: inherit;
}

.dash-row-main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.dash-row-title {
  font-weight: 600;
  font-size: var(--text-base);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dash-row-meta {
  font-size: var(--text-xs);
  color: var(--color-text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dash-row-value {
  font-weight: 700;
  font-size: var(--text-md);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  flex: none;
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.dash-row-unit {
  font-size: var(--text-xs);
  font-weight: 500;
  color: var(--color-text-light);
}

.dash-row-cta {
  font-size: var(--text-xs);
  font-weight: 700;
  color: var(--color-primary-dark);
  white-space: nowrap;
  flex: none;
}

.dash-tier {
  font-size: 0.66rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 3px 8px;
  border-radius: var(--radius-full);
  background: var(--color-primary-bg);
  color: var(--color-primary-dark);
  white-space: nowrap;
  flex: none;
}

@media (max-width: 640px) {
  /* The tier chip is the first thing to go when the row gets tight — the score
     and the name matter more. */
  .dash-tier { display: none; }
}

/* --- Coming soon (entitled module with no screen yet) --- */
.coming-soon {
  max-width: 520px;
  margin: var(--spacing-2xl) auto;
  padding: var(--spacing-2xl) var(--spacing-xl);
  text-align: center;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
}

.coming-soon-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin: 0 auto var(--spacing-md);
  border-radius: var(--radius-md);
  background: var(--color-primary-bg);
  color: var(--color-primary-dark);
}

.coming-soon-badge {
  display: inline-block;
  font-size: var(--text-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.09em;
  padding: 4px 12px;
  border-radius: var(--radius-full);
  background: var(--color-warning-bg);
  color: var(--color-warning-text);
  margin-bottom: var(--spacing-md);
}

.coming-soon h2 {
  margin-bottom: var(--spacing-sm);
}

.coming-soon p {
  color: var(--color-text-secondary);
  margin-bottom: var(--spacing-md);
}

.coming-soon-note {
  font-size: var(--text-sm);
  color: var(--color-text-light);
  padding-top: var(--spacing-md);
  border-top: 1px solid var(--color-border-light);
}

/* --- New Assessment --- */
.new-assessment-aside {
  position: sticky;
  /* Clears the sticky app bar. */
  top: calc(var(--appbar-h) + var(--spacing-md));
}

.new-assessment-actions {
  display: flex;
  gap: var(--spacing-sm);
  justify-content: flex-end;
  align-items: center;
  padding-top: var(--spacing-md);
  border-top: 1px solid var(--color-border);
}

@media (max-width: 900px) {
  /* Stacked, a sticky aside would pin the CV panel over the form. */
  .new-assessment-aside {
    position: static;
  }

  .new-assessment-actions {
    justify-content: stretch;
  }

  .new-assessment-actions .btn {
    flex: 1 1;
  }
}

/* --- New Assessment: repeatable row editors ---
   The column template is computed per section in JS, so it lands as an inline
   style that no media query can reach. \`!important\` from a stylesheet is the one
   thing that does outrank an inline style, and stacking is the only sane layout
   for a four-column row on a phone. */
@media (max-width: 760px) {
  .rowsection-row {
    grid-template-columns: 1fr !important;
    gap: 6px !important;
    padding-bottom: var(--spacing-sm);
    border-bottom: 1px dashed var(--color-border);
  }

  /* The delete button is last in DOM order; full-width it so the row reads as
     a small card with its own remove action rather than a stray icon. */
  .rowsection-row > button {
    justify-self: end;
  }
}

/* ============================================
   Checkout Page
   ============================================ */

.checkout-wrapper {
  max-width: 960px;
  margin: 0 auto;
}

.checkout-empty {
  text-align: center;
  padding: 80px 20px;
}

.checkout-empty svg {
  color: var(--color-text-light);
  margin-bottom: 16px;
}

.checkout-empty h2 {
  margin-bottom: 8px;
}

.checkout-empty p {
  color: var(--color-text-secondary);
  margin-bottom: 24px;
}

/* Steps */
.checkout-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  margin-bottom: var(--spacing-2xl);
}

.checkout-step {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--color-text-light);
  font-size: 0.9rem;
  font-weight: 500;
}

.checkout-step.active {
  color: var(--color-primary);
}

.checkout-step.done {
  color: var(--color-success);
}

.checkout-step-num {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid currentColor;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.85rem;
}

.checkout-step.active .checkout-step-num {
  background: var(--color-primary);
  color: var(--color-primary-contrast);
  border-color: var(--color-primary);
}

.checkout-step.done .checkout-step-num {
  background: var(--color-success);
  color: var(--color-text-inverse);
  border-color: var(--color-success);
}

.checkout-step-line {
  width: 40px;
  height: 2px;
  background: var(--color-border);
  margin: 0 12px;
}

/* Layout */
.checkout-layout {
  display: flex;
  gap: var(--spacing-xl);
  align-items: flex-start;
}

.checkout-form-section {
  flex: 1 1;
}

.checkout-card {
  background: var(--color-white);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: var(--spacing-xl);
}

.checkout-card h3 {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
}

.checkout-hint {
  color: var(--color-text-secondary);
  font-size: 0.88rem;
  margin-bottom: var(--spacing-lg);
}

.checkout-secure-note {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.82rem;
  color: var(--color-success);
  margin-bottom: var(--spacing-md);
}

.checkout-gateway-info {
  background: var(--color-primary-bg);
  border: 1px solid var(--color-primary-light);
  border-radius: var(--radius-md);
  padding: var(--spacing-md);
  margin-bottom: var(--spacing-lg);
}

.checkout-gateway-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.95rem;
  color: var(--color-primary-dark);
}

.checkout-payment-summary {
  margin-bottom: var(--spacing-md);
  padding: var(--spacing-md) 0;
  border-top: 1px solid var(--color-border);
  border-bottom: 1px solid var(--color-border);
}

.checkout-gateway-note {
  margin-top: var(--spacing-md);
  text-align: center;
  font-size: 0.8rem;
  color: var(--color-text-light);
}

/* Order Summary */
.checkout-summary {
  width: 320px;
  flex-shrink: 0;
}

.checkout-summary-card {
  background: var(--color-white);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: var(--spacing-xl);
  position: sticky;
  top: 84px;
}

.checkout-summary-card h4 {
  margin-bottom: var(--spacing-md);
  font-size: 1rem;
}

.checkout-plan-name {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--color-primary);
}

.checkout-plan-cycle {
  font-size: 0.88rem;
  color: var(--color-text-secondary);
  margin-bottom: 4px;
}

.checkout-summary-divider {
  height: 1px;
  background: var(--color-border-light);
  margin: var(--spacing-md) 0;
}

.checkout-plan-features {
  list-style: none;
  padding: 0;
  margin: 0;
}

.checkout-plan-features li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  padding: 3px 0;
  color: var(--color-text-secondary);
}

.checkout-plan-features li svg {
  color: var(--color-success);
  flex-shrink: 0;
}

.checkout-total-row {
  display: flex;
  justify-content: space-between;
  font-size: 0.9rem;
  padding: 4px 0;
  color: var(--color-text-secondary);
}

.checkout-total-row.total {
  font-weight: 700;
  font-size: 1.05rem;
  color: var(--color-secondary);
}

/* Success */
.checkout-success {
  text-align: center;
  padding: 60px var(--spacing-xl);
}

.checkout-success-icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: var(--color-success-bg);
  color: var(--color-success);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto var(--spacing-lg);
}

.checkout-success h2 {
  margin-bottom: 8px;
  color: var(--color-success);
}

.checkout-success p {
  color: var(--color-text-secondary);
  margin-bottom: 4px;
}

/* ============================================
   Quill Rich Text - Rendered Content
   ============================================ */
/* ── Rich text editor (Quill "snow") in dark mode ──
   quill.snow.css is a third-party stylesheet with hardcoded #ccc borders, #444
   icon strokes and #fff panels — none of it reads our tokens, so the toolbar and
   especially its picker DROPDOWNS stayed white-on-white when the dark theme was
   on. These override the handful of declarations that carry colour. */
[data-theme='dark'] .ql-toolbar.ql-snow,
[data-theme='dark'] .ql-container.ql-snow {
  border-color: var(--color-border);
}

[data-theme='dark'] .ql-toolbar.ql-snow {
  background: var(--color-surface-raised);
}

[data-theme='dark'] .ql-container.ql-snow {
  background: var(--color-surface);
}

[data-theme='dark'] .ql-editor {
  color: var(--color-text);
}

[data-theme='dark'] .ql-editor.ql-blank::before {
  color: var(--color-text-light);
}

/* Toolbar icons are inline SVG strokes and fills, not glyphs. */
[data-theme='dark'] .ql-snow .ql-stroke { stroke: var(--color-text-secondary); }
[data-theme='dark'] .ql-snow .ql-fill,
[data-theme='dark'] .ql-snow .ql-stroke.ql-fill { fill: var(--color-text-secondary); }
[data-theme='dark'] .ql-snow .ql-picker { color: var(--color-text-secondary); }

[data-theme='dark'] .ql-snow.ql-toolbar button:hover .ql-stroke,
[data-theme='dark'] .ql-snow.ql-toolbar button.ql-active .ql-stroke,
[data-theme='dark'] .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,
[data-theme='dark'] .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke { stroke: var(--color-primary); }

[data-theme='dark'] .ql-snow.ql-toolbar button:hover .ql-fill,
[data-theme='dark'] .ql-snow.ql-toolbar button.ql-active .ql-fill,
[data-theme='dark'] .ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill { fill: var(--color-primary); }

[data-theme='dark'] .ql-snow.ql-toolbar button:hover,
[data-theme='dark'] .ql-snow.ql-toolbar button.ql-active,
[data-theme='dark'] .ql-snow.ql-toolbar .ql-picker-label:hover,
[data-theme='dark'] .ql-snow.ql-toolbar .ql-picker-item:hover,
[data-theme='dark'] .ql-snow.ql-toolbar .ql-picker-item.ql-selected { color: var(--color-primary); }

/* The dropdown panel itself — the part that was an unreadable white sheet. */
[data-theme='dark'] .ql-snow .ql-picker-options {
  background: var(--color-surface-raised);
  border-color: var(--color-border-strong);
  box-shadow: var(--shadow-lg);
}

[data-theme='dark'] .ql-snow .ql-picker.ql-expanded .ql-picker-label,
[data-theme='dark'] .ql-snow .ql-picker.ql-expanded .ql-picker-options {
  border-color: var(--color-border-strong);
}

/* Link tooltip. */
[data-theme='dark'] .ql-snow .ql-tooltip {
  background: var(--color-surface-raised);
  border-color: var(--color-border-strong);
  box-shadow: var(--shadow-lg);
  color: var(--color-text);
}

[data-theme='dark'] .ql-snow .ql-tooltip input[type=text] {
  background: var(--color-surface);
  border-color: var(--color-border);
  color: var(--color-text);
}

[data-theme='dark'] .ql-snow .ql-tooltip a.ql-action,
[data-theme='dark'] .ql-snow .ql-tooltip a.ql-remove,
[data-theme='dark'] .ql-snow a { color: var(--color-primary); }

.ql-editor p {
  margin: 0;
  line-height: 1.5;
}
.ql-editor p + p {
  margin-top: 0.25em;
}
.ql-editor p:empty,
.ql-editor p:has(> br:only-child) {
  height: 1em;
}
.ql-editor h1, .ql-editor h2, .ql-editor h3 {
  margin: 0.4em 0 0.2em;
}
.ql-editor ul, .ql-editor ol {
  margin: 0.2em 0;
}

/* ============================================
   Public Survey - Responsive
   ============================================ */
@media (max-width: 768px) {
  .public-survey-container {
    padding: 20px 10px !important;
  }
  .public-survey-container .card {
    padding: 16px 14px !important;
    border-radius: 10px !important;
  }
  .public-survey-container h1 {
    font-size: 1.2rem !important;
  }
  .public-survey-container .btn-lg {
    padding: 10px 20px !important;
    font-size: 0.95rem !important;
  }
  .public-survey-container img {
    max-height: 200px !important;
  }
}

@media (max-width: 480px) {
  .public-survey-container {
    padding: 12px 6px !important;
  }
  .public-survey-container .card {
    padding: 14px 12px !important;
  }
  .public-survey-container h1 {
    font-size: 1.05rem !important;
  }
  .public-survey-container .form-control {
    font-size: 0.9rem !important;
  }
}

/* ============================================
   Pasted icon markup in survey question labels
   ============================================ */

/* Font Awesome is NOT bundled in this app (nothing in index.html/package.json
   loads it), so a pasted <i class="fa fa-asterisk"> draws nothing at all — the
   glyph normally comes from FA's icon font. Authors use it to mark a question,
   so render the asterisk as a plain character instead of shipping a ~70KB icon
   font for one glyph. Inline color/font-size on the tag still apply, so
   style="color:red" gives the intended red asterisk. */
.fa-asterisk {
  font-style: normal;
}
.fa-asterisk::before {
  content: "*";
}

/* LiveKit recording indicator — the dot pulses so a running recording is
   noticeable in peripheral vision, not just a static red badge. */
@keyframes lk-rec-blink {
  0%, 100% { opacity: 1; }
  50%      { opacity: 0.25; }
}

/* --- Wordmark ---
   The real logotype, rendered as an image. Only the HEIGHT is constrained:
   the artwork is ~5.4:1, and setting a width as well is how a logo gets
   squashed. \`flex-shrink: 0\` stops a tight flex parent (the collapsed
   sidebar) doing the same thing. */
.wordmark {
  display: inline-flex;
  align-items: center;
  gap: 0.5em;
  line-height: 1;
  white-space: nowrap;
}

.wordmark-img {
  height: 1.6rem;
  width: auto;
  flex-shrink: 0;
  display: block;
}

/* Light/dark variants of the SAME artwork — only the ink differs, the sphere is
   identical in both. Swapped here rather than in JS so the logo cannot flash the
   wrong variant on a theme change or first paint. \`data-theme\` is always set
   explicitly on <html> by useTheme, so there is no third state to handle. */
.wordmark-img-dark { display: none; }
[data-theme='dark'] .wordmark-img-light { display: none; }
[data-theme='dark'] .wordmark-img-dark { display: block; }


/* Product qualifier ("KOL" / "Admin") — a small caps tag, never part of the logotype. */
.wordmark-suffix {
  font-family: var(--font-sans);
  font-size: 0.58em;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: var(--color-text-light);
  margin-left: 0.45em;
  align-self: center;
}

/* --- Advisory Boards: lifecycle track on each board row --- */
.phase-track {
  display: flex;
  gap: 4px;
  margin-top: 10px;
  max-width: 420px;
}

.phase-step {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.phase-step-bar {
  height: 4px;
  border-radius: var(--radius-full);
  background: var(--color-surface-raised);
  transition: background var(--transition);
}

.phase-step.is-done .phase-step-bar { background: var(--color-primary-light); }
.phase-step.is-current .phase-step-bar { background: var(--color-primary); }

.phase-step-label {
  font-size: 0.62rem;
  color: var(--color-text-light);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.phase-step.is-current .phase-step-label {
  color: var(--color-primary-dark);
  font-weight: 700;
}

/* Below 700px the five labels collide; the bars alone still show position. */
@media (max-width: 700px) {
  .phase-step-label { display: none; }
}

/* --- Board readiness gaps --- */
.board-gaps {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 8px;
}

.board-gap {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 7px;
  border-radius: var(--radius-full);
  background: var(--color-warning-bg);
  color: var(--color-warning-text);
  font-size: 0.66rem;
  font-weight: 600;
  white-space: nowrap;
}

/* ── Advisory board detail ─────────────────────────────────────────────
   Its own page (#boards/{id}): back-link, hero, grouped section rail. */
.bd-back { display: flex; align-items: center; gap: 6px; margin-bottom: 12px; min-width: 0; }
.bd-back-sep { color: var(--color-text-light); flex: none; }
.bd-back-current {
  font-size: 0.82rem; color: var(--color-text-secondary); font-weight: 600;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}

.bd-hero { padding: 18px 20px; margin-bottom: 18px; }
.bd-hero-top { display: flex; justify-content: space-between; align-items: flex-start; gap: 14px; flex-wrap: wrap; }
.bd-identity { min-width: 0; flex: 1 1 320px; }
.bd-title-row { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-bottom: 6px; }
.bd-title { margin: 0; font-size: 1.35rem; line-height: 1.25; }
.bd-pill { padding: 3px 10px; border-radius: 999px; font-size: 0.72rem; font-weight: 600; white-space: nowrap; }
.bd-meta { display: flex; flex-wrap: wrap; gap: 4px 16px; font-size: 0.85rem; color: var(--color-text-secondary); }
.bd-meta > span { display: inline-flex; align-items: center; gap: 4px; }
.bd-actions { display: flex; gap: 6px; align-items: center; flex-wrap: wrap; }
.bd-locked {
  display: inline-flex; align-items: center; gap: 4px;
  font-size: 0.78rem; color: var(--color-text-light);
}

/* Stat strip — each tile jumps to the section it summarises. */
.bd-stats {
  display: grid; grid-template-columns: repeat(auto-fit, minmax(128px, 1fr));
  gap: 8px; margin-top: 16px;
}
.bd-stat {
  display: flex; flex-direction: column; gap: 4px; align-items: flex-start;
  padding: 10px 12px; border: 1px solid var(--color-border-light); border-radius: var(--radius);
  background: var(--color-bg); cursor: pointer; text-align: left;
  transition: border-color var(--transition), background var(--transition);
}
.bd-stat:hover { border-color: var(--color-primary); background: var(--color-primary-bg); }
.bd-stat-label {
  display: inline-flex; align-items: center; gap: 5px;
  font-size: 0.7rem; font-weight: 600; letter-spacing: 0.04em; text-transform: uppercase;
  color: var(--color-text-light);
}
.bd-stat-value { font-size: 1.25rem; font-weight: 700; color: var(--color-text); line-height: 1.1; }
.bd-stat-text { font-size: 0.95rem; text-transform: capitalize; }
.bd-stat-of { font-size: 0.85rem; font-weight: 600; color: var(--color-text-light); }

/* Lifecycle track — bar + step + label, one column per phase. */
.bd-phases { margin-top: 18px; padding-top: 14px; border-top: 1px solid var(--color-border-light); }
.bd-phases-head {
  display: flex; align-items: baseline; justify-content: space-between;
  gap: 8px; flex-wrap: wrap; margin-bottom: 10px;
}
.bd-phases-note { font-size: 0.74rem; color: var(--color-text-light); }
.bd-eyebrow {
  font-size: 0.72rem; font-weight: 700; letter-spacing: 0.05em;
  text-transform: uppercase; color: var(--color-text-light);
}
.bd-phase-row { display: flex; gap: 6px; }
.bd-phase {
  flex: 1 1; min-width: 0; display: flex; flex-direction: column; gap: 5px;
  padding: 0; border: none; background: none; cursor: pointer; text-align: left;
}
.bd-phase-bar {
  display: block; height: 4px; border-radius: 999px;
  background: var(--color-border-light); transition: background var(--transition);
}
.bd-phase:not(.is-current):not(.is-done):hover .bd-phase-bar { background: var(--color-border); }
.bd-phase-step { font-size: 0.66rem; font-weight: 600; color: var(--color-text-light); }
.bd-phase-label {
  font-size: 0.8rem; font-weight: 600; color: var(--color-text-secondary);
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.bd-phase.is-done .bd-phase-label { color: var(--color-text); }
.bd-phase.is-current .bd-phase-label { font-weight: 700; }

/* Body: left section rail + panel. */
.bd-body { display: grid; grid-template-columns: 208px minmax(0, 1fr); gap: 18px; align-items: start; }
/* A sticky element can only travel inside its containing block, and a grid row
   is only as tall as its tallest item — with no min-height here the rail was
   the taller column, had zero travel, and scrolled away with the page. */
.bd-panel { min-height: calc(100vh - 120px); }

/* The rail is bounded and scrolls on its own vertical axis. The bound is a
   fixed 440px rather than the remaining viewport: viewport-bound made it 230px
   at the top of the page, which read as chopped rather than scrollable. The
   scrollbar is deliberately styled — macOS overlay scrollbars stay invisible
   until you scroll, so an unstyled one gives no clue the list continues. */
/* The bottom strip is reserved space, not an overlay — the cue used to sit on
   top of the last visible item and the fade washed both of them out. Reserved
   unconditionally so nothing shifts when the cue appears and disappears. */
.bd-rail-wrap { position: sticky; top: 84px; padding-bottom: 22px; }
/* Fade the bottom edge so it is obvious the list continues past the cut. Drawn
   on the wrapper, not the scroller, or it would scroll away with the content;
   inset from the right so it never sits over the scrollbar. */
.bd-rail-wrap::after {
  content: ''; position: absolute; left: 0; right: 11px; bottom: 22px; height: 26px;
  background: linear-gradient(to bottom, transparent, var(--color-bg));
  pointer-events: none; opacity: 0; transition: opacity var(--transition);
}
.bd-rail-wrap.has-more::after { opacity: 1; }
/* Explicit cue — the fade alone is easy to miss, and macOS hides its overlay
   scrollbar until you are already scrolling. Both drop away at the end. */
.bd-rail-more {
  position: absolute; left: 0; right: 11px; bottom: 0; height: 22px;
  display: flex; align-items: center; justify-content: center; gap: 4px;
  font-size: 0.68rem; font-weight: 700; letter-spacing: 0.06em; text-transform: uppercase;
  color: var(--color-primary-dark); pointer-events: none;
  opacity: 0; transition: opacity var(--transition);
}
.bd-rail-wrap.has-more .bd-rail-more { opacity: 1; }
.bd-rail {
  display: flex; flex-direction: column; gap: 14px;
  max-height: min(440px, calc(100vh - 140px));
  overflow-y: scroll; overflow-x: hidden;
  padding-right: 10px;
  scrollbar-width: thin;
  scrollbar-color: var(--color-border-strong) var(--color-surface-raised);
  overscroll-behavior: contain;
}
.bd-rail::-webkit-scrollbar { width: 10px; appearance: none; }
.bd-rail::-webkit-scrollbar-track {
  background: var(--color-surface-raised); border-radius: 999px;
}
.bd-rail::-webkit-scrollbar-thumb {
  background: var(--color-border-strong); border-radius: 999px;
  border: 2px solid var(--color-surface-raised);
}
.bd-rail::-webkit-scrollbar-thumb:hover { background: var(--color-text-light); }

.bd-rail-group { display: flex; flex-direction: column; gap: 1px; }
.bd-rail-heading {
  font-size: 0.68rem; font-weight: 700; letter-spacing: 0.07em; text-transform: uppercase;
  color: var(--color-text-light); padding: 0 10px 5px;
}
.bd-rail-link {
  display: flex; align-items: center; gap: 9px; width: 100%;
  padding: 8px 10px; border: none; border-radius: var(--radius); background: none;
  color: var(--color-text-secondary); font-size: 0.86rem; font-weight: 500;
  cursor: pointer; text-align: left; transition: background var(--transition), color var(--transition);
}
.bd-rail-link:hover { background: var(--color-surface-hover); color: var(--color-text); }
.bd-rail-link.is-active { background: var(--color-primary-bg); color: var(--color-primary-dark); font-weight: 600; }
.bd-rail-link svg { flex: none; }
.bd-rail-label { flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.bd-rail-count {
  flex: none; min-width: 20px; padding: 1px 6px; border-radius: 999px;
  background: var(--color-surface-raised); border: 1px solid var(--color-border-light);
  font-size: 0.7rem; font-weight: 700; text-align: center; color: var(--color-text-secondary);
}
.bd-rail-link.is-active .bd-rail-count {
  background: var(--color-surface); border-color: transparent; color: var(--color-primary-dark);
}

/* Overview: brief on the left, readiness on the right. */
.bd-overview { display: grid; grid-template-columns: minmax(0, 1.55fr) minmax(0, 1fr); gap: 16px; align-items: start; }
.bd-brief { padding: 18px; }
.bd-prose { margin: 6px 0 0; line-height: 1.6; max-width: 68ch; }
.bd-prose-pre { white-space: pre-wrap; }
.bd-empty { color: var(--color-text-light); font-style: normal; }
.bd-facts {
  display: grid; grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)); gap: 14px;
  margin-top: 18px; padding-top: 16px; border-top: 1px solid var(--color-border-light);
}
.bd-fact { display: flex; flex-direction: column; gap: 3px; font-size: 0.9rem; min-width: 0; }
.bd-fact > span:last-child { overflow-wrap: anywhere; }
.bd-notes { margin-top: 18px; padding-top: 16px; border-top: 1px solid var(--color-border-light); }

.bd-readiness { padding: 18px; }
.bd-readiness-head { display: flex; align-items: baseline; justify-content: space-between; gap: 8px; }
.bd-readiness-score { font-size: 1rem; font-weight: 700; color: var(--color-text); }
.bd-readiness-track {
  height: 5px; border-radius: 999px; background: var(--color-border-light);
  overflow: hidden; margin: 10px 0 14px;
}
.bd-readiness-fill { display: block; height: 100%; background: var(--color-primary); transition: width var(--transition); }
.bd-checks { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 12px; }
.bd-check { display: flex; gap: 9px; align-items: flex-start; color: var(--color-text-light); }
.bd-check.is-ok { color: var(--color-success); }
.bd-check svg { flex: none; margin-top: 1px; }
.bd-check-label {
  border: none; background: none; padding: 0; cursor: pointer;
  font-size: 0.88rem; font-weight: 600; color: var(--color-text); text-align: left;
}
.bd-check-label:hover { color: var(--color-primary-dark); text-decoration: underline; }
.bd-check.is-ok .bd-check-label { color: var(--color-text-secondary); font-weight: 500; }
.bd-check-hint { font-size: 0.78rem; color: var(--color-text-light); margin-top: 2px; line-height: 1.45; }

@media (max-width: 1080px) {
  .bd-overview { grid-template-columns: minmax(0, 1fr); }
}
@media (max-width: 900px) {
  /* No room for a rail beside the panel; it lies down into a horizontal
     scroller and the group headings drop out rather than doubling its height. */
  .bd-body { grid-template-columns: minmax(0, 1fr); gap: 14px; }
  .bd-panel { min-height: 0; }
  .bd-rail-wrap { position: static; padding-bottom: 0; }
  .bd-rail-wrap::after, .bd-rail-more { display: none; }
  .bd-rail {
    flex-direction: row; gap: 4px;
    max-height: none; overflow-y: hidden; overflow-x: auto;
    padding-right: 0; padding-bottom: 6px;
    border-bottom: 1px solid var(--color-border-light);
  }
  .bd-rail::-webkit-scrollbar { width: auto; height: 8px; }
  .bd-rail-group { flex-direction: row; gap: 4px; }
  .bd-rail-heading { display: none; }
  .bd-rail-link { width: auto; white-space: nowrap; }
  .bd-phase-step { display: none; }
}
@media (max-width: 560px) {
  .bd-phase-label { font-size: 0.7rem; }
  .bd-phases-note { display: none; }
}

/* Overview left column stacks brief + breakdown + roster. */
.bd-col { display: flex; flex-direction: column; gap: 16px; min-width: 0; }
.bd-breakdown, .bd-roster { padding: 18px; }
.bd-phase-counts { display: flex; flex-direction: column; gap: 9px; margin-top: 12px; }
.bd-phase-count {
  display: grid; grid-template-columns: minmax(90px, 130px) minmax(0, 1fr) 28px;
  align-items: center; gap: 10px; width: 100%;
  border: none; background: none; padding: 0; cursor: pointer; text-align: left;
}
.bd-phase-count-label {
  font-size: 0.82rem; color: var(--color-text-secondary);
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.bd-phase-count:hover .bd-phase-count-label { color: var(--color-text); }
.bd-phase-count-track { height: 7px; border-radius: 999px; background: var(--color-border-light); overflow: hidden; }
.bd-phase-count-fill { display: block; height: 100%; border-radius: 999px; }
.bd-phase-count-n { font-size: 0.82rem; font-weight: 700; color: var(--color-text); text-align: right; }

.bd-roster-list { list-style: none; margin: 12px 0 0; padding: 0; display: flex; flex-direction: column; gap: 10px; }
.bd-roster-item { display: flex; align-items: center; gap: 10px; min-width: 0; }
.bd-roster-avatar {
  flex: none; width: 30px; height: 30px; border-radius: 50%;
  display: grid; place-items: center;
  background: var(--color-primary-bg); color: var(--color-primary-dark);
  font-size: 0.8rem; font-weight: 700;
}
.bd-roster-body { display: flex; flex-direction: column; min-width: 0; }
.bd-roster-name {
  font-size: 0.88rem; font-weight: 600; color: var(--color-text);
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.bd-roster-sub {
  font-size: 0.76rem; color: var(--color-text-light);
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.bd-roster-more { padding-left: 40px; }

/* Inline text button — an action that reads as part of a sentence. */
.btn-link {
  border: none; background: none; padding: 0; cursor: pointer;
  font: inherit; color: var(--color-primary-dark); font-weight: 600;
}
.btn-link:hover { text-decoration: underline; }

/* ── Meetings ──────────────────────────────────────────────────────────
   Segmented status pills, an at-a-glance band, and a date-grouped list. */
.filter-pills {
  display: inline-flex; gap: 2px; flex: none;
  padding: 3px; border-radius: var(--radius);
  background: var(--color-surface-raised);
}
.filter-pill {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 6px 12px; border: none; border-radius: calc(var(--radius) - 2px);
  background: transparent; color: var(--color-text-secondary);
  font-size: 0.8rem; font-weight: 600; cursor: pointer; white-space: nowrap;
  transition: background var(--transition), color var(--transition);
}
.filter-pill:hover { color: var(--color-text); }
.filter-pill.is-active {
  background: var(--color-surface); color: var(--color-primary);
  box-shadow: var(--shadow-sm, 0 1px 2px rgba(0, 0, 0, 0.06));
}
.filter-pill-count {
  min-width: 18px; padding: 0 5px; border-radius: 999px;
  background: var(--color-bg); color: var(--color-text-secondary);
  font-size: 0.68rem; font-weight: 700; text-align: center;
}
.filter-pill.is-active .filter-pill-count {
  background: var(--color-primary-bg); color: var(--color-primary-dark);
}

.mt-stats {
  display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 10px; margin-bottom: 14px;
}
.mt-stat {
  display: flex; flex-direction: column; gap: 4px;
  padding: 12px 14px; border-radius: var(--radius);
  border: 1px solid var(--color-border-light); background: var(--color-surface);
}
.mt-stat-label {
  display: inline-flex; align-items: center; gap: 5px;
  font-size: 0.7rem; font-weight: 600; letter-spacing: 0.04em; text-transform: uppercase;
  color: var(--color-text-light);
}
.mt-stat-value { font-size: 1.35rem; font-weight: 700; color: var(--color-text); line-height: 1.1; }

.mt-groups { display: flex; flex-direction: column; gap: 20px; }
.mt-group-head { display: flex; align-items: center; gap: 8px; margin-bottom: 8px; }
.mt-group-title {
  margin: 0; font-size: 0.74rem; font-weight: 700;
  letter-spacing: 0.07em; text-transform: uppercase; color: var(--color-text-light);
}
.mt-group-count {
  min-width: 18px; padding: 1px 6px; border-radius: 999px;
  background: var(--color-surface-raised); color: var(--color-text-secondary);
  font-size: 0.68rem; font-weight: 700; text-align: center;
}
.mt-list { padding: 0; overflow: hidden; }

.mt-row {
  display: flex; align-items: center; gap: 12px;
  padding: 12px 16px; border-bottom: 1px solid var(--color-border-light);
  transition: background var(--transition);
}
.mt-row:last-child { border-bottom: none; }
.mt-row:hover { background: var(--color-bg); }
.mt-row-main {
  display: flex; flex: 1 1 auto; min-width: 0; align-items: center; gap: 12px;
  border: none; background: none; padding: 0; text-align: left; cursor: pointer;
}
.mt-icon {
  flex: none; width: 36px; height: 36px; border-radius: var(--radius);
  display: grid; place-items: center;
}
.mt-body { display: flex; flex-direction: column; gap: 3px; min-width: 0; flex: 1 1 auto; }
.mt-title-row { display: flex; align-items: center; gap: 8px; min-width: 0; }
.mt-title {
  font-weight: 600; font-size: 0.93rem; color: var(--color-text);
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.mt-status {
  flex: none; padding: 2px 8px; border-radius: 999px;
  font-size: 0.68rem; font-weight: 700; text-transform: capitalize;
}
.mt-meta {
  display: flex; flex-wrap: wrap; gap: 2px 14px;
  font-size: 0.78rem; color: var(--color-text-secondary);
}
.mt-meta > span { display: inline-flex; align-items: center; gap: 4px; }
.mt-gaps { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 2px; }
.mt-when {
  flex: none; font-size: 0.78rem; font-weight: 600; color: var(--color-text-light);
  white-space: nowrap; padding-left: 8px;
}
.mt-actions { display: flex; align-items: center; gap: 6px; flex: none; }
.mt-icon-btn {
  display: grid; place-items: center; width: 30px; height: 30px;
  border: none; border-radius: var(--radius); background: transparent;
  color: var(--color-text-light); cursor: pointer;
  transition: background var(--transition), color var(--transition);
}
.mt-icon-btn:hover { background: var(--color-surface-hover); color: var(--color-text); }
.mt-icon-btn.is-danger:hover { background: var(--color-error-bg, var(--color-surface-hover)); color: var(--color-error); }
.mt-icon-btn:disabled { cursor: default; opacity: 0.6; }

/* ── Meeting detail ──────────────────────────────────────────────────── */
.md-summary {
  margin: 8px 0 0; font-size: 0.88rem; line-height: 1.55;
  color: var(--color-text-secondary); max-width: 72ch;
}
.md-live {
  display: inline-flex; align-items: center; gap: 6px;
  font-size: 0.74rem; font-weight: 700; letter-spacing: 0.04em;
  text-transform: uppercase; color: var(--color-success);
}
.md-live-dot {
  width: 7px; height: 7px; border-radius: 50%;
  background: var(--color-success); animation: md-pulse 1.8s ease-in-out infinite;
}
@keyframes md-pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.25; } }
@media (prefers-reduced-motion: reduce) { .md-live-dot { animation: none; } }
/* Static tiles reuse the board hero's stat styling without its click affordance. */
/* Static tiles pass already-formatted text ("in 3 days", "Live now"), so the
   title-casing the board hero applies to raw enum values must not apply here. */
.bd-stat.as-static { cursor: default; }
.bd-stat.as-static .bd-stat-text { text-transform: none; }
.bd-stat.as-static:hover { border-color: var(--color-border-light); background: var(--color-bg); }
.md-workspace { margin-top: 20px; }

@media (max-width: 700px) {
  .mt-row { flex-wrap: wrap; }
  .mt-when { display: none; }
  .mt-actions { margin-left: auto; }
}

/* ── Public HCP form (/form/:token) ────────────────────────────────────
   The only screen people outside the account see, so it carries the mark
   and reads as a document rather than an app view. */
.pf-page { min-height: 100vh; background: var(--color-bg); display: flex; flex-direction: column; }
.pf-bar {
  display: flex; align-items: center; justify-content: space-between; gap: 12;
  padding: 14px 24px; border-bottom: 1px solid var(--color-border-light);
  background: var(--color-surface);
}
.pf-main { width: 100%; max-width: 1080px; margin: 0 auto; padding: 32px 24px 120px; flex: 1 1 auto; }
.pf-main.is-narrow { max-width: 460px; display: grid; place-items: center; }

.pf-head { text-align: center; margin-bottom: 24px; }
.pf-head h1 { margin: 0 0 8px; font-size: 1.6rem; line-height: 1.25; }
.pf-head p { margin: 0 auto; max-width: 58ch; color: var(--color-text-secondary); line-height: 1.6; }
.pf-alert { margin-bottom: 18px; }

/* CV dropzone — horizontal, so it can never stretch into a tall empty column
   beside the form the way the old two-column layout did. */
.pf-cv {
  display: flex; align-items: center; gap: 14px;
  padding: 16px 18px; margin-bottom: 20px;
  border: 1.5px dashed var(--color-border-strong); border-radius: var(--radius-lg, 12px);
  background: var(--color-surface); cursor: pointer;
  transition: border-color var(--transition), background var(--transition);
}
.pf-cv:hover, .pf-cv:focus-visible { border-color: var(--color-primary); background: var(--color-primary-bg); }
.pf-cv.has-file { border-style: solid; border-color: var(--color-primary); background: var(--color-primary-bg); }
.pf-cv.is-busy { cursor: progress; }
.pf-cv-icon {
  flex: none; width: 44px; height: 44px; border-radius: 50%;
  display: grid; place-items: center;
  background: var(--color-primary-bg); color: var(--color-primary-dark);
}
.pf-cv.has-file .pf-cv-icon { background: var(--color-surface); color: var(--color-success); }
.pf-cv-copy { display: flex; flex-direction: column; gap: 2px; min-width: 0; flex: 1 1 auto; }
.pf-cv-copy strong { font-size: 0.92rem; overflow-wrap: anywhere; }
.pf-cv-copy span { font-size: 0.8rem; color: var(--color-text-secondary); line-height: 1.5; }
.pf-cv-clear {
  flex: none; border: none; background: none; cursor: pointer;
  color: var(--color-text-light); padding: 4px; border-radius: var(--radius);
}
.pf-cv-clear:hover { color: var(--color-error); background: var(--color-surface); }

.pf-section { padding: 20px; margin-bottom: 16px; }
.pf-section-title {
  display: flex; align-items: center; gap: 8px;
  margin: 0 0 16px; font-size: 1rem; font-weight: 700;
}
.pf-section-title svg { color: var(--color-primary); }
.pf-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 14px 16px; }
/* Column counts are set per section to match the number of fields — auto-fit
   alone laid the four "About you" inputs out 3 + 1, leaving a two-slot hole. */
.pf-grid.is-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
/* Two-up on a wide screen so the extra width is used rather than left as
   margin; the odd last field spans both so it does not sit alone. */
.pf-grid.is-wide { grid-template-columns: repeat(auto-fit, minmax(320px, 1fr)); }
.pf-grid.is-wide > .pf-field:last-child:nth-child(odd) { grid-column: 1 / -1; }
.pf-field { display: flex; flex-direction: column; gap: 5px; min-width: 0; }
.pf-field label {
  display: flex; align-items: center; gap: 6px;
  font-size: 0.84rem; font-weight: 600; color: var(--color-text-secondary);
}
.pf-field label svg { color: var(--color-text-light); flex: none; }
.pf-field textarea { resize: vertical; }

.pf-submit {
  position: sticky; bottom: 16px; z-index: 5;
  display: flex; align-items: center; justify-content: space-between; gap: 14px;
  padding: 12px 16px; border-radius: var(--radius-lg, 12px);
  border: 1px solid var(--color-border); background: var(--color-surface);
  box-shadow: var(--shadow-lg, 0 8px 24px rgba(0, 0, 0, 0.1));
}
.pf-submit-status { font-size: 0.82rem; color: var(--color-text-secondary); min-width: 0; }

.pf-state { text-align: center; padding: 48px 8px; }
.pf-state h2 { margin: 14px 0 8px; font-size: 1.25rem; }
.pf-state p { margin: 0; color: var(--color-text-secondary); line-height: 1.6; }
.pf-state-note { margin-top: 10px !important; font-size: 0.85rem; color: var(--color-text-light) !important; }
.pf-state-icon {
  display: inline-grid; place-items: center; width: 56px; height: 56px; border-radius: 50%;
}
.pf-state-icon.is-success { background: var(--color-primary-bg); color: var(--color-success); }
.pf-state-icon.is-error { background: var(--color-surface-raised); color: var(--color-error); }

.pf-foot {
  padding: 18px 24px 26px; text-align: center;
  font-size: 0.78rem; color: var(--color-text-light);
  border-top: 1px solid var(--color-border-light);
}

@media (max-width: 640px) {
  .pf-grid.is-2 { grid-template-columns: minmax(0, 1fr); }
}
@media (max-width: 560px) {
  .pf-main { padding: 22px 14px 120px; }
  .pf-head h1 { font-size: 1.3rem; }
  .pf-cv { flex-wrap: wrap; }
  .pf-submit { flex-direction: column; align-items: stretch; gap: 8px; }
  .pf-submit .btn { justify-content: center; }
}

/* Form Link tab — submission queue tools sit in the card header. */
/* One row: no internal wrapping, and the search shrinks instead — wrapping
   put the field on its own line and left the header visibly lopsided. */
.fl-tools { display: flex; align-items: center; gap: 10px; margin-left: auto; flex-wrap: nowrap; min-width: 0; }
.fl-search { min-width: 0; flex: 0 1 240px; }
.fl-search input { min-width: 0; }
@media (max-width: 860px) {
  /* Below this the header genuinely cannot hold both, so it becomes two rows
     with the tools spanning the full width. */
  .fl-head { flex-wrap: wrap; row-gap: 12px; }
  .fl-tools { width: 100%; margin-left: 0; }
  .fl-search { flex: 1 1 auto; }
}
@media (max-width: 560px) {
  .fl-tools { flex-wrap: wrap; }
  .filter-pills { flex-wrap: wrap; }
}

/* Form Link rows — the URL is the point of the row, so it gets its own line
   at full width instead of being truncated into uselessness. */
.fl-link { padding: 14px 20px; }
.fl-link-top { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; }
.fl-state {
  display: inline-flex; align-items: center; gap: 6px; flex: none;
  font-size: 0.72rem; font-weight: 700; letter-spacing: 0.03em;
  text-transform: uppercase; color: var(--color-text-light);
}
.fl-state.is-on { color: var(--color-success); }
.fl-dot { width: 7px; height: 7px; border-radius: 50%; background: currentColor; }
.fl-link-title { font-weight: 600; font-size: 0.95rem; min-width: 0; overflow-wrap: anywhere; }
.fl-link-meta { font-size: 0.8rem; color: var(--color-text-secondary); }
.fl-link-actions { display: flex; align-items: center; gap: 2px; margin-left: auto; flex: none; }
.fl-danger:hover { color: var(--color-error); }

.fl-url { display: flex; align-items: center; gap: 8px; margin-top: 10px; }
.fl-url-input {
  flex: 1 1 auto; min-width: 0;
  padding: 7px 10px; border-radius: var(--radius);
  border: 1px solid var(--color-border-light); background: var(--color-bg);
  font-family: var(--font-mono, ui-monospace, SFMono-Regular, Menlo, monospace);
  font-size: 0.78rem; color: var(--color-text-secondary);
  text-overflow: ellipsis;
}
.fl-url-input:focus { outline: 2px solid var(--color-primary); outline-offset: 1px; }

/* Compact and actionable — a one-line message did not need 300px of card. */
.fl-empty {
  display: flex; align-items: center; gap: 14px;
  padding: 20px; color: var(--color-text-secondary);
}
.fl-empty > svg { flex: none; color: var(--color-text-light); }
.fl-empty > div { display: flex; flex-direction: column; gap: 2px; min-width: 0; flex: 1 1 auto; }
.fl-empty strong { color: var(--color-text); font-size: 0.92rem; }
.fl-empty span { font-size: 0.83rem; line-height: 1.5; }

@media (max-width: 640px) {
  .fl-link-actions { margin-left: 0; width: 100%; }
  .fl-empty { flex-wrap: wrap; }
}

/* Submission backlog notice + per-row waiting age. */
.fl-backlog {
  display: flex; align-items: center; gap: 12px; flex-wrap: wrap;
  padding: 12px 16px; margin-bottom: 16px; border-radius: var(--radius);
  border: 1px solid var(--color-warning, #C77700);
  background: var(--color-warning-bg, var(--color-surface-raised));
  color: var(--color-warning-text, var(--color-text));
  font-size: 0.86rem;
}
.fl-backlog > svg { flex: none; }
.fl-backlog > span { flex: 1 1 auto; min-width: 0; }
.fl-waiting {
  font-size: 0.72rem; font-weight: 700; padding: 1px 7px; border-radius: 999px;
  background: var(--color-warning-bg, var(--color-surface-raised));
  color: var(--color-warning-text, var(--color-text-secondary));
}

/* Derived "current post" on /hcp/new — read-only, filled from the faculty row
   marked current rather than asked for a second time. */
.current-post {
  display: flex; flex-direction: column; gap: 2px;
  padding: 9px 12px; border-radius: var(--radius);
  border: 1px dashed var(--color-border); background: var(--color-bg);
  font-size: 0.86rem; color: var(--color-text-light); min-height: 40px;
  justify-content: center;
}
.current-post.is-set { border-style: solid; background: var(--color-surface); }
.current-post strong { color: var(--color-text); font-weight: 600; }
.current-post > span { color: var(--color-text-secondary); font-size: 0.8rem; line-height: 1.5; }

/* ── Account → KOL Tiers ─────────────────────────────────────────────── */
.tier-head { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; margin-bottom: 16px; flex-wrap: wrap; }
.tier-title { display: flex; align-items: center; gap: 8px; margin: 0 0 4px; font-size: 1.05rem; }
.tier-title svg { color: var(--color-primary); }
.tier-sub { margin: 0; font-size: 0.85rem; color: var(--color-text-secondary); max-width: 62ch; line-height: 1.55; }
.card.tier-card { padding: 0; overflow-x: auto; }
/* Explicit colour: something upstream gives tables an inverse text colour, so
   inheriting here put near-white text (--color-bg) on a white card. */
.tier-table { width: 100%; border-collapse: collapse; font-size: 0.88rem; color: var(--color-text); }
.tier-table td { color: var(--color-text); }
.tier-table th {
  text-align: left; padding: 11px 16px; font-size: 0.72rem; font-weight: 700;
  letter-spacing: 0.05em; text-transform: uppercase; color: var(--color-text-light);
  border-bottom: 1px solid var(--color-border-light); background: var(--color-bg);
  white-space: nowrap;
}
.tier-table td { padding: 12px 16px; border-bottom: 1px solid var(--color-border-light); vertical-align: middle; }
.tier-table tr:last-child td { border-bottom: none; }
.tier-table tr.is-off { opacity: 0.55; }
.tier-name { font-weight: 600; color: var(--color-text); }
.tier-code {
  display: block; margin-top: 2px; font-size: 0.7rem; color: var(--color-text-light);
  font-family: var(--font-mono, ui-monospace, SFMono-Regular, Menlo, monospace);
}
.tier-range-cell { white-space: nowrap; font-variant-numeric: tabular-nums; color: var(--color-text); }
.tier-swatch { display: inline-block; width: 22px; height: 22px; border-radius: 6px; border: 1px solid var(--color-border-light); }
.tier-pill {
  border: 1px solid var(--color-border); background: var(--color-bg);
  color: var(--color-text-secondary); border-radius: 999px;
  padding: 3px 11px; font-size: 0.75rem; font-weight: 600; cursor: pointer;
}
.tier-pill.is-on { border-color: transparent; background: var(--color-primary-bg); color: var(--color-primary-dark); }
.tier-actions { display: flex; gap: 4px; justify-content: flex-end; }
.tier-danger:hover:not(:disabled) { color: var(--color-error); }
.tier-actions .btn:disabled { opacity: 0.35; cursor: not-allowed; }
.tier-editor td { background: var(--color-primary-bg); }
.tier-editor .tier-range { display: flex; align-items: center; gap: 6px; }
.tier-editor .tier-range .form-control { width: 88px; }
.tier-hint { font-size: 0.72rem; color: var(--color-text-light); margin-top: 4px; }
.tier-color-input { width: 44px; height: 32px; padding: 2px; border: 1px solid var(--color-border); border-radius: var(--radius); background: var(--color-surface); cursor: pointer; }
.tier-active { display: inline-flex; align-items: center; gap: 6px; font-size: 0.85rem; }
.tier-gap { display: flex; align-items: flex-start; gap: 10px; line-height: 1.55; }
.tier-gap svg { flex: none; margin-top: 2px; }

/* Brand mark in the rail. The full logo carries its own sphere, so the
   standalone mark would be a duplicate beside it — it appears only when the
   rail collapses and the wordmark is hidden, leaving the brand with nothing. */
.logo-mark { display: block; }
.sidebar-brand-mark { display: none; }
.sidebar.is-collapsed .sidebar-brand-mark { display: block; }
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD,kCAAkC;AAClC;EACE,mBAAmB;;EAEnB;;;yEAGuE;EACvE,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;;EAEpB;;;uEAGqE;EACrE,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,iCAAiC;EACjC,0BAA0B;EAC1B,uBAAuB;EACvB,qBAAqB;;EAErB,iBAAiB;EACjB,wBAAwB;EACxB,2BAA2B;EAC3B,6BAA6B;EAC7B,wBAAwB;EACxB,2BAA2B;EAC3B,6BAA6B;EAC7B,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;EACxB,0BAA0B;;EAE1B;;;;6EAI2E;EAC3E,uBAAuB;EACvB,0BAA0B;EAC1B,qBAAqB;EACrB,wBAAwB;;EAExB,uDAAuD;EACvD,qBAAqB;EACrB,+BAA+B;EAC/B,2BAA2B;EAC3B,6BAA6B;;EAE7B;;;+CAG6C;EAC7C,mBAAmB;EACnB,wBAAwB;EACxB,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,qCAAqC;EACrC,sBAAsB;;EAEtB,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,2CAA2C;;EAE3C;yDACuD;EACvD,2EAA2E;EAC3E,wEAAwE;EACxE,4EAA4E;EAC5E,8EAA8E;EAC9E,8EAA8E;;EAE9E,gFAAgF;EAChF,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;;EAEpB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;;EAEnB,eAAe;EACf,uGAAuG;EACvG,0FAA0F;;EAE1F,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;;EAElB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;;EAErB;;0DAEwD;EACxD,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;EACpB,0BAA0B;;EAE1B,sCAAsC;EACtC,kDAAkD;EAClD,uDAAuD;AACzD;;AAEA;;;;;;4EAM4E;AAC5E;EACE,kBAAkB;;EAElB,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,iCAAiC;EACjC,0BAA0B;EAC1B,uBAAuB;EACvB,qBAAqB;;EAErB,wBAAwB;EACxB,2BAA2B;EAC3B,6BAA6B;EAC7B,wBAAwB;EACxB,2BAA2B;EAC3B,6BAA6B;EAC7B,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;EACxB,0BAA0B;;EAE1B,uBAAuB;EACvB,0BAA0B;EAC1B,qBAAqB;EACrB,wBAAwB;;EAExB,qBAAqB;EACrB,+BAA+B;EAC/B,2BAA2B;EAC3B,6BAA6B;;EAE7B,mBAAmB;EACnB,wBAAwB;EACxB,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,oCAAoC;EACpC,sBAAsB;;EAEtB,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,2CAA2C;;EAE3C;wDACsD;EACtD,yCAAyC;EACzC,qEAAqE;EACrE,yEAAyE;EACzE,2EAA2E;EAC3E,4EAA4E;AAC9E;;AAEA,yBAAyB;AACzB;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,iCAAiC;EACjC,2BAA2B;EAC3B,kCAAkC;EAClC,oCAAoC;EACpC,iBAAiB;EACjB,wEAAwE;EACxE,iFAAiF;AACnF;;AAEA;qEACqE;AACrE;EACE,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;;iFAEiF;AACjF,KAAK,0BAA0B,EAAE,qCAAqC,EAAE;AACxE,KAAK,0BAA0B,EAAE,qCAAqC,EAAE;AACxE,KAAK,yBAAyB,EAAE,oCAAoC,EAAE;AACtE,KAAK,yBAAyB,EAAE,oCAAoC,EAAE,gBAAgB,EAAE;AACxF,KAAK,yBAAyB,EAAE,oCAAoC,EAAE,gBAAgB,EAAE;AACxF,KAAK,2BAA2B,EAAE,sCAAsC,EAAE,gBAAgB,EAAE;;AAE5F;6DAC6D;AAC7D,IAAI,iBAAiB,EAAE;;AAEvB;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;mCACmC;AACnC;EACE,uCAAuC;EACvC,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE;IACE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;IACtC,gCAAgC;EAClC;AACF;;AAEA,MAAM,eAAe,EAAE,YAAY,EAAE;;AAErC,mBAAmB;AACnB;EACE,iBAAiB;EACjB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE;sDACoD;EACpD,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE;IACE,yCAAyC;IACzC,4BAA4B;EAC9B;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;oCAEoC;AACpC;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,0BAA0B;AAC5B;;AAEA,QAAQ,aAAa,EAAE;AACvB,YAAY,sBAAsB,EAAE;AACpC,gBAAgB,mBAAmB,EAAE;AACrC,mBAAmB,8BAA8B,EAAE;AACnD,UAAU,sBAAsB,EAAE;AAClC,UAAU,sBAAsB,EAAE;AAClC,UAAU,sBAAsB,EAAE;AAClC,eAAe,kBAAkB,EAAE;;AAEnC,mBAAmB;AACnB;;iDAEiD;AACjD;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB;;mCAEiC;EACjC,8DAA8D;EAC9D,8CAA8C;AAChD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,SAAO;AACT;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV;;0BAEwB;EACxB,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,mFAAmF;EACnF,4BAA4B;EAC5B,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,qCAAqC;EACrC,+BAA+B;EAC/B,gCAAgC;EAChC,kCAAkC;EAClC,eAAe;EACf,iGAAiG;AACnG;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,mEAAmE;AACnE,iBAAiB,aAAa,EAAE;;AAEhC;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,gCAAgC;EAChC,qCAAqC;EACrC,kCAAkC;EAClC,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;6BAG6B;AAC7B;EACE,aAAa;EACb,2CAA2C;EAC3C,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,0BAA0B;EAC1B,8DAA8D;EAC9D,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,gDAAgD;AAClD;;AAEA,oCAAoC,8BAA8B,EAAE;;AAEpE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iEAAiE;AACnE;;AAEA,oBAAoB,UAAU,EAAE;;AAEhC;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;qDACmD;EACnD;IACE,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA,wBAAwB,aAAa,EAAE;;EAEvC,gBAAgB,mBAAmB,EAAE,WAAW,EAAE;AACpD;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;EACV,mCAAmC;AACrC;;AAEA,yBAAyB,gCAAgC,EAAE;;AAE3D;EACE,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA,yBAAyB,gCAAgC,EAAE;;AAE3D;EACE,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,2CAA2C;EAC3C,YAAY;EACZ,0EAA0E;AAC5E;;AAEA;EACE,iCAAiC;AACnC;;AAEA;oCACoC;AACpC;EACE,UAAU;EACV,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,kDAAkD;EAClD,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;EAC3B,oCAAoC;EACpC,wBAAwB;EACxB;mEACiE;EACjE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,kCAAkC;EAClC,eAAe;AACjB;;AAEA;yEACyE;AACzE;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;kDACkD;AAClD;EACE,8CAA8C;EAC9C,6CAA6C;EAC7C,+CAA+C;AACjD;;AAEA;EACE;;0EAEwE;EACxE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,iCAAiC;EACjC,uCAAuC;EACvC,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB;;4DAE0D;EAC1D,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,+BAA+B;EAC/B,4BAA4B;EAC5B,kCAAkC;EAClC,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB;;qCAEmC;EACnC,YAAY;EACZ;qEACmE;EACnE,WAAW;EACX,iEAAiE;AACnE;;AAEA;;;oDAGoD;AACpD;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA,oBAAoB,UAAU,EAAE;;AAEhC;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;iDACiD;AACjD;EACE,mCAAmC;EACnC,6EAA6E;EAC7E,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,0BAA0B;EAC1B,qCAAqC;AACvC;;;;;;;;;;;AAWA,2DAA2D;AAC3D;;EAEE,uBAAuB;EACvB,+BAA+B;EAC/B,gCAAgC;EAChC,MAAM;AACR;;;AAGA,oCAAoC;AACpC;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,cAAc;EACd,iCAAiC;EACjC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iCAAiC;EACjC,uCAAuC;EACvC,qCAAqC;EACrC,wEAAwE;AAC1E;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,gCAAgC;EAChC,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;EACxB,mGAAmG;AACrG;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;6BAC6B;AAC7B;EACE,eAAe;EACf,sBAAsB;EACtB,wBAAwB;EACxB,YAAY;AACd;;AAEA,kFAAkF;AAClF;EACE;;IAEE,cAAc;EAChB;;EAEA,mBAAmB,aAAa,EAAE;EAClC,iBAAiB,oBAAoB,EAAE;;EAEvC;IACE,8DAA8D;EAChE;;EAEA,iEAAiE;EACjE,mBAAmB,aAAa,EAAE;;EAElC;IACE,uBAAuB;IACvB,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA,mBAAmB,wBAAwB,EAAE;;EAE7C;sCACoC;EACpC,wBAAwB,uBAAuB,EAAE;EACjD,uCAAuC,UAAU,EAAE,WAAW,EAAE;EAChE;;IAEE,2BAA2B;IAC3B,+BAA+B;IAC/B,gCAAgC;IAChC,sBAAsB;EACxB;;EAEA,iBAAiB,oBAAoB,EAAE;AACzC;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,oCAAoC;EACpC,6BAA6B;EAC7B,6BAA6B;EAC7B,0CAA0C;EAC1C,iCAAiC;EACjC,eAAe;EACf,iCAAiC;EACjC,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;oEACoE;AACpE;EACE,kCAAkC;EAClC,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,cAAc;EACd,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4CAA4C;EAC5C,kDAAkD;EAClD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sEAAsE;AACtE;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA,iCAAiC,aAAa,EAAE;;AAEhD;;;;yDAIyD;AACzD;EACE,aAAa;EACb;yEACuE;EACvE,4DAA4D;EAC5D,sBAAsB;EACtB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,8DAA8D;EAC9D,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,qGAAqG;AACvG;;AAEA;gDACgD;AAChD;EACE,wCAAwC;EACxC,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA,4BAA4B,WAAW,EAAE,YAAY,EAAE;;AAEvD;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,qCAAqC;EACrC,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mEAAmE;EACnE,mBAAmB;EACnB,SAAS;EACT;;iCAE+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,gCAAgC,mCAAmC,EAAE,gCAAgC,EAAE;AACvG,gCAAgC,mCAAmC,EAAE,gCAAgC,EAAE;AACvG,gCAAgC,mCAAmC,EAAE,gCAAgC,EAAE;AACvG,6BAA6B,gCAAgC,EAAE,6BAA6B,EAAE;AAC9F,+BAA+B,kCAAkC,EAAE,0BAA0B,EAAE;AAC/F,6BAA6B,gCAAgC,EAAE,wBAAwB,EAAE;;AAEzF,kBAAkB;AAClB;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;;;;;;;;EAQE,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,6BAA6B;EAC7B,qCAAqC;EACrC,4BAA4B;EAC5B;;;yEAGuE;EACvE,sCAAsC;EACtC,wBAAwB;EACxB,4GAA4G;EAC5G,aAAa;AACf;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;;;;EAIE,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;;;;EAIE,6CAA6C;EAC7C,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;;6DAG6D;AAC7D;;;;;EAKE,0CAA0C;EAE1C,mDAAmD;EACnD,8BAA8B;EAC9B,2DAAmD;EAAnD,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yDAAkP;EAClP,4BAA4B;EAC5B,sCAAsC;EACtC,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,8EAA8E;AAC9E;EACE,yDAAkP;AACpP;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,4CAA4C;EAC5C,qCAAqC;EACrC,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;EAClC,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;AACrC;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA,mBAAmB;AACnB;EACE,4CAA4C;EAC5C,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,QAAQ;EACR;4DAC0D;EAC1D,gCAAgC;EAChC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB;gFAC8E;EAC9E,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,8DAA8D;EAC9D,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,UAAU;AACZ;;AAEA;;;EAGE,yBAAyB;EACzB,oCAAoC;EACpC,SAAS;AACX;;AAEA,gEAAgE;AAChE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,iEAAiE;AACnE;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,8CAA8C;EAC9C,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,4CAA4C;EAC5C,+CAA+C;EAC/C,uCAAuC;EACvC,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;wEACwE;AACxE;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,oDAAoD;IACpD,mBAAmB;IACnB,oCAAoC;EACtC;;EAEA;IACE,SAAO;EACT;AACF;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,wBAAwB,EAAE;AACjC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,2DAA2D;EAC3D,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,sBAAsB;EACtB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,sCAAsC;EACtC,kBAAkB;EAClB,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA,yBAAyB;AACzB;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4CAA4C;EAC5C,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,gCAAgC;EAChC,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,6CAA6C;EAC7C,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6CAA6C;EAC7C,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,6CAA6C;EAC7C,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,4DAA4D;EAC5D,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,gCAAgC;EAChC,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,6CAA6C;EAC7C,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,gCAAgC;EAChC,iCAAiC;EACjC,gDAAgD;AAClD;;AAEA,wBAAwB;AACxB;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,gCAAgC;AAChC;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,iBAAiB;EACjB,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,8BAA8B;EAC9B,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,gCAAgC;EAChC,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,4CAA4C;EAC5C,2BAA2B;EAC3B,qCAAqC;EACrC,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,gBAAgB;EAChB,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,4BAA4B;EAC5B,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA,uBAAuB;AACvB;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,6BAA6B,EAAE;AACvC;;AAEA,uBAAuB;AACvB;EACE;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;;EAGA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,KAAK,kBAAkB,EAAE;EACzB,KAAK,iBAAiB,EAAE;;EAExB,WAAW,kBAAkB,EAAE;EAC/B,QAAQ,oCAAoC,EAAE;;EAE9C;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;2EACyE;EACzE;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,sBAAsB;IACtB,oBAAoB;IACpB,sBAAsB;IACtB,8DAA8D;IAC9D,gCAAgC;IAChC,4CAA4C;IAC5C,4BAA4B;IAC5B,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;4CAC0C;EAC1C;IACE,aAAa;EACf;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,WAAW,kBAAkB,EAAE;;EAE/B;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;;iDAEiD;;;;;AAKjD;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,gCAAgC;EAChC,iCAAiC;EACjC,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;EAClC,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,SAAS;EACX;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;;iDAEiD;;AAEjD;;;;;;2CAM2C;AAC3C;EACE,gBAAgB;AAClB;;AAEA;sCACsC;AACtC;;;EAGE,uBAAuB;AACzB;;AAEA;EACE;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE;;gFAE8E;EAC9E;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;uEACqE;EACrE;IACE,sBAAsB;IACtB,+BAA+B;IAC/B,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;;;;qEAImE;EACnE;IACE,qCAAqC;EACvC;;EAEA,KAAK,0BAA0B,EAAE;EACjC,KAAK,yBAAyB,EAAE;EAChC,KAAK,yBAAyB,EAAE;;EAEhC;;IAEE,0BAA0B;EAC5B;;EAEA,qEAAqE;EACrE;IACE,WAAW;EACb;AACF;;AAEA,2CAA2C;AAC3C;EACE,8DAA8D;EAC9D,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,qBAAqB,2BAA2B,EAAE;;AAElD,WAAW,aAAa,EAAE,sBAAsB,EAAE;;AAElD;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,kDAAkD;AACpD;;AAEA,qBAAqB,mBAAmB,EAAE;;AAE1C,eAAe,SAAO,EAAE,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE;;AAE7E;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,uEAAuE;AACvE;EACE,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,yBAAyB,gCAAgC,EAAE;;AAE3D;EACE,aAAa;EACb;oDACkD;EAClD,2DAA2D;EAC3D,sBAAsB;EACtB,gCAAgC;EAChC;4EAC0E;EAC1E,oBAAoB;AACtB;;AAEA;EACE,8DAA8D;EAC9D,aAAa;EACb,sBAAsB;AACxB;;AAEA;oDACoD;AACpD;;;EAGE,SAAO;EACP,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,oBAAoB,2BAA2B,EAAE;;AAEjD;;6BAE6B;AAC7B;EACE;0DACwD;EACxD,2DAA2D;EAC3D,QAAQ;AACV;;AAEA,4BAA4B,gBAAgB,EAAE;;AAE9C,4BAA4B,yBAAyB,EAAE;;AAEvD,wEAAwE;AACxE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA,iCAAiC,6BAA6B,EAAE;;AAEhE;EACE,yBAAyB;EACzB,8BAA8B;EAC9B;oBACkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA,gBAAgB;AAChB,eAAe,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,iBAAiB,EAAE;;AAEnF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;;AAEA,iCAAiC,gCAAgC,EAAE;;AAEnE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iCAAiC;EACjC,uCAAuC;EACvC,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iFAAiF;AACjF,sBAAsB,mCAAmC,EAAE,gCAAgC,EAAE;AAC7F,sBAAsB,sCAAsC,EAAE,wBAAwB,EAAE;AACxF,sBAAsB,mCAAmC,EAAE,gCAAgC,EAAE;;AAE7F,eAAe,SAAO,EAAE,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAEvF;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kCAAkC;EAClC,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;+DAC+D;AAC/D;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,uCAAuC;EACvC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,oDAAoD;EACpD,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;;AAEA,kCAAkC,wBAAwB,EAAE;AAC5D,sCAAsC,gCAAgC,EAAE,gBAAgB,EAAE;AAC1F,qCAAqC,qCAAqC,EAAE;;AAE5E,4BAA4B;AAC5B;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,sCAAsC;EACtC,iCAAiC;EACjC,mCAAmC;EACnC,gCAAgC;EAChC,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,wEAAwE;AAC1E;;AAEA,mBAAmB,uCAAuC,EAAE;;AAE5D;EACE,qCAAqC;EACrC,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA,oBAAoB,kCAAkC,EAAE;;AAExD,kCAAkC;AAClC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iCAAiC;EACjC,uCAAuC;EACvC,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB;kDACgD;EAChD,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,UAAU;AACZ;;AAEA,mDAAmD;AACnD;0CAC0C;AAC1C,qBAAqB,6BAA6B,EAAE;AACpD,qBAAqB,6BAA6B,EAAE;AACpD,qBAAqB,gCAAgC,EAAE;AACvD,qBAAqB,gCAAgC,EAAE;AACvD,qBAAqB,gCAAgC,EAAE;AACvD,qBAAqB,mCAAmC,EAAE;;AAE1D;EACE,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iCAAiC;EACjC,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA,gBAAgB,cAAc,EAAE;;AAEhC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;sCACsC;AACtC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qCAAqC;EACrC,iCAAiC;EACjC,gCAAgC;EAChC,kCAAkC;EAClC,oBAAoB;EACpB,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,iGAAiG;AACnG;;AAEA,sBAAsB,wCAAwC,EAAE,wBAAwB,EAAE;;AAE1F;EACE,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA,uBAAuB,kCAAkC,EAAE;;AAE3D;EACE,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA,+BAA+B,kBAAkB,EAAE;;AAEnD;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;EAChC,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE;qCACmC;EACnC;;IAEE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,uCAAuC;EACvC,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gCAAgC;EAChC,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,iBAAiB;AACnB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,4BAA4B;EAC5B,gCAAgC;EAChC,wBAAwB;EACxB,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;EACrB,wEAAwE;AAC1E;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,+BAA+B;EAC/B,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,+DAA+D;AAC/D;EACE,iBAAiB;EACjB,UAAU;EACV,UAAU;EACV,2BAA2B;EAC3B,kEAAkE;AACpE;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,6CAA6C;EAC7C,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,uCAAuC;EACvC,kCAAkC;EAClC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,kDAAkD;EAClD,cAAc;EACd,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA,uBAAuB,mBAAmB,EAAE;;AAE5C;EACE,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;EAClC,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,iCAAiC;EACjC,mCAAmC;EACnC,gCAAgC;EAChC,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE;gCAC8B;EAC9B,aAAa,aAAa,EAAE;AAC9B;;AAEA,6DAA6D;AAC7D;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,6CAA6C;EAC7C,kBAAkB;EAClB,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,+BAA+B;EAC/B,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,iCAAiC;EACjC,mCAAmC;EACnC,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,kEAAkE;EAClE;IACE,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAO;EACT;AACF;;AAEA;;;;sCAIsC;AACtC;EACE;IACE,qCAAqC;IACrC,mBAAmB;IACnB,iCAAiC;IACjC,6CAA6C;EAC/C;;EAEA;wEACsE;EACtE;IACE,iBAAiB;EACnB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,MAAM;EACN,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,4CAA4C;EAC5C,+BAA+B;EAC/B,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,+BAA+B;EAC/B,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;;iDAEiD;AACjD;;;;sEAIsE;AACtE;;EAEE,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,gEAAgE;AAChE,0CAA0C,mCAAmC,EAAE;AAC/E;kDACkD,iCAAiC,EAAE;AACrF,0CAA0C,kCAAkC,EAAE;;AAE9E;;;2EAG2E,4BAA4B,EAAE;;AAEzG;;0EAE0E,0BAA0B,EAAE;;AAEtG;;;;sEAIsE,2BAA2B,EAAE;;AAEnG,6EAA6E;AAC7E;EACE,uCAAuC;EACvC,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA,kBAAkB;AAClB;EACE,uCAAuC;EACvC,wCAAwC;EACxC,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;;iCAEiC,2BAA2B,EAAE;;AAE9D;EACE,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;;AAEA;;iDAEiD;AACjD;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,6BAA6B;EAC/B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;;iDAEiD;;AAEjD;;;;;uDAKuD;AACvD;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;;AAEA;kEACkE;AAClE;EACE,WAAW,UAAU,EAAE;EACvB,WAAW,aAAa,EAAE;AAC5B;;AAEA;;;;mCAImC;AACnC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;;;4EAG4E;AAC5E,qBAAqB,aAAa,EAAE;AACpC,0CAA0C,aAAa,EAAE;AACzD,yCAAyC,cAAc,EAAE;;;AAGzD,wFAAwF;AACxF;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA,sCAAsC,sCAAsC,EAAE;AAC9E,yCAAyC,gCAAgC,EAAE;;AAE3E;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,6EAA6E;AAC7E;EACE,oBAAoB,aAAa,EAAE;AACrC;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iCAAiC;EACjC,mCAAmC;EACnC,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;wEACwE;AACxE,WAAW,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB,EAAE,YAAY,EAAE;AAC5F,eAAe,8BAA8B,EAAE,UAAU,EAAE;AAC3D;EACE,kBAAkB,EAAE,kCAAkC,EAAE,gBAAgB;EACxE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB;AAChE;;AAEA,WAAW,kBAAkB,EAAE,mBAAmB,EAAE;AACpD,eAAe,aAAa,EAAE,8BAA8B,EAAE,uBAAuB,EAAE,SAAS,EAAE,eAAe,EAAE;AACnH,eAAe,YAAY,EAAE,eAAe,EAAE;AAC9C,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,kBAAkB,EAAE;AACnG,YAAY,SAAS,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;AAC9D,WAAW,iBAAiB,EAAE,oBAAoB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAC/G,WAAW,aAAa,EAAE,eAAe,EAAE,aAAa,EAAE,kBAAkB,EAAE,kCAAkC,EAAE;AAClH,kBAAkB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACvE,cAAc,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE,eAAe,EAAE;AAC7E;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,kBAAkB,EAAE,8BAA8B;AACpD;;AAEA,+DAA+D;AAC/D;EACE,aAAa,EAAE,2DAA2D;EAC1E,QAAQ,EAAE,gBAAgB;AAC5B;AACA;EACE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,uBAAuB;EACxE,kBAAkB,EAAE,2CAA2C,EAAE,4BAA4B;EAC7F,2BAA2B,EAAE,eAAe,EAAE,gBAAgB;EAC9D,wEAAwE;AAC1E;AACA,iBAAiB,kCAAkC,EAAE,mCAAmC,EAAE;AAC1F;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,iBAAiB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,yBAAyB;EACtF,8BAA8B;AAChC;AACA,iBAAiB,kBAAkB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,gBAAgB,EAAE;AACnG,gBAAgB,kBAAkB,EAAE,0BAA0B,EAAE;AAChE,cAAc,kBAAkB,EAAE,gBAAgB,EAAE,8BAA8B,EAAE;;AAEpF,gEAAgE;AAChE,aAAa,gBAAgB,EAAE,iBAAiB,EAAE,+CAA+C,EAAE;AACnG;EACE,aAAa,EAAE,qBAAqB,EAAE,8BAA8B;EACpE,QAAQ,EAAE,eAAe,EAAE,mBAAmB;AAChD;AACA,kBAAkB,kBAAkB,EAAE,8BAA8B,EAAE;AACtE;EACE,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB;EAC5D,yBAAyB,EAAE,8BAA8B;AAC3D;AACA,gBAAgB,aAAa,EAAE,QAAQ,EAAE;AACzC;EACE,SAAW,EAAE,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ;EAC1E,UAAU,EAAE,YAAY,EAAE,gBAAgB,EAAE,eAAe,EAAE,gBAAgB;AAC/E;AACA;EACE,cAAc,EAAE,WAAW,EAAE,oBAAoB;EACjD,qCAAqC,EAAE,wCAAwC;AACjF;AACA,+DAA+D,+BAA+B,EAAE;AAChG,iBAAiB,kBAAkB,EAAE,gBAAgB,EAAE,8BAA8B,EAAE;AACvF;EACE,iBAAiB,EAAE,gBAAgB,EAAE,kCAAkC;EACvE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB;AAChE;AACA,oCAAoC,wBAAwB,EAAE;AAC9D,uCAAuC,gBAAgB,EAAE;;AAEzD,qCAAqC;AACrC,WAAW,aAAa,EAAE,2CAA2C,EAAE,SAAS,EAAE,kBAAkB,EAAE;AACtG;;yEAEyE;AACzE,YAAY,+BAA+B,EAAE;;AAE7C;;;;2EAI2E;AAC3E;;2EAE2E;AAC3E,gBAAgB,gBAAgB,EAAE,SAAS,EAAE,oBAAoB,EAAE;AACnE;;8DAE8D;AAC9D;EACE,WAAW,EAAE,kBAAkB,EAAE,OAAO,EAAE,WAAW,EAAE,YAAY,EAAE,YAAY;EACjF,oEAAoE;EACpE,oBAAoB,EAAE,UAAU,EAAE,qCAAqC;AACzE;AACA,gCAAgC,UAAU,EAAE;AAC5C;0EAC0E;AAC1E;EACE,kBAAkB,EAAE,OAAO,EAAE,WAAW,EAAE,SAAS,EAAE,YAAY;EACjE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ;EACrE,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,yBAAyB;EACvF,gCAAgC,EAAE,oBAAoB;EACtD,UAAU,EAAE,qCAAqC;AACnD;AACA,uCAAuC,UAAU,EAAE;AACnD;EACE,aAAa,EAAE,sBAAsB,EAAE,SAAS;EAChD,2CAA2C;EAC3C,kBAAkB,EAAE,kBAAkB;EACtC,mBAAmB;EACnB,qBAAqB;EACrB,uEAAuE;EACvE,4BAA4B;AAC9B;AACA,8BAA8B,WAAW,EAA4B,gBAAgB,EAAE;AACvF;EACE,uCAAuC,EAAE,oBAAoB;AAC/D;AACA;EACE,sCAAsC,EAAE,oBAAoB;EAC5D,6CAA6C;AAC/C;AACA,0CAA0C,mCAAmC,EAAE;;AAE/E,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAClE;EACE,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,yBAAyB;EACvF,8BAA8B,EAAE,mBAAmB;AACrD;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,WAAW;EACzD,iBAAiB,EAAE,YAAY,EAAE,4BAA4B,EAAE,gBAAgB;EAC/E,kCAAkC,EAAE,kBAAkB,EAAE,gBAAgB;EACxE,eAAe,EAAE,gBAAgB,EAAE,iEAAiE;AACtG;AACA,sBAAsB,sCAAsC,EAAE,wBAAwB,EAAE;AACxF,0BAA0B,mCAAmC,EAAE,gCAAgC,EAAE,gBAAgB,EAAE;AACnH,oBAAoB,UAAU,EAAE;AAChC,iBAAiB,cAAc,EAAE,YAAY,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC/G;EACE,UAAU,EAAE,eAAe,EAAE,gBAAgB,EAAE,oBAAoB;EACnE,uCAAuC,EAAE,2CAA2C;EACpF,iBAAiB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,kCAAkC;AAC7F;AACA;EACE,gCAAgC,EAAE,yBAAyB,EAAE,gCAAgC;AAC/F;;AAEA,yDAAyD;AACzD,eAAe,aAAa,EAAE,uDAAuD,EAAE,SAAS,EAAE,kBAAkB,EAAE;AACtH,YAAY,aAAa,EAAE;AAC3B,YAAY,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAChE,gBAAgB,qBAAqB,EAAE;AACvC,YAAY,8BAA8B,EAAE,kBAAkB,EAAE;AAChE;EACE,aAAa,EAAE,2DAA2D,EAAE,SAAS;EACrF,gBAAgB,EAAE,iBAAiB,EAAE,+CAA+C;AACtF;AACA,WAAW,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,YAAY,EAAE;AAC7F,6BAA6B,uBAAuB,EAAE;AACtD,YAAY,gBAAgB,EAAE,iBAAiB,EAAE,+CAA+C,EAAE;;AAElG,gBAAgB,aAAa,EAAE;AAC/B,qBAAqB,aAAa,EAAE,qBAAqB,EAAE,8BAA8B,EAAE,QAAQ,EAAE;AACrG,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,wBAAwB,EAAE;AACnF;EACE,WAAW,EAAE,oBAAoB,EAAE,qCAAqC;EACxE,gBAAgB,EAAE,mBAAmB;AACvC;AACA,qBAAqB,cAAc,EAAE,YAAY,EAAE,gCAAgC,EAAE,mCAAmC,EAAE;AAC1H,aAAa,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACxG,YAAY,aAAa,EAAE,QAAQ,EAAE,uBAAuB,EAAE,8BAA8B,EAAE;AAC9F,kBAAkB,2BAA2B,EAAE;AAC/C,gBAAgB,UAAU,EAAE,eAAe,EAAE;AAC7C;EACE,YAAY,EAAE,gBAAgB,EAAE,UAAU,EAAE,eAAe;EAC3D,kBAAkB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,gBAAgB;AAClF;AACA,wBAAwB,gCAAgC,EAAE,0BAA0B,EAAE;AACtF,kCAAkC,kCAAkC,EAAE,gBAAgB,EAAE;AACxF,iBAAiB,kBAAkB,EAAE,8BAA8B,EAAE,eAAe,EAAE,iBAAiB,EAAE;;AAEzG;EACE,eAAe,qCAAqC,EAAE;AACxD;AACA;EACE;gFAC8E;EAC9E,WAAW,qCAAqC,EAAE,SAAS,EAAE;EAC7D,YAAY,aAAa,EAAE;EAC3B,gBAAgB,gBAAgB,EAAE,iBAAiB,EAAE;EACrD,sCAAsC,aAAa,EAAE;EACrD;IACE,mBAAmB,EAAE,QAAQ;IAC7B,gBAAgB,EAAE,kBAAkB,EAAE,gBAAgB;IACtD,gBAAgB,EAAE,mBAAmB;IACrC,kDAAkD;EACpD;EACA,8BAA8B,WAAW,EAAE,WAAW,EAAE;EACxD,iBAAiB,mBAAmB,EAAE,QAAQ,EAAE;EAChD,mBAAmB,aAAa,EAAE;EAClC,gBAAgB,WAAW,EAAE,mBAAmB,EAAE;EAClD,iBAAiB,aAAa,EAAE;AAClC;AACA;EACE,kBAAkB,iBAAiB,EAAE;EACrC,kBAAkB,aAAa,EAAE;AACnC;;AAEA,4DAA4D;AAC5D,UAAU,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,YAAY,EAAE;AAC1E,4BAA4B,aAAa,EAAE;AAC3C,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AACtF;EACE,aAAa,EAAE,8DAA8D;EAC7E,mBAAmB,EAAE,SAAS,EAAE,WAAW;EAC3C,YAAY,EAAE,gBAAgB,EAAE,UAAU,EAAE,eAAe,EAAE,gBAAgB;AAC/E;AACA;EACE,kBAAkB,EAAE,kCAAkC;EACtD,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB;AAChE;AACA,8CAA8C,wBAAwB,EAAE;AACxE,wBAAwB,WAAW,EAAE,oBAAoB,EAAE,qCAAqC,EAAE,gBAAgB,EAAE;AACpH,uBAAuB,cAAc,EAAE,YAAY,EAAE,oBAAoB,EAAE;AAC3E,oBAAoB,kBAAkB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,iBAAiB,EAAE;;AAEvG,kBAAkB,gBAAgB,EAAE,gBAAgB,EAAE,UAAU,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACpH,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,YAAY,EAAE;AAC/E;EACE,UAAU,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EACzD,aAAa,EAAE,mBAAmB;EAClC,mCAAmC,EAAE,gCAAgC;EACrE,iBAAiB,EAAE,gBAAgB;AACrC;AACA,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE;AACvE;EACE,kBAAkB,EAAE,gBAAgB,EAAE,wBAAwB;EAC9D,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB;AAChE;AACA;EACE,kBAAkB,EAAE,8BAA8B;EAClD,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB;AAChE;AACA,kBAAkB,kBAAkB,EAAE;;AAEtC,qEAAqE;AACrE;EACE,YAAY,EAAE,gBAAgB,EAAE,UAAU,EAAE,eAAe;EAC3D,aAAa,EAAE,gCAAgC,EAAE,gBAAgB;AACnE;AACA,kBAAkB,0BAA0B,EAAE;;AAE9C;0EAC0E;AAC1E;EACE,oBAAoB,EAAE,QAAQ,EAAE,UAAU;EAC1C,YAAY,EAAE,4BAA4B;EAC1C,uCAAuC;AACzC;AACA;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,iBAAiB,EAAE,YAAY,EAAE,wCAAwC;EACzE,uBAAuB,EAAE,kCAAkC;EAC3D,iBAAiB,EAAE,gBAAgB,EAAE,eAAe,EAAE,mBAAmB;EACzE,iEAAiE;AACnE;AACA,qBAAqB,wBAAwB,EAAE;AAC/C;EACE,gCAAgC,EAAE,2BAA2B;EAC7D,2DAA2D;AAC7D;AACA;EACE,eAAe,EAAE,cAAc,EAAE,oBAAoB;EACrD,2BAA2B,EAAE,kCAAkC;EAC/D,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB;AAC1D;AACA;EACE,mCAAmC,EAAE,gCAAgC;AACvE;;AAEA;EACE,aAAa,EAAE,2DAA2D;EAC1E,SAAS,EAAE,mBAAmB;AAChC;AACA;EACE,aAAa,EAAE,sBAAsB,EAAE,QAAQ;EAC/C,kBAAkB,EAAE,4BAA4B;EAChD,2CAA2C,EAAE,gCAAgC;AAC/E;AACA;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,iBAAiB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,yBAAyB;EACtF,8BAA8B;AAChC;AACA,iBAAiB,kBAAkB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,gBAAgB,EAAE;;AAEnG,aAAa,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAC/D,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AACnF;EACE,SAAS,EAAE,kBAAkB,EAAE,gBAAgB;EAC/C,sBAAsB,EAAE,yBAAyB,EAAE,8BAA8B;AACnF;AACA;EACE,eAAe,EAAE,gBAAgB,EAAE,oBAAoB;EACvD,uCAAuC,EAAE,kCAAkC;EAC3E,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB;AAC1D;AACA,WAAW,UAAU,EAAE,gBAAgB,EAAE;;AAEzC;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,kBAAkB,EAAE,kDAAkD;EACtE,wCAAwC;AAC1C;AACA,qBAAqB,mBAAmB,EAAE;AAC1C,gBAAgB,2BAA2B,EAAE;AAC7C;EACE,aAAa,EAAE,cAAc,EAAE,YAAY,EAAE,mBAAmB,EAAE,SAAS;EAC3E,YAAY,EAAE,gBAAgB,EAAE,UAAU,EAAE,gBAAgB,EAAE,eAAe;AAC/E;AACA;EACE,UAAU,EAAE,WAAW,EAAE,YAAY,EAAE,4BAA4B;EACnE,aAAa,EAAE,mBAAmB;AACpC;AACA,WAAW,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE,cAAc,EAAE;AAC1F,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,YAAY,EAAE;AAC5E;EACE,gBAAgB,EAAE,kBAAkB,EAAE,wBAAwB;EAC9D,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB;AAChE;AACA;EACE,UAAU,EAAE,gBAAgB,EAAE,oBAAoB;EAClD,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B;AAClE;AACA;EACE,aAAa,EAAE,eAAe,EAAE,aAAa;EAC7C,kBAAkB,EAAE,kCAAkC;AACxD;AACA,kBAAkB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACvE,WAAW,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,eAAe,EAAE;AACtE;EACE,UAAU,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,8BAA8B;EAChF,mBAAmB,EAAE,iBAAiB;AACxC;AACA,cAAc,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,UAAU,EAAE;AACxE;EACE,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,YAAY;EAC7D,YAAY,EAAE,4BAA4B,EAAE,uBAAuB;EACnE,8BAA8B,EAAE,eAAe;EAC/C,iEAAiE;AACnE;AACA,qBAAqB,sCAAsC,EAAE,wBAAwB,EAAE;AACvF,+BAA+B,6DAA6D,EAAE,yBAAyB,EAAE;AACzH,wBAAwB,eAAe,EAAE,YAAY,EAAE;;AAEvD,2EAA2E;AAC3E;EACE,eAAe,EAAE,kBAAkB,EAAE,iBAAiB;EACtD,kCAAkC,EAAE,eAAe;AACrD;AACA;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB;EAC5D,yBAAyB,EAAE,2BAA2B;AACxD;AACA;EACE,UAAU,EAAE,WAAW,EAAE,kBAAkB;EAC3C,gCAAgC,EAAE,6CAA6C;AACjF;AACA,sBAAsB,WAAW,UAAU,EAAE,EAAE,MAAM,aAAa,EAAE,EAAE;AACtE,0CAA0C,eAAe,eAAe,EAAE,EAAE;AAC5E,mFAAmF;AACnF;gFACgF;AAChF,qBAAqB,eAAe,EAAE;AACtC,mCAAmC,oBAAoB,EAAE;AACzD,2BAA2B,uCAAuC,EAAE,2BAA2B,EAAE;AACjG,gBAAgB,gBAAgB,EAAE;;AAElC;EACE,UAAU,eAAe,EAAE;EAC3B,WAAW,aAAa,EAAE;EAC1B,cAAc,iBAAiB,EAAE;AACnC;;AAEA;;qDAEqD;AACrD,WAAW,iBAAiB,EAAE,2BAA2B,EAAE,aAAa,EAAE,sBAAsB,EAAE;AAClG;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,OAAO;EAC3E,kBAAkB,EAAE,kDAAkD;EACtE,gCAAgC;AAClC;AACA,WAAW,WAAW,EAAE,iBAAiB,EAAE,cAAc,EAAE,wBAAwB,EAAE,cAAc,EAAE;AACrG,qBAAqB,gBAAgB,EAAE,aAAa,EAAE,mBAAmB,EAAE;;AAE3E,WAAW,kBAAkB,EAAE,mBAAmB,EAAE;AACpD,cAAc,eAAe,EAAE,iBAAiB,EAAE,iBAAiB,EAAE;AACrE,aAAa,cAAc,EAAE,eAAe,EAAE,kCAAkC,EAAE,gBAAgB,EAAE;AACpG,YAAY,mBAAmB,EAAE;;AAEjC;2DAC2D;AAC3D;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,kBAAkB,EAAE,mBAAmB;EACvC,+CAA+C,EAAE,qCAAqC;EACtF,gCAAgC,EAAE,eAAe;EACjD,wEAAwE;AAC1E;AACA,qCAAqC,kCAAkC,EAAE,mCAAmC,EAAE;AAC9G,kBAAkB,mBAAmB,EAAE,kCAAkC,EAAE,mCAAmC,EAAE;AAChH,iBAAiB,gBAAgB,EAAE;AACnC;EACE,UAAU,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EACzD,aAAa,EAAE,mBAAmB;EAClC,mCAAmC,EAAE,gCAAgC;AACvE;AACA,8BAA8B,gCAAgC,EAAE,2BAA2B,EAAE;AAC7F,cAAc,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE,cAAc,EAAE;AAC7F,qBAAqB,kBAAkB,EAAE,uBAAuB,EAAE;AAClE,mBAAmB,iBAAiB,EAAE,kCAAkC,EAAE,gBAAgB,EAAE;AAC5F;EACE,UAAU,EAAE,YAAY,EAAE,gBAAgB,EAAE,eAAe;EAC3D,8BAA8B,EAAE,YAAY,EAAE,4BAA4B;AAC5E;AACA,qBAAqB,yBAAyB,EAAE,gCAAgC,EAAE;;AAElF,cAAc,aAAa,EAAE,mBAAmB,EAAE;AAClD;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,gBAAgB,EAAE,eAAe,EAAE,gBAAgB;AACrD;AACA,wBAAwB,2BAA2B,EAAE;AACrD,WAAW,aAAa,EAAE,2DAA2D,EAAE,cAAc,EAAE;AACvG;+EAC+E;AAC/E,gBAAgB,gDAAgD,EAAE;AAClE;oEACoE;AACpE,mBAAmB,2DAA2D,EAAE;AAChF,yDAAyD,mBAAmB,EAAE;AAC9E,YAAY,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE;AAC3E;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,kBAAkB,EAAE,gBAAgB,EAAE,kCAAkC;AAC1E;AACA,sBAAsB,8BAA8B,EAAE,UAAU,EAAE;AAClE,qBAAqB,gBAAgB,EAAE;;AAEvC;EACE,gBAAgB,EAAE,YAAY,EAAE,UAAU;EAC1C,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS;EAC7E,kBAAkB,EAAE,qCAAqC;EACzD,qCAAqC,EAAE,gCAAgC;EACvE,2DAA2D;AAC7D;AACA,oBAAoB,kBAAkB,EAAE,kCAAkC,EAAE,YAAY,EAAE;;AAE1F,YAAY,kBAAkB,EAAE,iBAAiB,EAAE;AACnD,eAAe,kBAAkB,EAAE,kBAAkB,EAAE;AACvD,cAAc,SAAS,EAAE,kCAAkC,EAAE,gBAAgB,EAAE;AAC/E,iBAAiB,2BAA2B,EAAE,kBAAkB,EAAE,yCAAyC,EAAE;AAC7G;EACE,oBAAoB,EAAE,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB;AAC1F;AACA,4BAA4B,mCAAmC,EAAE,2BAA2B,EAAE;AAC9F,0BAA0B,uCAAuC,EAAE,yBAAyB,EAAE;;AAE9F;EACE,uBAAuB,EAAE,kBAAkB;EAC3C,kBAAkB,EAAE,8BAA8B;EAClD,+CAA+C;AACjD;;AAEA;EACE,gBAAgB,qCAAqC,EAAE;AACzD;AACA;EACE,WAAW,wBAAwB,EAAE;EACrC,cAAc,iBAAiB,EAAE;EACjC,SAAS,eAAe,EAAE;EAC1B,aAAa,sBAAsB,EAAE,oBAAoB,EAAE,QAAQ,EAAE;EACrE,kBAAkB,uBAAuB,EAAE;AAC7C;;AAEA,mEAAmE;AACnE;wEACwE;AACxE,YAAY,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,YAAY,EAAE;AAC/G,aAAa,YAAY,EAAE,eAAe,EAAE;AAC5C,mBAAmB,YAAY,EAAE;AACjC;EACE;8CAC4C;EAC5C,WAAW,eAAe,EAAE,aAAa,EAAE;EAC3C,YAAY,WAAW,EAAE,cAAc,EAAE;EACzC,aAAa,cAAc,EAAE;AAC/B;AACA;EACE,YAAY,eAAe,EAAE;EAC7B,gBAAgB,eAAe,EAAE;AACnC;;AAEA;+DAC+D;AAC/D,WAAW,kBAAkB,EAAE;AAC/B,eAAe,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE;AAC/E;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,UAAU;EAC/D,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB;EAC5D,yBAAyB,EAAE,8BAA8B;AAC3D;AACA,kBAAkB,2BAA2B,EAAE;AAC/C,UAAU,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,wBAAwB,EAAE;AACjF,iBAAiB,gBAAgB,EAAE,kBAAkB,EAAE,YAAY,EAAE,uBAAuB,EAAE;AAC9F,gBAAgB,iBAAiB,EAAE,kCAAkC,EAAE;AACvE,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,UAAU,EAAE;AAChG,mBAAmB,yBAAyB,EAAE;;AAE9C,UAAU,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AAC1E;EACE,cAAc,EAAE,YAAY;EAC5B,iBAAiB,EAAE,4BAA4B;EAC/C,2CAA2C,EAAE,2BAA2B;EACxE,6EAA6E;EAC7E,kBAAkB,EAAE,kCAAkC;EACtD,uBAAuB;AACzB;AACA,sBAAsB,uCAAuC,EAAE,mBAAmB,EAAE;;AAEpF,4EAA4E;AAC5E;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,aAAa,EAAE,kCAAkC;AACnD;AACA,kBAAkB,UAAU,EAAE,8BAA8B,EAAE;AAC9D,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE,cAAc,EAAE;AACjG,mBAAmB,wBAAwB,EAAE,kBAAkB,EAAE;AACjE,iBAAiB,kBAAkB,EAAE,gBAAgB,EAAE;;AAEvD;EACE,mBAAmB,cAAc,EAAE,WAAW,EAAE;EAChD,YAAY,eAAe,EAAE;AAC/B;;AAEA,qDAAqD;AACrD;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe;EAC9D,kBAAkB,EAAE,mBAAmB,EAAE,4BAA4B;EACrE,+CAA+C;EAC/C,gEAAgE;EAChE,mDAAmD;EACnD,kBAAkB;AACpB;AACA,oBAAoB,UAAU,EAAE;AAChC,qBAAqB,cAAc,EAAE,YAAY,EAAE;AACnD;EACE,kBAAkB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,oBAAoB;EAC5E,gEAAgE;EAChE,6DAA6D;AAC/D;;AAEA;wDACwD;AACxD;EACE,aAAa,EAAE,sBAAsB,EAAE,QAAQ;EAC/C,iBAAiB,EAAE,4BAA4B;EAC/C,sCAAsC,EAAE,2BAA2B;EACnE,kBAAkB,EAAE,8BAA8B,EAAE,gBAAgB;EACpE,uBAAuB;AACzB;AACA,uBAAuB,mBAAmB,EAAE,gCAAgC,EAAE;AAC9E,uBAAuB,wBAAwB,EAAE,gBAAgB,EAAE;AACnE,uBAAuB,kCAAkC,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;;AAEhG,2EAA2E;AAC3E,aAAa,aAAa,EAAE,uBAAuB,EAAE,8BAA8B,EAAE,SAAS,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACtI,cAAc,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,kBAAkB,EAAE;AACjG,kBAAkB,2BAA2B,EAAE;AAC/C,YAAY,SAAS,EAAE,kBAAkB,EAAE,kCAAkC,EAAE,eAAe,EAAE,iBAAiB,EAAE;AACnH,kBAAkB,UAAU,EAAE,gBAAgB,EAAE;AAChD;sEACsE;AACtE,cAAc,WAAW,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,wBAAwB,EAAE;AACpG,iBAAiB,wBAAwB,EAAE;AAC3C;EACE,gBAAgB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB;EAC1E,sBAAsB,EAAE,yBAAyB,EAAE,8BAA8B;EACjF,kDAAkD,EAAE,2BAA2B;EAC/E,mBAAmB;AACrB;AACA,iBAAiB,kBAAkB,EAAE,kDAAkD,EAAE,sBAAsB,EAAE;AACjH,+BAA+B,mBAAmB,EAAE;AACpD,wBAAwB,aAAa,EAAE;AACvC,aAAa,gBAAgB,EAAE,wBAAwB,EAAE;AACzD;EACE,cAAc,EAAE,eAAe,EAAE,iBAAiB,EAAE,8BAA8B;EAClF,6EAA6E;AAC/E;AACA,mBAAmB,mBAAmB,EAAE,kCAAkC,EAAE,wBAAwB,EAAE;AACtG,eAAe,qBAAqB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,2CAA2C,EAAE;AAClI;EACE,qCAAqC,EAAE,2BAA2B;EAClE,kCAAkC,EAAE,oBAAoB;EACxD,iBAAiB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe;AAC1E;AACA,mBAAmB,yBAAyB,EAAE,mCAAmC,EAAE,gCAAgC,EAAE;AACrH,gBAAgB,aAAa,EAAE,QAAQ,EAAE,yBAAyB,EAAE;AACpE,oCAAoC,yBAAyB,EAAE;AAC/D,8BAA8B,aAAa,EAAE,mBAAmB,EAAE;AAClE,kBAAkB,mCAAmC,EAAE;AACvD,2BAA2B,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACzE,yCAAyC,WAAW,EAAE;AACtD,aAAa,kBAAkB,EAAE,8BAA8B,EAAE,eAAe,EAAE;AAClF,oBAAoB,WAAW,EAAE,YAAY,EAAE,YAAY,EAAE,qCAAqC,EAAE,4BAA4B,EAAE,gCAAgC,EAAE,eAAe,EAAE;AACrL,eAAe,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AACxF,YAAY,aAAa,EAAE,uBAAuB,EAAE,SAAS,EAAE,iBAAiB,EAAE;AAClF,gBAAgB,UAAU,EAAE,eAAe,EAAE;;AAE7C;;+EAE+E;AAC/E,aAAa,cAAc,EAAE;AAC7B,sBAAsB,aAAa,EAAE;AACrC,4CAA4C,cAAc,EAAE","sourcesContent":["/* ============================================\n   TuraQuant - Global Styles\n   ============================================ */\n\n/* --- CSS Custom Properties --- */\n:root {\n  color-scheme: light;\n\n  /* ══ Turacoz brand ══\n     Taken from the Vista portal (vista.turacoz.com). The brand ramp runs\n     green → teal → blue; the portal uses ink for primary buttons with a green\n     hover, blue for links, and green as the live accent. No gradients. */\n  --brand-green-1: #98CA3C;\n  --brand-green-2: #87C541;\n  --brand-green-3: #65BC46;\n  --brand-green-4: #3EA151;\n  --brand-teal: #3E8E8D;\n  --brand-blue: #3A57A7;\n  --brand-ink: #0A0203;\n\n  /* ── Interactive ──\n     --color-primary is the living accent: active nav, icons, focus, links.\n     Primary BUTTONS are ink with a green hover, matching the portal — that rule\n     lives on .btn-primary rather than here, so the two do not fight. */\n  --color-primary: #3EA151;\n  --color-primary-dark: #2C7139;\n  --color-primary-light: #98CA3C;\n  --color-primary-bg: #EEF4E0;\n  --color-primary-contrast: #FFFFFF;\n  --color-secondary: #0A0203;\n  --color-accent: #3E8E8D;\n  --color-link: #3A57A7;\n\n  /* ── Status ── */\n  --color-success: #3EA151;\n  --color-success-bg: #E9F3E2;\n  --color-success-text: #2C7139;\n  --color-warning: #C97A00;\n  --color-warning-bg: #FBF1DE;\n  --color-warning-text: #8A5400;\n  --color-error: #C4362C;\n  --color-error-bg: #FAEBE9;\n  --color-error-text: #932720;\n  --color-danger: #C4362C;\n  --color-info: #3A57A7;\n  --color-info-bg: #E4E8F2;\n  --color-info-text: #2C4384;\n\n  /* ── Categorical ──\n     Chart series, data-source badges and role tags need more hues than the\n     brand ramp provides, and those hues must stay distinguishable rather than\n     harmonised. They are tokens all the same, so they can be re-tuned for dark\n     mode — the deep violet and pink below are unreadable on a dark ground. */\n  --color-violet: #6D28D9;\n  --color-violet-bg: #EDE9FE;\n  --color-pink: #C0246A;\n  --color-pink-bg: #FBE7F0;\n\n  /* ── Text. Warm, olive-leaning greys — not slate. ── */\n  --color-text: #0A0203;\n  --color-text-secondary: #5C5F58;\n  --color-text-light: #8E918A;\n  --color-text-inverse: #FAFAF7;\n\n  /* ── Surfaces ──\n     --color-bg is the page, --color-surface a card on it, --color-surface-raised\n     a control nested on the card. Named by role, not by \"white\", which is what\n     lets the dark theme swap them wholesale. */\n  --color-bg: #FAFAF7;\n  --color-surface: #FFFFFF;\n  --color-surface-raised: #F4F4F0;\n  --color-surface-sunken: #ECECE6;\n  --color-surface-hover: #ECECE6;\n  --color-overlay: rgba(10, 2, 3, 0.55);\n  --color-white: #FFFFFF;\n\n  /* ── Lines ── */\n  --color-border: #E5E5DF;\n  --color-border-light: #F4F4F0;\n  --color-border-strong: #D0D0C8;\n  --color-focus-ring: rgba(62, 161, 81, 0.35);\n\n  /* ── Elevation. Ink-tinted, as on the portal — a neutral black shadow reads\n     grey and muddy against a warm off-white ground. ── */\n  --shadow-sm: 0 1px 2px rgba(10, 2, 3, 0.04), 0 1px 4px rgba(10, 2, 3, 0.04);\n  --shadow: 0 2px 6px rgba(10, 2, 3, 0.05), 0 1px 3px rgba(10, 2, 3, 0.04);\n  --shadow-md: 0 6px 22px rgba(10, 2, 3, 0.06), 0 2px 6px rgba(10, 2, 3, 0.04);\n  --shadow-lg: 0 20px 60px rgba(10, 2, 3, 0.12), 0 4px 16px rgba(10, 2, 3, 0.06);\n  --shadow-xl: 0 28px 80px rgba(10, 2, 3, 0.16), 0 8px 24px rgba(10, 2, 3, 0.08);\n\n  /* ── Radii, matching the portal: 10px fields, 14–18px cards, pill buttons. ── */\n  --radius-sm: 8px;\n  --radius: 10px;\n  --radius-md: 14px;\n  --radius-lg: 18px;\n  --radius-xl: 24px;\n  --radius-full: 100px;\n\n  /* ── Spacing ── */\n  --spacing-xs: 4px;\n  --spacing-sm: 8px;\n  --spacing-md: 16px;\n  --spacing-lg: 24px;\n  --spacing-xl: 32px;\n  --spacing-2xl: 48px;\n  --spacing-3xl: 64px;\n\n  /* ── Type ── */\n  --font-sans: 'Montserrat', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  --font-mono: 'JetBrains Mono', 'Fira Code', ui-monospace, SFMono-Regular, Menlo, monospace;\n\n  --text-xs: 0.72rem;\n  --text-sm: 0.82rem;\n  --text-base: 0.92rem;\n  --text-md: 1rem;\n  --text-lg: 1.12rem;\n  --text-xl: 1.35rem;\n  --text-2xl: 1.7rem;\n  --text-3xl: 2.2rem;\n  --text-4xl: 2.9rem;\n\n  --leading-tight: 1.25;\n  --leading-snug: 1.4;\n  --leading-normal: 1.6;\n\n  /* Montserrat is geometric and runs wide — large sizes need negative tracking\n     or headings sprawl, and uppercase eyebrows need a lot of positive tracking,\n     which is exactly how the portal sets them (0.22em). */\n  --tracking-tight: -0.02em;\n  --tracking-snug: -0.01em;\n  --tracking-normal: 0;\n  --tracking-eyebrow: 0.22em;\n\n  --ease: cubic-bezier(0.2, 0.7, 0.2, 1);\n  --transition: 180ms cubic-bezier(0.2, 0.7, 0.2, 1);\n  --transition-slow: 320ms cubic-bezier(0.2, 0.7, 0.2, 1);\n}\n\n/* ══ Dark theme ══\n   Only the tokens change; nothing below this block knows which theme is active.\n   The neutrals stay warm rather than going blue-black, so the brand still reads\n   as the same product. Surfaces lift as they come closer to the user — the\n   inverse of light mode. Borders lighten rather than darken, because a darker\n   line is invisible on a dark ground. The greens and blue are raised: #3EA151\n   and #3A57A7 are both too dark to carry text on a near-black background. */\n[data-theme='dark'] {\n  color-scheme: dark;\n\n  --color-primary: #7FC456;\n  --color-primary-dark: #98CA3C;\n  --color-primary-light: #B4DC72;\n  --color-primary-bg: #1B2A14;\n  --color-primary-contrast: #0A0203;\n  --color-secondary: #F4F4F0;\n  --color-accent: #5FB3B2;\n  --color-link: #8FA5E0;\n\n  --color-success: #7FC456;\n  --color-success-bg: #16240F;\n  --color-success-text: #A8DA80;\n  --color-warning: #E0A33A;\n  --color-warning-bg: #2A1E07;\n  --color-warning-text: #F0C476;\n  --color-error: #E8705F;\n  --color-error-bg: #2C120F;\n  --color-error-text: #F2A093;\n  --color-danger: #E8705F;\n  --color-info: #8FA5E0;\n  --color-info-bg: #151B2E;\n  --color-info-text: #B3C2EC;\n\n  --color-violet: #B49BF5;\n  --color-violet-bg: #241A3D;\n  --color-pink: #F08BB6;\n  --color-pink-bg: #351324;\n\n  --color-text: #F4F4F0;\n  --color-text-secondary: #A5A89F;\n  --color-text-light: #7E817A;\n  --color-text-inverse: #0A0203;\n\n  --color-bg: #0E0E0C;\n  --color-surface: #171714;\n  --color-surface-raised: #20201C;\n  --color-surface-sunken: #121210;\n  --color-surface-hover: #292923;\n  --color-overlay: rgba(0, 0, 0, 0.72);\n  --color-white: #171714;\n\n  --color-border: #2B2B26;\n  --color-border-light: #20201C;\n  --color-border-strong: #403F38;\n  --color-focus-ring: rgba(127, 196, 86, 0.4);\n\n  /* On a dark ground depth comes from the surface ramp above, not from shadow;\n     these are deepened so they still register at all. */\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.5);\n  --shadow: 0 2px 6px rgba(0, 0, 0, 0.55), 0 1px 3px rgba(0, 0, 0, 0.4);\n  --shadow-md: 0 6px 22px rgba(0, 0, 0, 0.6), 0 2px 6px rgba(0, 0, 0, 0.45);\n  --shadow-lg: 0 20px 60px rgba(0, 0, 0, 0.65), 0 4px 16px rgba(0, 0, 0, 0.5);\n  --shadow-xl: 0 28px 80px rgba(0, 0, 0, 0.72), 0 8px 24px rgba(0, 0, 0, 0.55);\n}\n\n/* --- Reset & Base --- */\n*, *::before, *::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nhtml {\n  font-size: 16px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  scroll-behavior: smooth;\n}\n\nbody {\n  font-family: var(--font-sans);\n  color: var(--color-text);\n  background-color: var(--color-bg);\n  font-size: var(--text-base);\n  line-height: var(--leading-normal);\n  letter-spacing: var(--tracking-snug);\n  min-height: 100vh;\n  /* The theme swap should not strobe. Colours cross-fade; nothing else. */\n  transition: background-color var(--transition-slow), color var(--transition-slow);\n}\n\n/* Inter ships tabular figures — use them wherever numbers are compared in a\n   column (scores, tables), so digits line up instead of jittering. */\ntable, .score-meter-value, .stat-value, .metric-value {\n  font-variant-numeric: tabular-nums;\n}\n\na {\n  color: var(--color-primary);\n  text-decoration: none;\n  transition: color var(--transition);\n}\n\na:hover {\n  color: var(--color-primary-dark);\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-weight: 600;\n  line-height: var(--leading-tight);\n  color: var(--color-text);\n  text-wrap: balance;\n}\n\n/* Tracking tightens as size grows — Inter set large at default tracking reads\n   loose and webby. Weight drops from 700 to 600 at display sizes for the same\n   reason: at 2.25rem, 700 is heavier than it needs to be to read as a heading. */\nh1 { font-size: var(--text-3xl); letter-spacing: var(--tracking-tight); }\nh2 { font-size: var(--text-2xl); letter-spacing: var(--tracking-tight); }\nh3 { font-size: var(--text-xl); letter-spacing: var(--tracking-snug); }\nh4 { font-size: var(--text-lg); letter-spacing: var(--tracking-snug); font-weight: 600; }\nh5 { font-size: var(--text-md); letter-spacing: var(--tracking-snug); font-weight: 600; }\nh6 { font-size: var(--text-base); letter-spacing: var(--tracking-normal); font-weight: 600; }\n\n/* Long-form paragraphs get a measure cap; without one, text on a wide monitor\n   runs to 200 characters a line and becomes hard to track. */\np { text-wrap: pretty; }\n\n::selection {\n  background: var(--color-primary);\n  color: var(--color-primary-contrast);\n}\n\n/* One visible focus style everywhere, rather than the browser default that some\n   resets had already suppressed. */\n:where(a, button, input, select, textarea, [tabindex]):focus-visible {\n  outline: 2px solid var(--color-primary);\n  outline-offset: 2px;\n  border-radius: var(--radius-sm);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *, *::before, *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n\nimg { max-width: 100%; height: auto; }\n\n/* --- Layout --- */\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 var(--spacing-lg);\n}\n\n.container-sm {\n  max-width: 640px;\n  margin: 0 auto;\n  padding: 0 var(--spacing-lg);\n}\n\n.page {\n  /* Was `100vh - 64px` for the old top navbar. The sidebar is beside the page,\n     not above it, so the page owns the full height. */\n  min-height: 100vh;\n  padding: var(--spacing-xl) 0;\n}\n\n@media (max-width: 900px) {\n  .page {\n    min-height: calc(100vh - var(--appbar-h));\n    padding: var(--spacing-lg) 0;\n  }\n}\n\n.page-header {\n  margin-bottom: var(--spacing-lg);\n}\n\n/* Visually hidden, still read aloud and still in the document outline. Used for\n   page titles that the app bar already displays — the heading must exist, it\n   just must not be printed twice. */\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.page-header h1 {\n  margin-bottom: var(--spacing-sm);\n}\n\n.page-header p {\n  color: var(--color-text-secondary);\n  font-size: 1.05rem;\n}\n\n.content {\n  flex: 1;\n  padding: var(--spacing-xl);\n}\n\n.flex { display: flex; }\n.flex-col { flex-direction: column; }\n.items-center { align-items: center; }\n.justify-between { justify-content: space-between; }\n.gap-sm { gap: var(--spacing-sm); }\n.gap-md { gap: var(--spacing-md); }\n.gap-lg { gap: var(--spacing-lg); }\n.text-center { text-align: center; }\n\n/* --- Navbar --- */\n/* ============================================\n   App shell — fixed left sidebar, main column beside it\n   ============================================ */\n:root {\n  --sidebar-w: 264px;\n  --sidebar-w-collapsed: 76px;\n  --appbar-h: 60px;\n}\n\n.app-shell {\n  min-height: 100vh;\n}\n\n.app-main {\n  margin-left: var(--sidebar-w);\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  /* The page used to sit flush against the rail with no breathing room, which\n     read as one undivided slab. The main column now floats on the page ground\n     with a gutter on every side. */\n  padding: var(--spacing-md) var(--spacing-lg) var(--spacing-lg);\n  transition: margin-left var(--transition-slow);\n}\n\n.app-shell.sidebar-collapsed .app-main {\n  margin-left: var(--sidebar-w-collapsed);\n}\n\n.app-content {\n  flex: 1;\n}\n\n/* --- App bar: breadcrumbs + sidebar control --- */\n.appbar {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n  height: var(--appbar-h);\n  flex: none;\n  /* Sticky, and pulled out to the full width of the column so its background\n     covers content scrolling underneath rather than leaving a transparent\n     strip at the sides. */\n  position: sticky;\n  top: 0;\n  z-index: 90;\n  margin: calc(var(--spacing-md) * -1) calc(var(--spacing-lg) * -1) var(--spacing-md);\n  padding: 0 var(--spacing-lg);\n  background: var(--color-bg);\n  border-bottom: 1px solid var(--color-border);\n}\n\n.appbar-icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  flex: none;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-sm);\n  background: var(--color-surface);\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  transition: background var(--transition), color var(--transition), border-color var(--transition);\n}\n\n.appbar-icon-btn:hover {\n  background: var(--color-surface-hover);\n  color: var(--color-text);\n  border-color: var(--color-border-strong);\n}\n\n.appbar-logout:hover {\n  background: var(--color-error-bg);\n  border-color: var(--color-error);\n  color: var(--color-error);\n}\n\n/* One slot, two controls: collapse on desktop, drawer on mobile. */\n.appbar-drawer { display: none; }\n\n.appbar-actions {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  margin-left: auto;\n}\n\n.appbar-user {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: var(--radius-full);\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  color: var(--color-text-secondary);\n  font-size: var(--text-sm);\n  font-weight: 500;\n  max-width: 200px;\n}\n\n.appbar-username {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* --- Settings layout ---\n   Eleven tabs in a horizontal strip wrapped onto two rows and read as a wall.\n   A vertical rail holds them all in one column, grouped, with room for a label\n   that is not abbreviated. */\n.settings-layout {\n  display: grid;\n  grid-template-columns: 232px minmax(0, 1fr);\n  gap: var(--spacing-lg);\n  align-items: start;\n}\n\n.settings-nav {\n  position: sticky;\n  top: calc(var(--appbar-h) + var(--spacing-md));\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-md);\n  padding: var(--spacing-sm);\n  max-height: calc(100vh - var(--appbar-h) - var(--spacing-2xl));\n  overflow-y: auto;\n}\n\n.settings-group-label {\n  font-size: var(--text-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.09em;\n  color: var(--color-text-light);\n  padding: var(--spacing-md) var(--spacing-md) 6px;\n}\n\n.settings-group-label:first-child { padding-top: var(--spacing-sm); }\n\n.settings-tab {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 9px var(--spacing-md);\n  border: none;\n  border-radius: var(--radius-sm);\n  background: none;\n  font-family: inherit;\n  font-size: var(--text-base);\n  font-weight: 500;\n  color: var(--color-text-secondary);\n  text-align: left;\n  cursor: pointer;\n  transition: background var(--transition), color var(--transition);\n}\n\n.settings-tab svg { flex: none; }\n\n.settings-tab:hover {\n  background: var(--color-surface-hover);\n  color: var(--color-text);\n}\n\n.settings-tab.active {\n  background: var(--color-primary-bg);\n  color: var(--color-primary-dark);\n  font-weight: 600;\n}\n\n@media (max-width: 900px) {\n  .settings-layout {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  /* Stacked, the rail becomes a scrolling strip rather than a tall list that\n     pushes the content it controls off the screen. */\n  .settings-nav {\n    position: static;\n    flex-direction: row;\n    overflow-x: auto;\n    max-height: none;\n    gap: var(--spacing-xs);\n  }\n\n  .settings-group-label { display: none; }\n\n  .settings-tab { white-space: nowrap; width: auto; }\n}\n\n/* --- Breadcrumbs --- */\n.breadcrumbs {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  overflow: hidden;\n  font-size: var(--text-md);\n}\n\n.breadcrumb-home {\n  display: inline-flex;\n  align-items: center;\n  color: var(--color-text-light);\n  flex: none;\n  transition: color var(--transition);\n}\n\n.breadcrumb-home:hover { color: var(--color-primary-dark); }\n\n.breadcrumb-sep {\n  color: var(--color-text-light);\n  flex: none;\n}\n\n.breadcrumb-link {\n  color: var(--color-text-secondary);\n  white-space: nowrap;\n  transition: color var(--transition);\n}\n\n.breadcrumb-link:hover { color: var(--color-primary-dark); }\n\n.breadcrumb-current {\n  color: var(--color-text);\n  font-weight: 600;\n  font-size: var(--text-lg);\n  letter-spacing: var(--tracking-snug);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* --- Sidebar --- */\n.sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: var(--sidebar-w);\n  display: flex;\n  flex-direction: column;\n  background: var(--color-surface);\n  border-right: 1px solid var(--color-border);\n  z-index: 120;\n  transition: width var(--transition-slow), transform var(--transition-slow);\n}\n\n.sidebar.is-collapsed {\n  width: var(--sidebar-w-collapsed);\n}\n\n/* The label is what collapses; the icon column stays put, so nothing shifts\n   sideways when the rail narrows. */\n.sidebar.is-collapsed .sidebar-label {\n  opacity: 0;\n  width: 0;\n  overflow: hidden;\n  pointer-events: none;\n}\n\n.sidebar-label {\n  white-space: nowrap;\n  opacity: 1;\n  transition: opacity var(--transition);\n}\n\n.sidebar-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--spacing-sm);\n  height: var(--appbar-h);\n  padding: 0 var(--spacing-md);\n  border-bottom: 1px solid var(--color-border-light);\n  flex: none;\n}\n\n.sidebar-brand {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  font-weight: 700;\n  font-size: var(--text-base);\n  letter-spacing: var(--tracking-snug);\n  color: var(--color-text);\n  /* min-width:0 lets a flex child actually shrink; without it the label was\n     clipped mid-letter by the close button instead of ellipsing. */\n  min-width: 0;\n  overflow: hidden;\n}\n\n.sidebar-brand .sidebar-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sidebar-brand svg {\n  width: 22px;\n  height: 22px;\n  color: var(--color-primary);\n  flex: none;\n}\n\n.sidebar-close {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: none;\n  border-radius: var(--radius-sm);\n  color: var(--color-text-secondary);\n  cursor: pointer;\n}\n\n/* Section heading inside the rail. Grouping the modules is also what stopped\n   the sidebar reading as a short list floating in a tall empty column. */\n.sidebar-group-label {\n  font-size: var(--text-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.09em;\n  color: var(--color-text-light);\n  padding: var(--spacing-md) var(--spacing-md) 4px;\n  white-space: nowrap;\n}\n\n/* Collapsed, the labels are gone, so a heading would be an unexplained gap —\n   a hairline rule separates the groups instead. */\n.sidebar.is-collapsed .sidebar-group-label {\n  padding: var(--spacing-sm) var(--spacing-sm) 0;\n  margin: var(--spacing-xs) var(--spacing-sm) 0;\n  border-top: 1px solid var(--color-border-light);\n}\n\n.sidebar-soon {\n  /* Deliberately NOT `margin-left: auto`: that claims all the free space in the\n     row, which forces the label to shrink and truncates it even when there is\n     plenty of room. Sitting directly after the label keeps both intact. */\n  font-size: 0.58rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  padding: 2px 5px;\n  border-radius: var(--radius-full);\n  background: var(--color-surface-raised);\n  color: var(--color-text-light);\n  flex: none;\n}\n\n.sidebar-link.active .sidebar-soon {\n  background: var(--color-surface);\n  color: var(--color-primary-dark);\n}\n\n.sidebar-foot {\n  flex: none;\n  padding: var(--spacing-sm);\n  border-top: 1px solid var(--color-border-light);\n}\n\n.sidebar-help {\n  color: var(--color-text-light);\n}\n\n.sidebar-nav {\n  flex: 1;\n  overflow-y: auto;\n  padding: var(--spacing-md) var(--spacing-sm);\n  display: flex;\n  flex-direction: column;\n  /* Explicit: without it the links sized to their content (199px in a 248px\n     rail), which left the label competing with the \"soon\" badge for space and\n     truncating it even though the rail had room to spare. */\n  align-items: stretch;\n  gap: 2px;\n}\n\n.sidebar-link {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n  padding: 10px var(--spacing-md);\n  border-radius: var(--radius);\n  color: var(--color-text-secondary);\n  font-weight: 500;\n  font-size: var(--text-base);\n  white-space: nowrap;\n  /* Without min-width:0 the label refuses to shrink and shoves the \"soon\"\n     badge off the edge of the rail — which clipped it on one item and lost it\n     entirely on the longest label. */\n  min-width: 0;\n  /* Explicit rather than relying on align-items: the row was sizing to its\n     content (199px inside a 248px track), which starved the label. */\n  width: 100%;\n  transition: background var(--transition), color var(--transition);\n}\n\n/* Takes the row's spare width so the badge sits at the end, and only ellipses\n   if the label genuinely cannot fit. `:not(.sidebar-soon)` matters: the badge\n   also carries .sidebar-label (so it collapses with the rail), and without the\n   exclusion this rule made the badge stretch too. */\n.sidebar-link > .sidebar-label:not(.sidebar-soon) {\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.sidebar-link svg { flex: none; }\n\n.sidebar-link:hover {\n  background: var(--color-surface-hover);\n  color: var(--color-text);\n}\n\n/* The active item gets a tinted pill plus a left marker — colour alone is not\n   enough to read at a glance in a list of six. */\n.sidebar-link.active {\n  background: var(--color-primary-bg);\n  /* --color-primary is only 2.9:1 on its own tint; the dark step clears 4.5. */\n  color: var(--color-primary-dark);\n  font-weight: 600;\n  position: relative;\n}\n\n.sidebar-link.active::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 3px;\n  height: 20px;\n  border-radius: 0 3px 3px 0;\n  background: var(--color-primary-dark);\n}\n\n\n\n\n\n\n\n\n\n\n/* When collapsed, everything centres on the icon column. */\n.sidebar.is-collapsed .sidebar-head,\n.sidebar.is-collapsed .sidebar-link {\n  justify-content: center;\n  padding-left: var(--spacing-sm);\n  padding-right: var(--spacing-sm);\n  gap: 0;\n}\n\n\n/* Scrim behind the mobile drawer. */\n.sidebar-scrim {\n  position: fixed;\n  inset: 0;\n  background: var(--color-overlay);\n  z-index: 115;\n}\n\n/* --- Theme toggle --- */\n.theme-toggle {\n  border: none;\n  background: none;\n  padding: 0;\n  cursor: pointer;\n  line-height: 0;\n  border-radius: var(--radius-full);\n  flex: none;\n}\n\n.theme-toggle-track {\n  display: flex;\n  align-items: center;\n  width: 46px;\n  height: 26px;\n  padding: 3px;\n  border-radius: var(--radius-full);\n  background: var(--color-surface-raised);\n  border: 1px solid var(--color-border);\n  transition: background var(--transition), border-color var(--transition);\n}\n\n.theme-toggle:hover .theme-toggle-track {\n  border-color: var(--color-border-strong);\n}\n\n.theme-toggle-thumb {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: var(--radius-full);\n  background: var(--color-surface);\n  color: var(--color-warning);\n  box-shadow: var(--shadow-sm);\n  transform: translateX(0);\n  transition: transform var(--transition-slow), color var(--transition), background var(--transition);\n}\n\n[data-theme='dark'] .theme-toggle-thumb {\n  transform: translateX(20px);\n  color: var(--color-primary);\n  background: var(--color-surface-raised);\n}\n\n/* Floating toggle for the screens with no shell — login, register, landing and\n   every public token page. */\n.theme-toggle-floating {\n  position: fixed;\n  top: var(--spacing-md);\n  right: var(--spacing-md);\n  z-index: 200;\n}\n\n/* Below 900px the sidebar becomes an off-canvas drawer and the top bar appears. */\n@media (max-width: 900px) {\n  .app-main,\n  .app-shell.sidebar-collapsed .app-main {\n    margin-left: 0;\n  }\n\n  .appbar-collapse { display: none; }\n  .appbar-drawer { display: inline-flex; }\n\n  .app-main {\n    padding: var(--spacing-sm) var(--spacing-md) var(--spacing-md);\n  }\n\n  /* The name is the first thing to drop when the bar gets tight. */\n  .appbar-username { display: none; }\n\n  .sidebar {\n    width: var(--sidebar-w);\n    transform: translateX(-100%);\n    box-shadow: var(--shadow-lg);\n  }\n\n  .sidebar.is-open { transform: translateX(0); }\n\n  /* Collapsed is a desktop affordance; in the drawer it would hide the labels\n     with no way to bring them back. */\n  .sidebar.is-collapsed { width: var(--sidebar-w); }\n  .sidebar.is-collapsed .sidebar-label { opacity: 1; width: auto; }\n  .sidebar.is-collapsed .sidebar-head,\n  .sidebar.is-collapsed .sidebar-link {\n    justify-content: flex-start;\n    padding-left: var(--spacing-md);\n    padding-right: var(--spacing-md);\n    gap: var(--spacing-md);\n  }\n\n  .sidebar-close { display: inline-flex; }\n}\n\n/* --- Buttons --- */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-sm);\n  padding: 10px 22px;\n  font-size: var(--text-base);\n  font-weight: 600;\n  letter-spacing: var(--tracking-snug);\n  font-family: var(--font-sans);\n  border: 1px solid transparent;\n  /* Pill buttons, as on the Vista portal. */\n  border-radius: var(--radius-full);\n  cursor: pointer;\n  transition: all var(--transition);\n  text-decoration: none;\n  line-height: 1.4;\n  white-space: nowrap;\n}\n\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn svg {\n  width: 18px;\n  height: 18px;\n}\n\n/* Ink, going green on hover — the portal's primary button, not a green fill.\n   --color-primary stays the live accent for nav, icons and focus. */\n.btn-primary {\n  background: var(--color-secondary);\n  color: var(--color-text-inverse);\n  border-color: var(--color-secondary);\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: var(--color-primary);\n  border-color: var(--color-primary);\n  color: #FFFFFF;\n  box-shadow: var(--shadow-md);\n  transform: translateY(-1px);\n}\n\n.btn-secondary {\n  background: var(--color-bg);\n  color: var(--color-text);\n  border-color: var(--color-border);\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: var(--color-white);\n  border-color: var(--color-primary-light);\n  color: var(--color-primary);\n}\n\n.btn-danger {\n  background: var(--color-error);\n  color: var(--color-white);\n  border-color: var(--color-error);\n}\n\n.btn-danger:hover:not(:disabled) {\n  background: var(--color-error);\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);\n}\n\n.btn-outline {\n  background: transparent;\n  color: var(--color-primary);\n  border-color: var(--color-primary);\n}\n\n.btn-outline:hover:not(:disabled) {\n  background: var(--color-primary);\n  color: var(--color-white);\n}\n\n.btn-ghost {\n  background: transparent;\n  color: var(--color-text-secondary);\n  border-color: transparent;\n}\n\n.btn-ghost:hover:not(:disabled) {\n  background: var(--color-bg);\n  color: var(--color-text);\n}\n\n.btn-sm {\n  padding: 6px 14px;\n  font-size: 0.85rem;\n}\n\n.btn-lg {\n  padding: 14px 28px;\n  font-size: 1.1rem;\n}\n\n.btn-block {\n  width: 100%;\n}\n\n/* --- Cards --- */\n.card {\n  background: var(--color-white);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n  transition: box-shadow var(--transition);\n}\n\n.card:hover {\n  box-shadow: var(--shadow-md);\n}\n\n.card-header {\n  padding: var(--spacing-md) var(--spacing-lg);\n  border-bottom: 1px solid var(--color-border-light);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.card-header h3,\n.card-header h4 {\n  margin: 0;\n}\n\n.card-body {\n  padding: var(--spacing-lg);\n}\n\n/* Sub-heading that groups a band of tiles or panels on a dashboard. */\n.section-heading {\n  font-size: var(--text-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.09em;\n  color: var(--color-text-light);\n  margin: var(--spacing-lg) 0 var(--spacing-sm);\n}\n\n.section-heading:first-of-type { margin-top: 0; }\n\n/* --- Stat tiles ---\n   One tile style for every module dashboard. The value leads, the label sits\n   under it, and the icon is a tinted chip in the corner — so a row of tiles\n   scans as a row of NUMBERS rather than a row of icons. Grid stretch keeps them\n   equal height even when one label wraps to two lines. */\n.stat-grid {\n  display: grid;\n  /* auto-FILL, not auto-fit: with a single permitted module, auto-fit collapsed\n     the empty tracks and stretched that one tile across the whole row. */\n  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));\n  gap: var(--spacing-md);\n  margin-bottom: var(--spacing-lg);\n  align-items: stretch;\n}\n\n.stat-card {\n  position: relative;\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-md);\n  padding: var(--spacing-md) var(--spacing-lg) var(--spacing-lg);\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  min-height: 118px;\n  text-decoration: none;\n  color: inherit;\n  transition: border-color var(--transition), box-shadow var(--transition), transform var(--transition);\n}\n\n/* Only tiles that go somewhere react to the pointer. A hover lift on a static\n   number promises a click that never happens. */\na.stat-card:hover {\n  border-color: var(--color-border-strong);\n  box-shadow: var(--shadow-md);\n  transform: translateY(-2px);\n}\n\n.stat-card .stat-icon {\n  position: absolute;\n  top: var(--spacing-md);\n  right: var(--spacing-md);\n  width: 34px;\n  height: 34px;\n  border-radius: var(--radius-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--color-surface-raised);\n  color: var(--color-text-secondary);\n}\n\n.stat-card .stat-icon svg { width: 17px; height: 17px; }\n\n.stat-card .stat-value {\n  font-size: var(--text-3xl);\n  font-weight: 700;\n  letter-spacing: var(--tracking-tight);\n  color: var(--color-text);\n  line-height: 1.1;\n}\n\n.stat-card .stat-label {\n  font-size: var(--text-xs);\n  color: var(--color-text-secondary);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  /* Reserve the icon's column so a long label never runs under it. */\n  padding-right: 42px;\n  order: -1;\n  /* Two lines' worth, always. Without it a label that wraps pushes its number\n     down and the row of figures stops lining up — which is the one thing a row\n     of KPI tiles exists to do. */\n  min-height: 2.4em;\n  line-height: 1.2;\n  margin-bottom: var(--spacing-sm);\n}\n\n.stat-card .stat-sub {\n  font-size: var(--text-xs);\n  color: var(--color-text-light);\n  margin-top: 2px;\n}\n\n.stat-card .stat-sub.is-live {\n  color: var(--color-success);\n  font-weight: 600;\n}\n\n.stat-card .stat-icon.primary { background: var(--color-primary-bg); color: var(--color-primary-dark); }\n.stat-card .stat-icon.success { background: var(--color-success-bg); color: var(--color-success-text); }\n.stat-card .stat-icon.warning { background: var(--color-warning-bg); color: var(--color-warning-text); }\n.stat-card .stat-icon.info { background: var(--color-info-bg); color: var(--color-info-text); }\n.stat-card .stat-icon.violet { background: var(--color-violet-bg); color: var(--color-violet); }\n.stat-card .stat-icon.pink { background: var(--color-pink-bg); color: var(--color-pink); }\n\n/* --- Forms --- */\n.form-group {\n  margin-bottom: var(--spacing-md);\n}\n\n.form-group label {\n  display: block;\n  font-size: var(--text-sm);\n  font-weight: 600;\n  color: var(--color-text);\n  margin-bottom: 5px;\n}\n\n.form-group .form-hint {\n  font-size: var(--text-xs);\n  color: var(--color-text-light);\n  margin-top: 4px;\n}\n\n.form-control,\ninput[type=\"text\"],\ninput[type=\"email\"],\ninput[type=\"password\"],\ninput[type=\"number\"],\ninput[type=\"url\"],\nselect,\ntextarea {\n  width: 100%;\n  padding: 9px 13px;\n  font-size: var(--text-base);\n  font-family: var(--font-sans);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  /* background-COLOR, never the `background` shorthand: the shorthand resets\n     background-image/-repeat/-position, and this rule outranks the `select`\n     rule that draws the dropdown chevron. Using the shorthand here wiped the\n     chevron in light mode and left it tiling across the field in dark. */\n  background-color: var(--color-surface);\n  color: var(--color-text);\n  transition: border-color var(--transition), box-shadow var(--transition), background-color var(--transition);\n  outline: none;\n}\n\n.form-control::placeholder,\ninput::placeholder,\ntextarea::placeholder {\n  color: var(--color-text-light);\n}\n\n.form-control:focus,\ninput:focus,\nselect:focus,\ntextarea:focus {\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px var(--color-focus-ring);\n}\n\n.form-control:disabled,\ninput:disabled,\nselect:disabled,\ntextarea:disabled {\n  background-color: var(--color-surface-raised);\n  color: var(--color-text-light);\n  cursor: not-allowed;\n}\n\n/* Chrome paints autofilled fields with its own near-white background and black\n   text, which is unreadable in dark mode. The inset shadow is the only way to\n   override that background; -webkit-text-fill-color the only way to reach the\n   text. The long delay keeps it from reverting on repaint. */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\nselect:-webkit-autofill {\n  -webkit-text-fill-color: var(--color-text);\n  -webkit-box-shadow: 0 0 0 1000px var(--color-surface) inset;\n  box-shadow: 0 0 0 1000px var(--color-surface) inset;\n  caret-color: var(--color-text);\n  transition: background-color 100000s ease-in-out 0s;\n}\n\ntextarea {\n  resize: vertical;\n  min-height: 76px;\n}\n\nselect {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%235C5F58' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  background-size: 18px 18px;\n  padding-right: 36px;\n}\n\n/* A slate chevron disappears on a dark field — repaint it in the light ink. */\n[data-theme='dark'] select {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%23A5A89F' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n\n.checkbox-group {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm);\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  font-size: 0.95rem;\n  cursor: pointer;\n  padding: var(--spacing-sm);\n  border-radius: var(--radius-sm);\n  transition: background var(--transition);\n}\n\n.checkbox-label:hover {\n  background: var(--color-bg);\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  accent-color: var(--color-primary);\n  cursor: pointer;\n}\n\n.radio-group {\n  display: flex;\n  gap: var(--spacing-md);\n  flex-wrap: wrap;\n}\n\n.radio-label {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  font-size: 0.95rem;\n  cursor: pointer;\n  padding: var(--spacing-sm) var(--spacing-md);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  transition: all var(--transition);\n}\n\n.radio-label:hover {\n  border-color: var(--color-primary-light);\n}\n\n.radio-label.selected {\n  border-color: var(--color-primary);\n  background: var(--color-primary-bg);\n  color: var(--color-primary);\n}\n\n.radio-label input[type=\"radio\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--color-primary);\n  cursor: pointer;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--spacing-lg);\n}\n\n/* --- Tables --- */\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.95rem;\n}\n\n.table th {\n  text-align: left;\n  padding: 12px 16px;\n  font-weight: 600;\n  font-size: 0.85rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--color-text-secondary);\n  background: var(--color-bg);\n  border-bottom: 2px solid var(--color-border);\n}\n\n.table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--color-border-light);\n  vertical-align: middle;\n}\n\n.table-striped tbody tr:nth-child(even) {\n  background: var(--color-bg);\n}\n\n.table tbody tr {\n  transition: background var(--transition);\n}\n\n.table tbody tr:hover {\n  background: var(--color-primary-bg);\n}\n\n/* --- Badges --- */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 12px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  border-radius: 999px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  white-space: nowrap;\n}\n\n.badge-global {\n  background: var(--brand-blue);\n  color: #FFFFFF;\n}\n\n.badge-strategic {\n  background: var(--color-info);\n  color: var(--color-text-inverse);\n}\n\n.badge-national {\n  background: var(--brand-teal);\n  color: #FFFFFF;\n}\n\n.badge-emerging {\n  background: var(--brand-green-4);\n  color: #FFFFFF;\n}\n\n.badge-local {\n  background: var(--color-warning);\n  color: var(--color-text-inverse);\n}\n\n.badge-non-kol {\n  background: var(--color-bg);\n  color: var(--color-text-secondary);\n  border: 1px solid var(--color-border);\n}\n\n/* --- Alerts --- */\n.alert {\n  padding: var(--spacing-md) var(--spacing-lg);\n  border-radius: var(--radius);\n  font-size: 0.95rem;\n  display: flex;\n  align-items: flex-start;\n  gap: var(--spacing-sm);\n  margin-bottom: var(--spacing-lg);\n}\n\n.alert svg {\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.alert-success {\n  background: var(--color-success-bg);\n  color: var(--color-success-text);\n  border: 1px solid var(--color-success-bg);\n}\n\n.alert-error {\n  background: var(--color-error-bg);\n  color: var(--color-error-text);\n  border: 1px solid var(--color-error-bg);\n}\n\n.alert-warning {\n  background: var(--color-warning-bg);\n  color: var(--color-warning-text);\n  border: 1px solid var(--color-warning-bg);\n}\n\n.alert-info {\n  background: var(--color-info-bg);\n  color: var(--color-info-text);\n  border: 1px solid var(--color-info-bg);\n}\n\n/* --- Modals --- */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  /* Ink-tinted rather than slate, to match the rest of the palette, and heavier\n     so the dialog reads as the only live thing on screen. */\n  background: var(--color-overlay);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-lg);\n  z-index: 1000;\n  animation: fadeIn 0.2s var(--ease);\n}\n\n.modal {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-xl);\n  width: 100%;\n  max-width: 520px;\n  /* The dialog itself no longer scrolls — the BODY does, so the header and the\n     footer buttons stay put instead of scrolling out of reach on a long form. */\n  max-height: min(88vh, 760px);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: slideUp 0.25s var(--ease);\n}\n\n.modal-header {\n  padding: var(--spacing-lg) var(--spacing-lg) var(--spacing-md);\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: var(--spacing-md);\n  flex: none;\n}\n\n.modal-header h2,\n.modal-header h3,\n.modal-header h4 {\n  font-size: var(--text-lg);\n  letter-spacing: var(--tracking-snug);\n  margin: 0;\n}\n\n/* The close control is usually a bare <button> in the header. */\n.modal-header > button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  flex: none;\n  border: none;\n  border-radius: var(--radius-sm);\n  background: none;\n  color: var(--color-text-light);\n  cursor: pointer;\n  transition: background var(--transition), color var(--transition);\n}\n\n.modal-header > button:hover {\n  background: var(--color-surface-hover);\n  color: var(--color-text);\n}\n\n.modal-body {\n  padding: 0 var(--spacing-lg) var(--spacing-lg);\n  overflow-y: auto;\n  flex: 1;\n}\n\n.modal-footer {\n  padding: var(--spacing-md) var(--spacing-lg);\n  border-top: 1px solid var(--color-border-light);\n  background: var(--color-surface-raised);\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--spacing-sm);\n  flex: none;\n}\n\n/* A dialog pinned to the middle of a phone screen leaves dead space above and\n   below and puts the actions mid-air. Below 600px it becomes a sheet. */\n@media (max-width: 600px) {\n  .modal-overlay {\n    align-items: flex-end;\n    padding: 0;\n  }\n\n  .modal {\n    max-width: none;\n    max-height: 92vh;\n    border-radius: var(--radius-lg) var(--radius-lg) 0 0;\n    border-bottom: none;\n    animation: sheetUp 0.28s var(--ease);\n  }\n\n  .modal-footer > .btn {\n    flex: 1;\n  }\n}\n\n@keyframes sheetUp {\n  from { transform: translateY(100%); }\n  to { transform: translateY(0); }\n}\n\n/* --- Dashboard Grid --- */\n.dashboard-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: var(--spacing-lg);\n}\n\n.stats-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));\n  gap: var(--spacing-md);\n  margin-bottom: var(--spacing-lg);\n  align-items: stretch;\n}\n\n/* --- Score Meter --- */\n.score-meter {\n  position: relative;\n  width: 160px;\n  height: 160px;\n  margin: 0 auto var(--spacing-lg);\n}\n\n.score-meter-circle {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  border: 8px solid var(--color-border-light);\n  position: relative;\n}\n\n.score-meter-value {\n  font-size: 2.5rem;\n  font-weight: 800;\n  color: var(--color-primary);\n  line-height: 1;\n}\n\n.score-meter-label {\n  font-size: 0.8rem;\n  color: var(--color-text-secondary);\n  margin-top: 4px;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 8px;\n  background: var(--color-border-light);\n  border-radius: 999px;\n  overflow: hidden;\n}\n\n.progress-bar-fill {\n  height: 100%;\n  border-radius: 999px;\n  background: var(--color-primary);\n  transition: width 0.6s ease;\n}\n\n/* --- Spinner --- */\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid var(--color-border);\n  border-top-color: var(--color-primary);\n  border-radius: 50%;\n  animation: spin 0.7s linear infinite;\n  margin: var(--spacing-xl) auto;\n}\n\n.spinner-sm {\n  width: 18px;\n  height: 18px;\n  border-width: 2px;\n  margin: 0;\n  display: inline-block;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-3xl);\n  color: var(--color-text-secondary);\n}\n\n/* --- Landing Page --- */\n.landing-page {\n  background: var(--color-white);\n  min-height: 100vh;\n}\n\n.landing-nav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--spacing-lg) var(--spacing-xl);\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.landing-nav-brand {\n  font-weight: 700;\n  font-size: 1.25rem;\n  color: var(--color-primary);\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n}\n\n.hero {\n  background: var(--color-secondary);\n  color: var(--color-text-inverse);\n  padding: 100px var(--spacing-xl) 120px;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.hero::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  width: 200%;\n  height: 200%;\n  background: none;\n}\n\n.hero-content {\n  position: relative;\n  z-index: 1;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.hero h1 {\n  font-size: 3.25rem;\n  font-weight: 800;\n  color: var(--color-text-inverse);\n  margin-bottom: var(--spacing-lg);\n  line-height: 1.15;\n  letter-spacing: -0.02em;\n}\n\n.hero p {\n  font-size: 1.25rem;\n  opacity: 0.9;\n  max-width: 600px;\n  margin: 0 auto var(--spacing-xl);\n  line-height: 1.7;\n}\n\n.hero-buttons {\n  display: flex;\n  gap: var(--spacing-md);\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.hero-buttons .btn-primary {\n  background: var(--color-surface);\n  color: var(--color-primary);\n  border-color: var(--color-surface);\n  padding: 14px 32px;\n  font-size: 1.05rem;\n}\n\n.hero-buttons .btn-primary:hover {\n  background: var(--color-primary-bg);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 24px rgba(0,0,0,0.2);\n}\n\n.hero-buttons .btn-outline {\n  color: var(--color-text-inverse);\n  border-color: rgba(255,255,255,0.4);\n  padding: 14px 32px;\n  font-size: 1.05rem;\n}\n\n.hero-buttons .btn-outline:hover {\n  background: rgba(255,255,255,0.1);\n  border-color: var(--color-surface);\n  color: var(--color-text-inverse);\n}\n\n.features {\n  padding: var(--spacing-3xl) var(--spacing-xl);\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.features h2 {\n  text-align: center;\n  margin-bottom: var(--spacing-xs);\n}\n\n.features > p {\n  text-align: center;\n  color: var(--color-text-secondary);\n  margin-bottom: var(--spacing-2xl);\n  font-size: 1.1rem;\n}\n\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: var(--spacing-lg);\n}\n\n.feature-card {\n  padding: var(--spacing-xl);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--color-border);\n  transition: all 0.3s ease;\n  text-align: center;\n}\n\n.feature-card:hover {\n  border-color: var(--color-primary-light);\n  box-shadow: var(--shadow-lg);\n  transform: translateY(-4px);\n}\n\n.feature-card .feature-icon {\n  width: 56px;\n  height: 56px;\n  background: var(--color-primary-bg);\n  border-radius: var(--radius-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto var(--spacing-md);\n  color: var(--color-primary);\n}\n\n.feature-card h3 {\n  font-size: 1.15rem;\n  margin-bottom: var(--spacing-sm);\n}\n\n.feature-card p {\n  color: var(--color-text-secondary);\n  font-size: 0.95rem;\n  line-height: 1.6;\n}\n\n.how-it-works {\n  background: var(--color-bg);\n  padding: var(--spacing-3xl) var(--spacing-xl);\n}\n\n.how-it-works-inner {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.how-it-works h2 {\n  text-align: center;\n  margin-bottom: var(--spacing-2xl);\n}\n\n.steps {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: var(--spacing-xl);\n}\n\n.step {\n  text-align: center;\n  padding: var(--spacing-xl);\n}\n\n.step-number {\n  width: 48px;\n  height: 48px;\n  background: var(--color-primary);\n  color: var(--color-primary-contrast);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 1.25rem;\n  margin: 0 auto var(--spacing-md);\n}\n\n.step h3 {\n  margin-bottom: var(--spacing-sm);\n}\n\n.step p {\n  color: var(--color-text-secondary);\n}\n\n.tier-section {\n  padding: var(--spacing-3xl) var(--spacing-xl);\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.tier-section h2 {\n  text-align: center;\n  margin-bottom: var(--spacing-sm);\n}\n\n.tier-section > p {\n  text-align: center;\n  color: var(--color-text-secondary);\n  margin-bottom: var(--spacing-2xl);\n  font-size: 1.05rem;\n}\n\n.tier-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: var(--spacing-md);\n}\n\n.tier-card {\n  padding: var(--spacing-lg);\n  border-radius: var(--radius-md);\n  text-align: center;\n  color: var(--color-text-inverse);\n  transition: transform 0.3s ease;\n}\n\n.tier-card:hover {\n  transform: scale(1.03);\n}\n\n.tier-card h4 {\n  color: var(--color-text-inverse);\n  font-size: 1.15rem;\n  margin-bottom: var(--spacing-xs);\n}\n\n.tier-card .tier-range {\n  font-size: 1.5rem;\n  font-weight: 800;\n  margin-bottom: var(--spacing-xs);\n}\n\n.tier-card p {\n  opacity: 0.9;\n  font-size: 0.9rem;\n}\n\n.stats-section {\n  background: var(--color-secondary);\n  padding: var(--spacing-3xl) var(--spacing-xl);\n  color: var(--color-text-inverse);\n}\n\n.stats-section-inner {\n  max-width: 1200px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.stats-section h2 {\n  color: var(--color-text-inverse);\n  margin-bottom: var(--spacing-2xl);\n}\n\n.stats-numbers {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: var(--spacing-xl);\n}\n\n.stats-numbers .stat-item .stat-num {\n  font-size: 2.5rem;\n  font-weight: 800;\n  margin-bottom: var(--spacing-xs);\n}\n\n.stats-numbers .stat-item .stat-desc {\n  opacity: 0.8;\n  font-size: 0.95rem;\n}\n\n/* --- Landing Nav Links --- */\n.landing-nav-links {\n  display: flex;\n  gap: var(--spacing-xl);\n}\n\n.landing-nav-links a {\n  color: var(--color-text-secondary);\n  font-weight: 500;\n  font-size: 0.95rem;\n  text-decoration: none;\n  transition: color var(--transition);\n}\n\n.landing-nav-links a:hover {\n  color: var(--color-primary);\n}\n\n/* --- Pricing Section --- */\n.pricing-section {\n  padding: var(--spacing-3xl) var(--spacing-xl);\n  max-width: 1200px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.pricing-section h2 {\n  margin-bottom: var(--spacing-xs);\n}\n\n.pricing-section > p {\n  color: var(--color-text-secondary);\n  font-size: 1.1rem;\n  margin-bottom: var(--spacing-xl);\n}\n\n.pricing-toggle {\n  display: inline-flex;\n  background: var(--color-bg);\n  border-radius: 50px;\n  padding: 4px;\n  margin-bottom: var(--spacing-2xl);\n  border: 1px solid var(--color-border);\n}\n\n.pricing-toggle-btn {\n  padding: 10px 24px;\n  border: none;\n  background: none;\n  border-radius: 50px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  transition: all var(--transition);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pricing-toggle-btn.active {\n  background: var(--color-primary);\n  color: var(--color-primary-contrast);\n  box-shadow: var(--shadow-sm);\n}\n\n.pricing-save-badge {\n  font-size: 0.7rem;\n  background: var(--color-success);\n  color: var(--color-text-inverse);\n  padding: 2px 8px;\n  border-radius: 50px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.pricing-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: var(--spacing-xl);\n  text-align: left;\n}\n\n.pricing-card {\n  background: var(--color-white);\n  border: 2px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  padding: var(--spacing-xl);\n  position: relative;\n  transition: all 0.3s ease;\n  display: flex;\n  flex-direction: column;\n}\n\n.pricing-card:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-lg);\n}\n\n.pricing-card.popular {\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 1px var(--color-primary), var(--shadow-lg);\n  transform: scale(1.03);\n}\n\n.pricing-card.popular:hover {\n  transform: scale(1.03) translateY(-4px);\n}\n\n.pricing-badge {\n  position: absolute;\n  top: -12px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: var(--color-primary);\n  color: var(--color-primary-contrast);\n  padding: 4px 16px;\n  border-radius: 50px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  white-space: nowrap;\n}\n\n.pricing-card h3 {\n  font-size: 1.35rem;\n  margin-bottom: 6px;\n}\n\n.pricing-desc {\n  color: var(--color-text-secondary);\n  font-size: 0.9rem;\n  margin-bottom: var(--spacing-lg);\n}\n\n.pricing-price {\n  display: flex;\n  align-items: baseline;\n  gap: 2px;\n  margin-bottom: 4px;\n}\n\n.pricing-currency {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--color-text);\n}\n\n.pricing-amount {\n  font-size: 3rem;\n  font-weight: 800;\n  color: var(--color-secondary);\n  line-height: 1;\n}\n\n.pricing-period {\n  font-size: 1rem;\n  color: var(--color-text-secondary);\n  font-weight: 500;\n}\n\n.pricing-yearly-note {\n  font-size: 0.82rem;\n  color: var(--color-text-light);\n  margin-bottom: var(--spacing-lg);\n}\n\n.pricing-card .btn-block {\n  width: 100%;\n  text-align: center;\n  margin: var(--spacing-lg) 0;\n  padding: 12px;\n}\n\n.pricing-features {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  flex: 1;\n}\n\n.pricing-features li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 0;\n  font-size: 0.92rem;\n  color: var(--color-text);\n  border-top: 1px solid var(--color-border-light);\n}\n\n.pricing-check {\n  color: var(--color-success);\n  flex-shrink: 0;\n}\n\n.cta {\n  padding: var(--spacing-3xl) var(--spacing-xl);\n  text-align: center;\n  background: var(--color-primary-bg);\n}\n\n.cta h2 {\n  margin-bottom: var(--spacing-md);\n}\n\n.cta p {\n  color: var(--color-text-secondary);\n  margin-bottom: var(--spacing-xl);\n  font-size: 1.1rem;\n}\n\n.landing-footer {\n  background: var(--color-secondary);\n  color: var(--color-text-light);\n  padding: var(--spacing-xl);\n  text-align: center;\n  font-size: 0.9rem;\n}\n\n/* --- Section titles --- */\n.section-title {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--color-secondary);\n  margin-bottom: var(--spacing-md);\n  padding-bottom: var(--spacing-sm);\n  border-bottom: 2px solid var(--color-primary-bg);\n}\n\n/* --- File Upload --- */\n.file-upload {\n  border: 2px dashed var(--color-border);\n  border-radius: var(--radius-md);\n  padding: var(--spacing-xl);\n  text-align: center;\n  cursor: pointer;\n  transition: all var(--transition);\n  background: var(--color-bg);\n}\n\n.file-upload:hover {\n  border-color: var(--color-primary-light);\n  background: var(--color-primary-bg);\n}\n\n.file-upload.active {\n  border-color: var(--color-primary);\n  background: var(--color-primary-bg);\n}\n\n.file-upload svg {\n  color: var(--color-text-light);\n  margin-bottom: var(--spacing-sm);\n}\n\n.file-upload p {\n  color: var(--color-text-secondary);\n  font-size: 0.95rem;\n}\n\n.file-upload .file-name {\n  color: var(--color-primary);\n  font-weight: 600;\n  margin-top: var(--spacing-sm);\n}\n\n/* --- Assessment Sections --- */\n.assessment-section {\n  background: var(--color-white);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-md);\n  margin-bottom: var(--spacing-lg);\n  overflow: hidden;\n}\n\n.assessment-section-header {\n  background: var(--color-bg);\n  padding: var(--spacing-md) var(--spacing-lg);\n  font-weight: 700;\n  font-size: 1rem;\n  color: var(--color-secondary);\n  border-bottom: 1px solid var(--color-border);\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n}\n\n.assessment-section-header .criterion-code {\n  background: var(--color-primary);\n  color: var(--color-primary-contrast);\n  padding: 2px 10px;\n  border-radius: var(--radius-sm);\n  font-size: 0.8rem;\n  font-weight: 700;\n}\n\n.assessment-section-body {\n  padding: var(--spacing-lg);\n}\n\n/* --- Results Page --- */\n.results-header {\n  text-align: center;\n  padding: var(--spacing-2xl);\n  background: var(--color-primary-bg);\n  border-radius: var(--radius-md);\n  margin-bottom: var(--spacing-xl);\n  border: 1px solid var(--color-border);\n}\n\n.results-breakdown {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--spacing-lg);\n  margin-bottom: var(--spacing-xl);\n}\n\n.score-summary {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: var(--spacing-md);\n  margin-bottom: var(--spacing-xl);\n}\n\n.score-summary-item {\n  text-align: center;\n  padding: var(--spacing-lg);\n  background: var(--color-white);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-md);\n}\n\n.score-summary-item .score-label {\n  font-size: 0.85rem;\n  color: var(--color-text-secondary);\n  margin-bottom: var(--spacing-xs);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  font-weight: 600;\n}\n\n.score-summary-item .score-number {\n  font-size: 1.75rem;\n  font-weight: 800;\n  color: var(--color-primary);\n}\n\n/* --- Collapsible --- */\n.collapsible-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: var(--spacing-md) var(--spacing-lg);\n  background: var(--color-bg);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 0.95rem;\n  transition: all var(--transition);\n  font-family: var(--font-sans);\n  color: var(--color-text);\n}\n\n.collapsible-trigger:hover {\n  background: var(--color-primary-bg);\n}\n\n.collapsible-content {\n  padding: var(--spacing-lg);\n  border: 1px solid var(--color-border);\n  border-top: none;\n  border-radius: 0 0 var(--radius) var(--radius);\n  background: var(--color-white);\n}\n\n/* --- Auth Pages --- */\n.auth-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--color-bg);\n  padding: var(--spacing-lg);\n}\n\n.auth-card {\n  background: var(--color-white);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-xl);\n  padding: var(--spacing-2xl);\n  width: 100%;\n  max-width: 440px;\n}\n\n.auth-card h2 {\n  text-align: center;\n  margin-bottom: var(--spacing-xs);\n}\n\n.auth-card .auth-subtitle {\n  text-align: center;\n  color: var(--color-text-secondary);\n  margin-bottom: var(--spacing-xl);\n}\n\n.auth-card .auth-footer {\n  text-align: center;\n  margin-top: var(--spacing-lg);\n  color: var(--color-text-secondary);\n  font-size: 0.9rem;\n}\n\n.auth-brand {\n  text-align: center;\n  margin-bottom: var(--spacing-xl);\n  color: var(--color-primary);\n  font-size: 1.35rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-sm);\n}\n\n/* --- Confidence Flags --- */\n.confidence-flags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--spacing-sm);\n}\n\n.confidence-flag {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  font-size: 0.8rem;\n  background: var(--color-warning-bg);\n  color: var(--color-warning-text);\n  border-radius: var(--radius-sm);\n  font-weight: 500;\n}\n\n.confidence-flag.ok {\n  background: var(--color-success-bg);\n  color: var(--color-success-text);\n}\n\n/* --- Animations --- */\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideUp {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes floatBg {\n  0%, 100% { transform: translate(0, 0); }\n  50% { transform: translate(-2%, 1%); }\n}\n\n/* --- Responsive --- */\n@media (max-width: 1024px) {\n  .pricing-grid {\n    grid-template-columns: 1fr;\n    max-width: 450px;\n    margin: 0 auto;\n  }\n\n  .pricing-card.popular {\n    transform: none;\n  }\n\n  .landing-nav-links {\n    display: none;\n  }\n\n\n  .features-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .tier-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .results-breakdown {\n    grid-template-columns: 1fr;\n  }\n\n  .stats-numbers {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  h1 { font-size: 1.75rem; }\n  h2 { font-size: 1.5rem; }\n\n  .hero h1 { font-size: 2.25rem; }\n  .hero { padding: 60px var(--spacing-lg) 80px; }\n\n  .stats-row {\n    grid-template-columns: 1fr;\n  }\n\n  .features-grid,\n  .steps,\n  .tier-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .score-summary {\n    grid-template-columns: 1fr;\n  }\n\n  .navbar {\n    padding: 0 var(--spacing-md);\n  }\n\n  /* Was `display: none` with no replacement, which left the app with no\n     navigation at all on a phone. It is now a panel the hamburger opens. */\n  .navbar-links {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    flex-direction: column;\n    align-items: stretch;\n    gap: var(--spacing-xs);\n    padding: var(--spacing-sm) var(--spacing-md) var(--spacing-md);\n    background: var(--color-surface);\n    border-bottom: 1px solid var(--color-border);\n    box-shadow: var(--shadow-lg);\n    display: none;\n  }\n\n  .navbar-links.is-open {\n    display: flex;\n  }\n\n  .navbar-links a {\n    padding: var(--spacing-md);\n    font-size: var(--text-md);\n  }\n\n  .navbar-toggle {\n    display: inline-flex;\n  }\n\n  .navbar {\n    position: sticky;\n  }\n\n  .navbar-inner {\n    position: relative;\n  }\n\n  /* The username is the first thing to go when the bar gets tight — the avatar\n     of information nobody needs at 375px. */\n  .navbar-username {\n    display: none;\n  }\n\n  .container {\n    padding: 0 var(--spacing-md);\n  }\n\n  .stats-numbers {\n    grid-template-columns: 1fr 1fr;\n    gap: var(--spacing-lg);\n  }\n\n  .hero-buttons {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .radio-group {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero h1 { font-size: 1.75rem; }\n\n  .auth-card {\n    padding: var(--spacing-lg);\n  }\n\n  .tier-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ============================================\n   Account Page\n   ============================================ */\n\n\n\n\n.account-card {\n  background: var(--color-white);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-md);\n  overflow: hidden;\n}\n\n.account-card-header {\n  padding: var(--spacing-lg);\n  border-bottom: 1px solid var(--color-border);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.account-card-header h3 {\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 1.1rem;\n}\n\n.account-card-body {\n  padding: var(--spacing-lg);\n}\n\n.profile-detail {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 0;\n  border-bottom: 1px solid var(--color-border-light);\n  font-size: 0.95rem;\n}\n\n.profile-detail:last-child {\n  border-bottom: none;\n}\n\n.profile-label {\n  color: var(--color-text-secondary);\n  min-width: 120px;\n  font-weight: 500;\n}\n\n.form-row-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--spacing-md);\n}\n\n/* Current Plan */\n.current-plan-info {\n  display: flex;\n  align-items: baseline;\n  gap: var(--spacing-lg);\n  margin-bottom: var(--spacing-lg);\n  padding-bottom: var(--spacing-lg);\n  border-bottom: 1px solid var(--color-border-light);\n}\n\n.current-plan-name {\n  font-size: 1.75rem;\n  color: var(--color-primary);\n  margin: 0;\n}\n\n.current-plan-price {\n  font-size: 1.1rem;\n  color: var(--color-text-secondary);\n  font-weight: 600;\n}\n\n.current-plan-features h4 {\n  font-size: 0.85rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--color-text-secondary);\n  margin: var(--spacing-lg) 0 var(--spacing-sm);\n}\n\n.current-plan-features ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 6px 24px;\n}\n\n.current-plan-features li {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.9rem;\n  padding: 4px 0;\n}\n\n/* Badges */\n.badge-success {\n  background: var(--color-success-bg);\n  color: var(--color-success-text);\n}\n\n.badge-warning {\n  background: var(--color-warning-bg);\n  color: var(--color-warning-text);\n}\n\n.badge-danger {\n  background: var(--color-error-bg);\n  color: var(--color-error-text);\n}\n\n/* Invoice Table */\n.invoice-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.invoice-table th {\n  text-align: left;\n  padding: 12px 16px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--color-text-secondary);\n  background: var(--color-bg);\n  border-bottom: 1px solid var(--color-border);\n}\n\n.invoice-table td {\n  padding: 12px 16px;\n  font-size: 0.9rem;\n  border-bottom: 1px solid var(--color-border-light);\n}\n\n.invoice-table .font-mono {\n  font-family: var(--font-mono);\n  font-size: 0.82rem;\n}\n\n/* Subscribe Modal */\n.subscribe-cycle-toggle {\n  display: flex;\n  justify-content: center;\n  gap: 4px;\n  background: var(--color-bg);\n  border-radius: 50px;\n  padding: 4px;\n  margin-bottom: var(--spacing-xl);\n  border: 1px solid var(--color-border);\n  width: fit-content;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.subscribe-plans-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: var(--spacing-md);\n}\n\n.subscribe-plan-card {\n  border: 2px solid var(--color-border);\n  border-radius: var(--radius-md);\n  padding: var(--spacing-lg);\n  cursor: pointer;\n  transition: all var(--transition);\n  position: relative;\n}\n\n.subscribe-plan-card:hover {\n  border-color: var(--color-primary-light);\n}\n\n.subscribe-plan-card.selected {\n  border-color: var(--color-primary);\n  background: var(--color-primary-bg);\n}\n\n.subscribe-plan-card.popular {\n  border-color: var(--color-primary-light);\n}\n\n.subscribe-plan-card.current {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.subscribe-plan-card h4 {\n  margin: 0 0 8px;\n}\n\n.subscribe-price {\n  font-size: 1.75rem;\n  font-weight: 800;\n  color: var(--color-secondary);\n  margin-bottom: 12px;\n}\n\n.subscribe-price span {\n  font-size: 1rem;\n}\n\n.subscribe-price small {\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--color-text-secondary);\n}\n\n.subscribe-features {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.subscribe-features li {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.82rem;\n  padding: 3px 0;\n  color: var(--color-text-secondary);\n}\n\n.subscribe-features li svg {\n  color: var(--color-success);\n  flex-shrink: 0;\n}\n\n.subscribe-features .more {\n  color: var(--color-text-light);\n  font-style: italic;\n}\n\n.subscribe-current-badge,\n.subscribe-badge {\n  position: absolute;\n  top: -10px;\n  right: 12px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  padding: 2px 10px;\n  border-radius: 50px;\n  text-transform: uppercase;\n}\n\n.subscribe-current-badge {\n  background: var(--color-text-secondary);\n  color: var(--color-text-inverse);\n}\n\n.subscribe-badge {\n  background: var(--color-primary);\n  color: var(--color-primary-contrast);\n}\n\n.spinning {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 768px) {\n  .form-row-2 {\n    grid-template-columns: 1fr;\n  }\n  .current-plan-features ul {\n    grid-template-columns: 1fr;\n  }\n  .subscribe-plans-grid {\n    grid-template-columns: 1fr;\n  }\n  .checkout-layout {\n    flex-direction: column !important;\n  }\n  .checkout-summary {\n    order: -1;\n  }\n  .new-assessment-grid {\n    grid-template-columns: 1fr !important;\n  }\n}\n\n/* ============================================\n   Responsive foundation\n   ============================================ */\n\n/* Nothing should be able to push the page sideways. Scrolling belongs to the\n   element that is too wide (a table, a code block), never to the document.\n\n   `clip`, NOT `hidden`: overflow:hidden makes the box a scroll container, and a\n   `position: sticky` child then sticks to THAT box instead of the viewport —\n   which silently broke the sticky app bar. overflow:clip clips without creating\n   a scrollport, so sticky keeps working. */\n.app-main {\n  overflow-x: clip;\n}\n\n/* Emails, tokens and URLs are unbreakable strings that otherwise widen their\n   container until the layout gives. */\n.table td,\n.card-body p,\n.page-header p {\n  overflow-wrap: anywhere;\n}\n\n@media (max-width: 900px) {\n  .container,\n  .container-sm {\n    padding: 0 var(--spacing-md);\n  }\n}\n\n@media (max-width: 760px) {\n  /* Tables had no overflow handling at all — a wide one simply broke the page.\n     display:block turns the table itself into the scroll container, so it stays\n     readable by swiping instead of shrinking columns into unreadable slivers. */\n  .table {\n    display: block;\n    max-width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .page-header {\n    margin-bottom: var(--spacing-lg);\n  }\n\n  /* Page headers are usually title-left / action-right; at this width the action\n     belongs under the title, full width, where a thumb can reach it. */\n  .page-header[style*=\"flex\"] {\n    flex-direction: column;\n    align-items: stretch !important;\n    gap: var(--spacing-md);\n  }\n\n  .btn {\n    padding: 10px 18px;\n  }\n}\n\n@media (max-width: 640px) {\n  /* Inline grid templates are written in JS and cannot carry a media query.\n     A stylesheet !important is the one declaration that outranks an inline\n     style, so this is the only way to reach them. At this width a multi-column\n     layout is wrong regardless of what the template says. Opt out with\n     `keep-grid` on anything that genuinely must stay side by side. */\n  [style*=\"grid-template-columns\"]:not(.keep-grid) {\n    grid-template-columns: 1fr !important;\n  }\n\n  h1 { font-size: var(--text-2xl); }\n  h2 { font-size: var(--text-xl); }\n  h3 { font-size: var(--text-lg); }\n\n  .card-body,\n  .card-header {\n    padding: var(--spacing-md);\n  }\n\n  /* Full-width actions read better than a row of half-width buttons. */\n  .btn-lg {\n    width: 100%;\n  }\n}\n\n/* --- Advisory Boards: meetings feed --- */\n.ab-panel {\n  padding: var(--spacing-md) var(--spacing-lg) var(--spacing-lg);\n  margin-bottom: var(--spacing-md);\n}\n\n.ab-panel-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--spacing-sm);\n  margin-bottom: 4px;\n}\n\n.ab-panel-head > span {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: var(--text-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--color-text-light);\n}\n\n.ab-panel-head svg { color: var(--color-primary); }\n\n.ab-list { display: flex; flex-direction: column; }\n\n.ab-row {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n  padding: 10px 0;\n  border-bottom: 1px solid var(--color-border-light);\n}\n\n.ab-row:last-child { border-bottom: none; }\n\n.ab-row-main { flex: 1; min-width: 0; display: flex; flex-direction: column; }\n\n.ab-row-title {\n  font-weight: 600;\n  font-size: var(--text-base);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ab-row-meta {\n  font-size: var(--text-xs);\n  color: var(--color-text-secondary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* A call happening right now should be the loudest thing on the row. */\n.ab-live {\n  flex: none;\n  font-size: var(--text-xs);\n  font-weight: 700;\n  color: var(--color-success);\n  white-space: nowrap;\n}\n\n/* --- Assessments: insights band --- */\n.insights-toggle {\n  border: none;\n  background: none;\n  padding: 0 0 var(--spacing-sm);\n  font-family: inherit;\n  font-size: var(--text-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--color-text-light);\n  cursor: pointer;\n}\n\n.insights-toggle:hover { color: var(--color-primary-dark); }\n\n.insights-grid {\n  display: grid;\n  /* 230px lets four cards share one row on a normal desktop instead of three\n     plus an orphan, which left two empty columns. */\n  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));\n  gap: var(--spacing-md);\n  margin-bottom: var(--spacing-md);\n  /* stretch, NOT start: with `start` every card sized to its own content, so a\n     two-row list sat beside a tall chart with a ragged gap underneath it. */\n  align-items: stretch;\n}\n\n.insight-card {\n  padding: var(--spacing-md) var(--spacing-lg) var(--spacing-lg);\n  display: flex;\n  flex-direction: column;\n}\n\n/* The body takes the slack in a stretched card, so a short list is spaced out\n   rather than huddled at the top over dead space. */\n.insight-card > .leader-list,\n.insight-card > .rank-list,\n.insight-card > .dist-chart {\n  flex: 1;\n  justify-content: space-evenly;\n}\n\n.insight-head {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: var(--text-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--color-text-light);\n}\n\n.insight-head svg { color: var(--color-primary); }\n\n/* Inside a narrow insight card the default rank layout gave the bar most of the\n   width and truncated the label it was describing. The label matters more than\n   two extra pixels of bar. */\n.insight-card .rank-row {\n  /* The track is capped so a card that ends up full width (one insight card in\n     the row) does not stretch a \"0/1\" bar across 600px. */\n  grid-template-columns: minmax(0, 1.5fr) minmax(0, 1fr) auto;\n  gap: 8px;\n}\n\n.insight-card .rank-track { max-width: 320px; }\n\n.insight-card .rank-label { font-size: var(--text-xs); }\n\n/* Section label inside an insight card that holds more than one list. */\n.insight-subhead {\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: var(--color-text-light);\n  margin: var(--spacing-md) 0 2px;\n}\n\n.insight-subhead:first-of-type { margin-top: var(--spacing-sm); }\n\n.insight-note {\n  font-size: var(--text-xs);\n  color: var(--color-text-light);\n  /* auto pushes it to the bottom of a stretched card instead of leaving the\n     gap below it. */\n  margin: auto 0 0;\n  padding-top: var(--spacing-sm);\n  border-top: 1px solid var(--color-border-light);\n}\n\n/* Leaderboard */\n.leader-list { display: flex; flex-direction: column; gap: 8px; padding-top: 12px; }\n\n.leader-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: inherit;\n  text-decoration: none;\n  padding: 3px 0;\n}\n\n.leader-row:hover .leader-name { color: var(--color-primary-dark); }\n\n.leader-rank {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  flex: none;\n  border-radius: var(--radius-full);\n  background: var(--color-surface-raised);\n  color: var(--color-text-secondary);\n  font-size: 0.68rem;\n  font-weight: 700;\n}\n\n/* Only the top three get a colour — a \"rank\" badge on every row is just noise. */\n.leader-rank.rank-1 { background: var(--color-warning-bg); color: var(--color-warning-text); }\n.leader-rank.rank-2 { background: var(--color-surface-hover); color: var(--color-text); }\n.leader-rank.rank-3 { background: var(--color-primary-bg); color: var(--color-primary-dark); }\n\n.leader-main { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 4px; }\n\n.leader-name {\n  font-size: var(--text-sm);\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.leader-bar {\n  height: 6px;\n  border-radius: var(--radius-full);\n  background: var(--color-surface-raised);\n  overflow: hidden;\n}\n\n.leader-fill {\n  display: block;\n  height: 100%;\n  border-radius: var(--radius-full);\n  background: var(--color-primary);\n}\n\n.leader-score {\n  font-size: var(--text-sm);\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  flex: none;\n}\n\n/* Score distribution */\n.dist-chart {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n  padding-top: 14px;\n}\n\n.dist-col {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.dist-count {\n  font-size: var(--text-xs);\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n\n/* The track gives every column one baseline and one ceiling, so bars are\n   comparable instead of each being sized to its own content. */\n.dist-track {\n  width: 100%;\n  height: 62px;\n  display: flex;\n  align-items: flex-end;\n  background: var(--color-surface-raised);\n  border-radius: var(--radius-sm);\n  overflow: hidden;\n}\n\n.dist-bar {\n  width: 100%;\n  background: var(--color-primary);\n  border-radius: var(--radius-sm) var(--radius-sm) 0 0;\n  min-height: 2px;\n  transition: height var(--transition-slow);\n}\n\n.dist-label {\n  font-size: 0.65rem;\n  color: var(--color-text-light);\n  white-space: nowrap;\n}\n\n/* A rank row that is also a filter. */\n.rank-row-btn {\n  border: none;\n  background: none;\n  padding: 2px 0;\n  font-family: inherit;\n  text-align: left;\n  cursor: pointer;\n  border-radius: var(--radius-sm);\n}\n\n.rank-row-btn:hover .rank-label { color: var(--color-text); }\n.rank-row-btn.is-active .rank-label { color: var(--color-primary-dark); font-weight: 600; }\n.rank-row-btn.is-active .rank-fill { background: var(--color-primary-dark); }\n\n/* --- Follow-up chips --- */\n.flag-chips {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: var(--spacing-md);\n}\n\n.flag-chips-label {\n  font-size: var(--text-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--color-text-light);\n  margin-right: 2px;\n}\n\n.flag-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 11px;\n  border: 1px solid var(--color-warning);\n  border-radius: var(--radius-full);\n  background: var(--color-warning-bg);\n  color: var(--color-warning-text);\n  font-family: inherit;\n  font-size: var(--text-xs);\n  font-weight: 500;\n  cursor: pointer;\n  transition: background var(--transition), border-color var(--transition);\n}\n\n.flag-chip:hover { border-color: var(--color-warning-text); }\n\n.flag-chip.is-active {\n  background: var(--color-warning-text);\n  border-color: var(--color-warning-text);\n  color: var(--color-warning-bg);\n}\n\n.flag-chip strong { font-variant-numeric: tabular-nums; }\n\n/* --- Card provenance flags --- */\n.card-flags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n  margin-top: 8px;\n}\n\n.card-flag {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: var(--radius-full);\n  background: var(--color-surface-raised);\n  color: var(--color-text-light);\n  font-size: 0.68rem;\n  font-weight: 600;\n  /* Missing reads as absent rather than as an error — most of these are\n     optional, and a wall of red would be wrong. */\n  opacity: 0.55;\n}\n\n.card-flag.is-on {\n  background: var(--color-success-bg);\n  color: var(--color-success-text);\n  opacity: 1;\n}\n\n/* --- Assessments: tier mix + filter toolbar --- */\n/* One colour per tier, shared by the stacked bar and the legend dots so the\n   two always agree. Ordered high → low. */\n.tier-global_kol   { background: var(--brand-blue); }\n.tier-strategic_kol{ background: var(--brand-teal); }\n.tier-national_kol { background: var(--brand-green-4); }\n.tier-emerging_kol { background: var(--brand-green-3); }\n.tier-local_kol    { background: var(--brand-green-1); }\n.tier-non_kol      { background: var(--color-text-light); }\n\n.tier-mix {\n  padding: var(--spacing-md) var(--spacing-lg);\n  margin-bottom: var(--spacing-md);\n}\n\n.tier-mix-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.tier-mix-title {\n  font-size: var(--text-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.09em;\n  color: var(--color-text-light);\n}\n\n.tier-mix-total {\n  font-size: var(--text-xs);\n  color: var(--color-text-light);\n  font-variant-numeric: tabular-nums;\n}\n\n.tier-mix-bar {\n  display: flex;\n  height: 10px;\n  border-radius: var(--radius-full);\n  overflow: hidden;\n  background: var(--color-surface-raised);\n}\n\n.tier-mix-seg { display: block; }\n\n.tier-mix-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 10px;\n}\n\n/* Each legend entry is also the filter for that tier — the fastest way to\n   answer \"show me the Global KOLs\". */\n.tier-mix-key {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-full);\n  background: var(--color-surface);\n  color: var(--color-text-secondary);\n  font-family: inherit;\n  font-size: var(--text-xs);\n  text-transform: capitalize;\n  cursor: pointer;\n  transition: border-color var(--transition), background var(--transition), color var(--transition);\n}\n\n.tier-mix-key:hover { border-color: var(--color-border-strong); color: var(--color-text); }\n\n.tier-mix-key.is-active {\n  border-color: var(--color-primary);\n  background: var(--color-primary-bg);\n  color: var(--color-primary-dark);\n}\n\n.tier-mix-key strong { font-variant-numeric: tabular-nums; }\n\n.tier-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: var(--radius-full);\n  flex: none;\n}\n\n.filter-bar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--spacing-sm);\n  margin-bottom: var(--spacing-sm);\n}\n\n.filter-search {\n  position: relative;\n  flex: 1 1 260px;\n  min-width: 200px;\n  display: flex;\n  align-items: center;\n}\n\n.filter-search svg {\n  position: absolute;\n  left: 12px;\n  color: var(--color-text-light);\n  pointer-events: none;\n}\n\n.filter-search .form-control { padding-left: 36px; }\n\n.filter-select {\n  width: auto;\n  flex: 0 1 auto;\n  min-width: 130px;\n  max-width: 210px;\n}\n\n.filter-summary {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  margin-bottom: var(--spacing-md);\n  font-size: var(--text-sm);\n  color: var(--color-text-secondary);\n}\n\n@media (max-width: 640px) {\n  /* Stacked, the selects should use the full width rather than sitting in a\n     ragged row of different sizes. */\n  .filter-select,\n  .filter-bar .btn {\n    width: 100%;\n    max-width: none;\n  }\n}\n\n/* --- Ranked bar list (tier mix, top specialties) ---\n   These classes were written for the admin panel first; the frontend used them\n   without ever defining them, so the bars rendered as bare label+count text. */\n.rank-list {\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n  padding: 10px 0 2px;\n}\n\n.rank-row {\n  display: grid;\n  grid-template-columns: minmax(78px, 1fr) minmax(0, 1.6fr) auto;\n  align-items: center;\n  gap: 10px;\n}\n\n.rank-label {\n  font-size: var(--text-xs);\n  color: var(--color-text-secondary);\n  text-transform: capitalize;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rank-track {\n  height: 8px;\n  background: var(--color-surface-raised);\n  border-radius: var(--radius-full);\n  overflow: hidden;\n}\n\n.rank-fill {\n  display: block;\n  height: 100%;\n  background: var(--color-primary);\n  border-radius: var(--radius-full);\n  transition: width var(--transition-slow);\n}\n\n.rank-count {\n  font-size: var(--text-sm);\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  min-width: 20px;\n  text-align: right;\n}\n\n/* --- Dashboard: quick actions, chips, panel notes --- */\n.quick-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 6px 0 2px;\n}\n\n.quick-action {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface);\n  color: var(--color-text);\n  font-size: var(--text-base);\n  font-weight: 500;\n  text-decoration: none;\n  transition: border-color var(--transition), background var(--transition);\n}\n\n.quick-action:hover {\n  border-color: var(--color-primary);\n  background: var(--color-primary-bg);\n  color: var(--color-primary-dark);\n}\n\n.quick-action-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  flex: none;\n  border-radius: var(--radius-sm);\n  background: var(--color-surface-raised);\n  color: var(--color-primary-dark);\n}\n\n.quick-action:hover .quick-action-icon {\n  background: var(--color-surface);\n}\n\n/* Nudges right on hover, so the row reads as \"go somewhere\". */\n.quick-action-arrow {\n  margin-left: auto;\n  flex: none;\n  opacity: 0;\n  transform: translateX(-4px);\n  transition: opacity var(--transition), transform var(--transition);\n}\n\n.quick-action:hover .quick-action-arrow {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.panel-note {\n  font-size: var(--text-xs);\n  color: var(--color-text-light);\n  font-variant-numeric: tabular-nums;\n}\n\n.panel-subhead {\n  font-size: var(--text-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--color-text-light);\n  margin: var(--spacing-md) 0 var(--spacing-sm);\n  padding-top: var(--spacing-sm);\n  border-top: 1px solid var(--color-border-light);\n}\n\n.chip-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: var(--radius-full);\n  background: var(--color-surface-raised);\n  color: var(--color-text-secondary);\n  font-size: var(--text-xs);\n  font-weight: 500;\n}\n\n.chip-count {\n  font-weight: 700;\n  color: var(--color-text);\n  font-variant-numeric: tabular-nums;\n}\n\n/* --- Dashboard list rows (recent assessments, most answered, boards) --- */\n.dash-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.dash-row {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n  padding: 11px 2px;\n  border-bottom: 1px solid var(--color-border-light);\n  color: inherit;\n  text-decoration: none;\n  transition: background var(--transition);\n}\n\n.dash-row:last-child { border-bottom: none; }\n\n.dash-row:hover {\n  background: var(--color-surface-hover);\n  color: inherit;\n}\n\n.dash-row-main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.dash-row-title {\n  font-weight: 600;\n  font-size: var(--text-base);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dash-row-meta {\n  font-size: var(--text-xs);\n  color: var(--color-text-secondary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dash-row-value {\n  font-weight: 700;\n  font-size: var(--text-md);\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n  flex: none;\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n}\n\n.dash-row-unit {\n  font-size: var(--text-xs);\n  font-weight: 500;\n  color: var(--color-text-light);\n}\n\n.dash-row-cta {\n  font-size: var(--text-xs);\n  font-weight: 700;\n  color: var(--color-primary-dark);\n  white-space: nowrap;\n  flex: none;\n}\n\n.dash-tier {\n  font-size: 0.66rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  padding: 3px 8px;\n  border-radius: var(--radius-full);\n  background: var(--color-primary-bg);\n  color: var(--color-primary-dark);\n  white-space: nowrap;\n  flex: none;\n}\n\n@media (max-width: 640px) {\n  /* The tier chip is the first thing to go when the row gets tight — the score\n     and the name matter more. */\n  .dash-tier { display: none; }\n}\n\n/* --- Coming soon (entitled module with no screen yet) --- */\n.coming-soon {\n  max-width: 520px;\n  margin: var(--spacing-2xl) auto;\n  padding: var(--spacing-2xl) var(--spacing-xl);\n  text-align: center;\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n}\n\n.coming-soon-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 64px;\n  height: 64px;\n  margin: 0 auto var(--spacing-md);\n  border-radius: var(--radius-md);\n  background: var(--color-primary-bg);\n  color: var(--color-primary-dark);\n}\n\n.coming-soon-badge {\n  display: inline-block;\n  font-size: var(--text-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.09em;\n  padding: 4px 12px;\n  border-radius: var(--radius-full);\n  background: var(--color-warning-bg);\n  color: var(--color-warning-text);\n  margin-bottom: var(--spacing-md);\n}\n\n.coming-soon h2 {\n  margin-bottom: var(--spacing-sm);\n}\n\n.coming-soon p {\n  color: var(--color-text-secondary);\n  margin-bottom: var(--spacing-md);\n}\n\n.coming-soon-note {\n  font-size: var(--text-sm);\n  color: var(--color-text-light);\n  padding-top: var(--spacing-md);\n  border-top: 1px solid var(--color-border-light);\n}\n\n/* --- New Assessment --- */\n.new-assessment-aside {\n  position: sticky;\n  /* Clears the sticky app bar. */\n  top: calc(var(--appbar-h) + var(--spacing-md));\n}\n\n.new-assessment-actions {\n  display: flex;\n  gap: var(--spacing-sm);\n  justify-content: flex-end;\n  align-items: center;\n  padding-top: var(--spacing-md);\n  border-top: 1px solid var(--color-border);\n}\n\n@media (max-width: 900px) {\n  /* Stacked, a sticky aside would pin the CV panel over the form. */\n  .new-assessment-aside {\n    position: static;\n  }\n\n  .new-assessment-actions {\n    justify-content: stretch;\n  }\n\n  .new-assessment-actions .btn {\n    flex: 1;\n  }\n}\n\n/* --- New Assessment: repeatable row editors ---\n   The column template is computed per section in JS, so it lands as an inline\n   style that no media query can reach. `!important` from a stylesheet is the one\n   thing that does outrank an inline style, and stacking is the only sane layout\n   for a four-column row on a phone. */\n@media (max-width: 760px) {\n  .rowsection-row {\n    grid-template-columns: 1fr !important;\n    gap: 6px !important;\n    padding-bottom: var(--spacing-sm);\n    border-bottom: 1px dashed var(--color-border);\n  }\n\n  /* The delete button is last in DOM order; full-width it so the row reads as\n     a small card with its own remove action rather than a stray icon. */\n  .rowsection-row > button {\n    justify-self: end;\n  }\n}\n\n/* ============================================\n   Checkout Page\n   ============================================ */\n\n.checkout-wrapper {\n  max-width: 960px;\n  margin: 0 auto;\n}\n\n.checkout-empty {\n  text-align: center;\n  padding: 80px 20px;\n}\n\n.checkout-empty svg {\n  color: var(--color-text-light);\n  margin-bottom: 16px;\n}\n\n.checkout-empty h2 {\n  margin-bottom: 8px;\n}\n\n.checkout-empty p {\n  color: var(--color-text-secondary);\n  margin-bottom: 24px;\n}\n\n/* Steps */\n.checkout-steps {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0;\n  margin-bottom: var(--spacing-2xl);\n}\n\n.checkout-step {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--color-text-light);\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.checkout-step.active {\n  color: var(--color-primary);\n}\n\n.checkout-step.done {\n  color: var(--color-success);\n}\n\n.checkout-step-num {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 2px solid currentColor;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 0.85rem;\n}\n\n.checkout-step.active .checkout-step-num {\n  background: var(--color-primary);\n  color: var(--color-primary-contrast);\n  border-color: var(--color-primary);\n}\n\n.checkout-step.done .checkout-step-num {\n  background: var(--color-success);\n  color: var(--color-text-inverse);\n  border-color: var(--color-success);\n}\n\n.checkout-step-line {\n  width: 40px;\n  height: 2px;\n  background: var(--color-border);\n  margin: 0 12px;\n}\n\n/* Layout */\n.checkout-layout {\n  display: flex;\n  gap: var(--spacing-xl);\n  align-items: flex-start;\n}\n\n.checkout-form-section {\n  flex: 1;\n}\n\n.checkout-card {\n  background: var(--color-white);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-md);\n  padding: var(--spacing-xl);\n}\n\n.checkout-card h3 {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 4px;\n}\n\n.checkout-hint {\n  color: var(--color-text-secondary);\n  font-size: 0.88rem;\n  margin-bottom: var(--spacing-lg);\n}\n\n.checkout-secure-note {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.82rem;\n  color: var(--color-success);\n  margin-bottom: var(--spacing-md);\n}\n\n.checkout-gateway-info {\n  background: var(--color-primary-bg);\n  border: 1px solid var(--color-primary-light);\n  border-radius: var(--radius-md);\n  padding: var(--spacing-md);\n  margin-bottom: var(--spacing-lg);\n}\n\n.checkout-gateway-badge {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.95rem;\n  color: var(--color-primary-dark);\n}\n\n.checkout-payment-summary {\n  margin-bottom: var(--spacing-md);\n  padding: var(--spacing-md) 0;\n  border-top: 1px solid var(--color-border);\n  border-bottom: 1px solid var(--color-border);\n}\n\n.checkout-gateway-note {\n  margin-top: var(--spacing-md);\n  text-align: center;\n  font-size: 0.8rem;\n  color: var(--color-text-light);\n}\n\n/* Order Summary */\n.checkout-summary {\n  width: 320px;\n  flex-shrink: 0;\n}\n\n.checkout-summary-card {\n  background: var(--color-white);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-md);\n  padding: var(--spacing-xl);\n  position: sticky;\n  top: 84px;\n}\n\n.checkout-summary-card h4 {\n  margin-bottom: var(--spacing-md);\n  font-size: 1rem;\n}\n\n.checkout-plan-name {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--color-primary);\n}\n\n.checkout-plan-cycle {\n  font-size: 0.88rem;\n  color: var(--color-text-secondary);\n  margin-bottom: 4px;\n}\n\n.checkout-summary-divider {\n  height: 1px;\n  background: var(--color-border-light);\n  margin: var(--spacing-md) 0;\n}\n\n.checkout-plan-features {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.checkout-plan-features li {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.85rem;\n  padding: 3px 0;\n  color: var(--color-text-secondary);\n}\n\n.checkout-plan-features li svg {\n  color: var(--color-success);\n  flex-shrink: 0;\n}\n\n.checkout-total-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.9rem;\n  padding: 4px 0;\n  color: var(--color-text-secondary);\n}\n\n.checkout-total-row.total {\n  font-weight: 700;\n  font-size: 1.05rem;\n  color: var(--color-secondary);\n}\n\n/* Success */\n.checkout-success {\n  text-align: center;\n  padding: 60px var(--spacing-xl);\n}\n\n.checkout-success-icon {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  background: var(--color-success-bg);\n  color: var(--color-success);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto var(--spacing-lg);\n}\n\n.checkout-success h2 {\n  margin-bottom: 8px;\n  color: var(--color-success);\n}\n\n.checkout-success p {\n  color: var(--color-text-secondary);\n  margin-bottom: 4px;\n}\n\n/* ============================================\n   Quill Rich Text - Rendered Content\n   ============================================ */\n/* ── Rich text editor (Quill \"snow\") in dark mode ──\n   quill.snow.css is a third-party stylesheet with hardcoded #ccc borders, #444\n   icon strokes and #fff panels — none of it reads our tokens, so the toolbar and\n   especially its picker DROPDOWNS stayed white-on-white when the dark theme was\n   on. These override the handful of declarations that carry colour. */\n[data-theme='dark'] .ql-toolbar.ql-snow,\n[data-theme='dark'] .ql-container.ql-snow {\n  border-color: var(--color-border);\n}\n\n[data-theme='dark'] .ql-toolbar.ql-snow {\n  background: var(--color-surface-raised);\n}\n\n[data-theme='dark'] .ql-container.ql-snow {\n  background: var(--color-surface);\n}\n\n[data-theme='dark'] .ql-editor {\n  color: var(--color-text);\n}\n\n[data-theme='dark'] .ql-editor.ql-blank::before {\n  color: var(--color-text-light);\n}\n\n/* Toolbar icons are inline SVG strokes and fills, not glyphs. */\n[data-theme='dark'] .ql-snow .ql-stroke { stroke: var(--color-text-secondary); }\n[data-theme='dark'] .ql-snow .ql-fill,\n[data-theme='dark'] .ql-snow .ql-stroke.ql-fill { fill: var(--color-text-secondary); }\n[data-theme='dark'] .ql-snow .ql-picker { color: var(--color-text-secondary); }\n\n[data-theme='dark'] .ql-snow.ql-toolbar button:hover .ql-stroke,\n[data-theme='dark'] .ql-snow.ql-toolbar button.ql-active .ql-stroke,\n[data-theme='dark'] .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,\n[data-theme='dark'] .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke { stroke: var(--color-primary); }\n\n[data-theme='dark'] .ql-snow.ql-toolbar button:hover .ql-fill,\n[data-theme='dark'] .ql-snow.ql-toolbar button.ql-active .ql-fill,\n[data-theme='dark'] .ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill { fill: var(--color-primary); }\n\n[data-theme='dark'] .ql-snow.ql-toolbar button:hover,\n[data-theme='dark'] .ql-snow.ql-toolbar button.ql-active,\n[data-theme='dark'] .ql-snow.ql-toolbar .ql-picker-label:hover,\n[data-theme='dark'] .ql-snow.ql-toolbar .ql-picker-item:hover,\n[data-theme='dark'] .ql-snow.ql-toolbar .ql-picker-item.ql-selected { color: var(--color-primary); }\n\n/* The dropdown panel itself — the part that was an unreadable white sheet. */\n[data-theme='dark'] .ql-snow .ql-picker-options {\n  background: var(--color-surface-raised);\n  border-color: var(--color-border-strong);\n  box-shadow: var(--shadow-lg);\n}\n\n[data-theme='dark'] .ql-snow .ql-picker.ql-expanded .ql-picker-label,\n[data-theme='dark'] .ql-snow .ql-picker.ql-expanded .ql-picker-options {\n  border-color: var(--color-border-strong);\n}\n\n/* Link tooltip. */\n[data-theme='dark'] .ql-snow .ql-tooltip {\n  background: var(--color-surface-raised);\n  border-color: var(--color-border-strong);\n  box-shadow: var(--shadow-lg);\n  color: var(--color-text);\n}\n\n[data-theme='dark'] .ql-snow .ql-tooltip input[type=text] {\n  background: var(--color-surface);\n  border-color: var(--color-border);\n  color: var(--color-text);\n}\n\n[data-theme='dark'] .ql-snow .ql-tooltip a.ql-action,\n[data-theme='dark'] .ql-snow .ql-tooltip a.ql-remove,\n[data-theme='dark'] .ql-snow a { color: var(--color-primary); }\n\n.ql-editor p {\n  margin: 0;\n  line-height: 1.5;\n}\n.ql-editor p + p {\n  margin-top: 0.25em;\n}\n.ql-editor p:empty,\n.ql-editor p:has(> br:only-child) {\n  height: 1em;\n}\n.ql-editor h1, .ql-editor h2, .ql-editor h3 {\n  margin: 0.4em 0 0.2em;\n}\n.ql-editor ul, .ql-editor ol {\n  margin: 0.2em 0;\n}\n\n/* ============================================\n   Public Survey - Responsive\n   ============================================ */\n@media (max-width: 768px) {\n  .public-survey-container {\n    padding: 20px 10px !important;\n  }\n  .public-survey-container .card {\n    padding: 16px 14px !important;\n    border-radius: 10px !important;\n  }\n  .public-survey-container h1 {\n    font-size: 1.2rem !important;\n  }\n  .public-survey-container .btn-lg {\n    padding: 10px 20px !important;\n    font-size: 0.95rem !important;\n  }\n  .public-survey-container img {\n    max-height: 200px !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .public-survey-container {\n    padding: 12px 6px !important;\n  }\n  .public-survey-container .card {\n    padding: 14px 12px !important;\n  }\n  .public-survey-container h1 {\n    font-size: 1.05rem !important;\n  }\n  .public-survey-container .form-control {\n    font-size: 0.9rem !important;\n  }\n}\n\n/* ============================================\n   Pasted icon markup in survey question labels\n   ============================================ */\n\n/* Font Awesome is NOT bundled in this app (nothing in index.html/package.json\n   loads it), so a pasted <i class=\"fa fa-asterisk\"> draws nothing at all — the\n   glyph normally comes from FA's icon font. Authors use it to mark a question,\n   so render the asterisk as a plain character instead of shipping a ~70KB icon\n   font for one glyph. Inline color/font-size on the tag still apply, so\n   style=\"color:red\" gives the intended red asterisk. */\n.fa-asterisk {\n  font-style: normal;\n}\n.fa-asterisk::before {\n  content: \"*\";\n}\n\n/* LiveKit recording indicator — the dot pulses so a running recording is\n   noticeable in peripheral vision, not just a static red badge. */\n@keyframes lk-rec-blink {\n  0%, 100% { opacity: 1; }\n  50%      { opacity: 0.25; }\n}\n\n/* --- Wordmark ---\n   The real logotype, rendered as an image. Only the HEIGHT is constrained:\n   the artwork is ~5.4:1, and setting a width as well is how a logo gets\n   squashed. `flex-shrink: 0` stops a tight flex parent (the collapsed\n   sidebar) doing the same thing. */\n.wordmark {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5em;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.wordmark-img {\n  height: 1.6rem;\n  width: auto;\n  flex-shrink: 0;\n  display: block;\n}\n\n/* Light/dark variants of the SAME artwork — only the ink differs, the sphere is\n   identical in both. Swapped here rather than in JS so the logo cannot flash the\n   wrong variant on a theme change or first paint. `data-theme` is always set\n   explicitly on <html> by useTheme, so there is no third state to handle. */\n.wordmark-img-dark { display: none; }\n[data-theme='dark'] .wordmark-img-light { display: none; }\n[data-theme='dark'] .wordmark-img-dark { display: block; }\n\n\n/* Product qualifier (\"KOL\" / \"Admin\") — a small caps tag, never part of the logotype. */\n.wordmark-suffix {\n  font-family: var(--font-sans);\n  font-size: 0.58em;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: var(--color-text-light);\n  margin-left: 0.45em;\n  align-self: center;\n}\n\n/* --- Advisory Boards: lifecycle track on each board row --- */\n.phase-track {\n  display: flex;\n  gap: 4px;\n  margin-top: 10px;\n  max-width: 420px;\n}\n\n.phase-step {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.phase-step-bar {\n  height: 4px;\n  border-radius: var(--radius-full);\n  background: var(--color-surface-raised);\n  transition: background var(--transition);\n}\n\n.phase-step.is-done .phase-step-bar { background: var(--color-primary-light); }\n.phase-step.is-current .phase-step-bar { background: var(--color-primary); }\n\n.phase-step-label {\n  font-size: 0.62rem;\n  color: var(--color-text-light);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.phase-step.is-current .phase-step-label {\n  color: var(--color-primary-dark);\n  font-weight: 700;\n}\n\n/* Below 700px the five labels collide; the bars alone still show position. */\n@media (max-width: 700px) {\n  .phase-step-label { display: none; }\n}\n\n/* --- Board readiness gaps --- */\n.board-gaps {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 8px;\n}\n\n.board-gap {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 7px;\n  border-radius: var(--radius-full);\n  background: var(--color-warning-bg);\n  color: var(--color-warning-text);\n  font-size: 0.66rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n/* ── Advisory board detail ─────────────────────────────────────────────\n   Its own page (#boards/{id}): back-link, hero, grouped section rail. */\n.bd-back { display: flex; align-items: center; gap: 6px; margin-bottom: 12px; min-width: 0; }\n.bd-back-sep { color: var(--color-text-light); flex: none; }\n.bd-back-current {\n  font-size: 0.82rem; color: var(--color-text-secondary); font-weight: 600;\n  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\n}\n\n.bd-hero { padding: 18px 20px; margin-bottom: 18px; }\n.bd-hero-top { display: flex; justify-content: space-between; align-items: flex-start; gap: 14px; flex-wrap: wrap; }\n.bd-identity { min-width: 0; flex: 1 1 320px; }\n.bd-title-row { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-bottom: 6px; }\n.bd-title { margin: 0; font-size: 1.35rem; line-height: 1.25; }\n.bd-pill { padding: 3px 10px; border-radius: 999px; font-size: 0.72rem; font-weight: 600; white-space: nowrap; }\n.bd-meta { display: flex; flex-wrap: wrap; gap: 4px 16px; font-size: 0.85rem; color: var(--color-text-secondary); }\n.bd-meta > span { display: inline-flex; align-items: center; gap: 4px; }\n.bd-actions { display: flex; gap: 6px; align-items: center; flex-wrap: wrap; }\n.bd-locked {\n  display: inline-flex; align-items: center; gap: 4px;\n  font-size: 0.78rem; color: var(--color-text-light);\n}\n\n/* Stat strip — each tile jumps to the section it summarises. */\n.bd-stats {\n  display: grid; grid-template-columns: repeat(auto-fit, minmax(128px, 1fr));\n  gap: 8px; margin-top: 16px;\n}\n.bd-stat {\n  display: flex; flex-direction: column; gap: 4px; align-items: flex-start;\n  padding: 10px 12px; border: 1px solid var(--color-border-light); border-radius: var(--radius);\n  background: var(--color-bg); cursor: pointer; text-align: left;\n  transition: border-color var(--transition), background var(--transition);\n}\n.bd-stat:hover { border-color: var(--color-primary); background: var(--color-primary-bg); }\n.bd-stat-label {\n  display: inline-flex; align-items: center; gap: 5px;\n  font-size: 0.7rem; font-weight: 600; letter-spacing: 0.04em; text-transform: uppercase;\n  color: var(--color-text-light);\n}\n.bd-stat-value { font-size: 1.25rem; font-weight: 700; color: var(--color-text); line-height: 1.1; }\n.bd-stat-text { font-size: 0.95rem; text-transform: capitalize; }\n.bd-stat-of { font-size: 0.85rem; font-weight: 600; color: var(--color-text-light); }\n\n/* Lifecycle track — bar + step + label, one column per phase. */\n.bd-phases { margin-top: 18px; padding-top: 14px; border-top: 1px solid var(--color-border-light); }\n.bd-phases-head {\n  display: flex; align-items: baseline; justify-content: space-between;\n  gap: 8px; flex-wrap: wrap; margin-bottom: 10px;\n}\n.bd-phases-note { font-size: 0.74rem; color: var(--color-text-light); }\n.bd-eyebrow {\n  font-size: 0.72rem; font-weight: 700; letter-spacing: 0.05em;\n  text-transform: uppercase; color: var(--color-text-light);\n}\n.bd-phase-row { display: flex; gap: 6px; }\n.bd-phase {\n  flex: 1 1 0; min-width: 0; display: flex; flex-direction: column; gap: 5px;\n  padding: 0; border: none; background: none; cursor: pointer; text-align: left;\n}\n.bd-phase-bar {\n  display: block; height: 4px; border-radius: 999px;\n  background: var(--color-border-light); transition: background var(--transition);\n}\n.bd-phase:not(.is-current):not(.is-done):hover .bd-phase-bar { background: var(--color-border); }\n.bd-phase-step { font-size: 0.66rem; font-weight: 600; color: var(--color-text-light); }\n.bd-phase-label {\n  font-size: 0.8rem; font-weight: 600; color: var(--color-text-secondary);\n  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\n}\n.bd-phase.is-done .bd-phase-label { color: var(--color-text); }\n.bd-phase.is-current .bd-phase-label { font-weight: 700; }\n\n/* Body: left section rail + panel. */\n.bd-body { display: grid; grid-template-columns: 208px minmax(0, 1fr); gap: 18px; align-items: start; }\n/* A sticky element can only travel inside its containing block, and a grid row\n   is only as tall as its tallest item — with no min-height here the rail was\n   the taller column, had zero travel, and scrolled away with the page. */\n.bd-panel { min-height: calc(100vh - 120px); }\n\n/* The rail is bounded and scrolls on its own vertical axis. The bound is a\n   fixed 440px rather than the remaining viewport: viewport-bound made it 230px\n   at the top of the page, which read as chopped rather than scrollable. The\n   scrollbar is deliberately styled — macOS overlay scrollbars stay invisible\n   until you scroll, so an unstyled one gives no clue the list continues. */\n/* The bottom strip is reserved space, not an overlay — the cue used to sit on\n   top of the last visible item and the fade washed both of them out. Reserved\n   unconditionally so nothing shifts when the cue appears and disappears. */\n.bd-rail-wrap { position: sticky; top: 84px; padding-bottom: 22px; }\n/* Fade the bottom edge so it is obvious the list continues past the cut. Drawn\n   on the wrapper, not the scroller, or it would scroll away with the content;\n   inset from the right so it never sits over the scrollbar. */\n.bd-rail-wrap::after {\n  content: ''; position: absolute; left: 0; right: 11px; bottom: 22px; height: 26px;\n  background: linear-gradient(to bottom, transparent, var(--color-bg));\n  pointer-events: none; opacity: 0; transition: opacity var(--transition);\n}\n.bd-rail-wrap.has-more::after { opacity: 1; }\n/* Explicit cue — the fade alone is easy to miss, and macOS hides its overlay\n   scrollbar until you are already scrolling. Both drop away at the end. */\n.bd-rail-more {\n  position: absolute; left: 0; right: 11px; bottom: 0; height: 22px;\n  display: flex; align-items: center; justify-content: center; gap: 4px;\n  font-size: 0.68rem; font-weight: 700; letter-spacing: 0.06em; text-transform: uppercase;\n  color: var(--color-primary-dark); pointer-events: none;\n  opacity: 0; transition: opacity var(--transition);\n}\n.bd-rail-wrap.has-more .bd-rail-more { opacity: 1; }\n.bd-rail {\n  display: flex; flex-direction: column; gap: 14px;\n  max-height: min(440px, calc(100vh - 140px));\n  overflow-y: scroll; overflow-x: hidden;\n  padding-right: 10px;\n  scrollbar-width: thin;\n  scrollbar-color: var(--color-border-strong) var(--color-surface-raised);\n  overscroll-behavior: contain;\n}\n.bd-rail::-webkit-scrollbar { width: 10px; -webkit-appearance: none; appearance: none; }\n.bd-rail::-webkit-scrollbar-track {\n  background: var(--color-surface-raised); border-radius: 999px;\n}\n.bd-rail::-webkit-scrollbar-thumb {\n  background: var(--color-border-strong); border-radius: 999px;\n  border: 2px solid var(--color-surface-raised);\n}\n.bd-rail::-webkit-scrollbar-thumb:hover { background: var(--color-text-light); }\n\n.bd-rail-group { display: flex; flex-direction: column; gap: 1px; }\n.bd-rail-heading {\n  font-size: 0.68rem; font-weight: 700; letter-spacing: 0.07em; text-transform: uppercase;\n  color: var(--color-text-light); padding: 0 10px 5px;\n}\n.bd-rail-link {\n  display: flex; align-items: center; gap: 9px; width: 100%;\n  padding: 8px 10px; border: none; border-radius: var(--radius); background: none;\n  color: var(--color-text-secondary); font-size: 0.86rem; font-weight: 500;\n  cursor: pointer; text-align: left; transition: background var(--transition), color var(--transition);\n}\n.bd-rail-link:hover { background: var(--color-surface-hover); color: var(--color-text); }\n.bd-rail-link.is-active { background: var(--color-primary-bg); color: var(--color-primary-dark); font-weight: 600; }\n.bd-rail-link svg { flex: none; }\n.bd-rail-label { flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.bd-rail-count {\n  flex: none; min-width: 20px; padding: 1px 6px; border-radius: 999px;\n  background: var(--color-surface-raised); border: 1px solid var(--color-border-light);\n  font-size: 0.7rem; font-weight: 700; text-align: center; color: var(--color-text-secondary);\n}\n.bd-rail-link.is-active .bd-rail-count {\n  background: var(--color-surface); border-color: transparent; color: var(--color-primary-dark);\n}\n\n/* Overview: brief on the left, readiness on the right. */\n.bd-overview { display: grid; grid-template-columns: minmax(0, 1.55fr) minmax(0, 1fr); gap: 16px; align-items: start; }\n.bd-brief { padding: 18px; }\n.bd-prose { margin: 6px 0 0; line-height: 1.6; max-width: 68ch; }\n.bd-prose-pre { white-space: pre-wrap; }\n.bd-empty { color: var(--color-text-light); font-style: normal; }\n.bd-facts {\n  display: grid; grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)); gap: 14px;\n  margin-top: 18px; padding-top: 16px; border-top: 1px solid var(--color-border-light);\n}\n.bd-fact { display: flex; flex-direction: column; gap: 3px; font-size: 0.9rem; min-width: 0; }\n.bd-fact > span:last-child { overflow-wrap: anywhere; }\n.bd-notes { margin-top: 18px; padding-top: 16px; border-top: 1px solid var(--color-border-light); }\n\n.bd-readiness { padding: 18px; }\n.bd-readiness-head { display: flex; align-items: baseline; justify-content: space-between; gap: 8px; }\n.bd-readiness-score { font-size: 1rem; font-weight: 700; color: var(--color-text); }\n.bd-readiness-track {\n  height: 5px; border-radius: 999px; background: var(--color-border-light);\n  overflow: hidden; margin: 10px 0 14px;\n}\n.bd-readiness-fill { display: block; height: 100%; background: var(--color-primary); transition: width var(--transition); }\n.bd-checks { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 12px; }\n.bd-check { display: flex; gap: 9px; align-items: flex-start; color: var(--color-text-light); }\n.bd-check.is-ok { color: var(--color-success); }\n.bd-check svg { flex: none; margin-top: 1px; }\n.bd-check-label {\n  border: none; background: none; padding: 0; cursor: pointer;\n  font-size: 0.88rem; font-weight: 600; color: var(--color-text); text-align: left;\n}\n.bd-check-label:hover { color: var(--color-primary-dark); text-decoration: underline; }\n.bd-check.is-ok .bd-check-label { color: var(--color-text-secondary); font-weight: 500; }\n.bd-check-hint { font-size: 0.78rem; color: var(--color-text-light); margin-top: 2px; line-height: 1.45; }\n\n@media (max-width: 1080px) {\n  .bd-overview { grid-template-columns: minmax(0, 1fr); }\n}\n@media (max-width: 900px) {\n  /* No room for a rail beside the panel; it lies down into a horizontal\n     scroller and the group headings drop out rather than doubling its height. */\n  .bd-body { grid-template-columns: minmax(0, 1fr); gap: 14px; }\n  .bd-panel { min-height: 0; }\n  .bd-rail-wrap { position: static; padding-bottom: 0; }\n  .bd-rail-wrap::after, .bd-rail-more { display: none; }\n  .bd-rail {\n    flex-direction: row; gap: 4px;\n    max-height: none; overflow-y: hidden; overflow-x: auto;\n    padding-right: 0; padding-bottom: 6px;\n    border-bottom: 1px solid var(--color-border-light);\n  }\n  .bd-rail::-webkit-scrollbar { width: auto; height: 8px; }\n  .bd-rail-group { flex-direction: row; gap: 4px; }\n  .bd-rail-heading { display: none; }\n  .bd-rail-link { width: auto; white-space: nowrap; }\n  .bd-phase-step { display: none; }\n}\n@media (max-width: 560px) {\n  .bd-phase-label { font-size: 0.7rem; }\n  .bd-phases-note { display: none; }\n}\n\n/* Overview left column stacks brief + breakdown + roster. */\n.bd-col { display: flex; flex-direction: column; gap: 16px; min-width: 0; }\n.bd-breakdown, .bd-roster { padding: 18px; }\n.bd-phase-counts { display: flex; flex-direction: column; gap: 9px; margin-top: 12px; }\n.bd-phase-count {\n  display: grid; grid-template-columns: minmax(90px, 130px) minmax(0, 1fr) 28px;\n  align-items: center; gap: 10px; width: 100%;\n  border: none; background: none; padding: 0; cursor: pointer; text-align: left;\n}\n.bd-phase-count-label {\n  font-size: 0.82rem; color: var(--color-text-secondary);\n  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\n}\n.bd-phase-count:hover .bd-phase-count-label { color: var(--color-text); }\n.bd-phase-count-track { height: 7px; border-radius: 999px; background: var(--color-border-light); overflow: hidden; }\n.bd-phase-count-fill { display: block; height: 100%; border-radius: 999px; }\n.bd-phase-count-n { font-size: 0.82rem; font-weight: 700; color: var(--color-text); text-align: right; }\n\n.bd-roster-list { list-style: none; margin: 12px 0 0; padding: 0; display: flex; flex-direction: column; gap: 10px; }\n.bd-roster-item { display: flex; align-items: center; gap: 10px; min-width: 0; }\n.bd-roster-avatar {\n  flex: none; width: 30px; height: 30px; border-radius: 50%;\n  display: grid; place-items: center;\n  background: var(--color-primary-bg); color: var(--color-primary-dark);\n  font-size: 0.8rem; font-weight: 700;\n}\n.bd-roster-body { display: flex; flex-direction: column; min-width: 0; }\n.bd-roster-name {\n  font-size: 0.88rem; font-weight: 600; color: var(--color-text);\n  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\n}\n.bd-roster-sub {\n  font-size: 0.76rem; color: var(--color-text-light);\n  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\n}\n.bd-roster-more { padding-left: 40px; }\n\n/* Inline text button — an action that reads as part of a sentence. */\n.btn-link {\n  border: none; background: none; padding: 0; cursor: pointer;\n  font: inherit; color: var(--color-primary-dark); font-weight: 600;\n}\n.btn-link:hover { text-decoration: underline; }\n\n/* ── Meetings ──────────────────────────────────────────────────────────\n   Segmented status pills, an at-a-glance band, and a date-grouped list. */\n.filter-pills {\n  display: inline-flex; gap: 2px; flex: none;\n  padding: 3px; border-radius: var(--radius);\n  background: var(--color-surface-raised);\n}\n.filter-pill {\n  display: inline-flex; align-items: center; gap: 6px;\n  padding: 6px 12px; border: none; border-radius: calc(var(--radius) - 2px);\n  background: transparent; color: var(--color-text-secondary);\n  font-size: 0.8rem; font-weight: 600; cursor: pointer; white-space: nowrap;\n  transition: background var(--transition), color var(--transition);\n}\n.filter-pill:hover { color: var(--color-text); }\n.filter-pill.is-active {\n  background: var(--color-surface); color: var(--color-primary);\n  box-shadow: var(--shadow-sm, 0 1px 2px rgba(0, 0, 0, 0.06));\n}\n.filter-pill-count {\n  min-width: 18px; padding: 0 5px; border-radius: 999px;\n  background: var(--color-bg); color: var(--color-text-secondary);\n  font-size: 0.68rem; font-weight: 700; text-align: center;\n}\n.filter-pill.is-active .filter-pill-count {\n  background: var(--color-primary-bg); color: var(--color-primary-dark);\n}\n\n.mt-stats {\n  display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 10px; margin-bottom: 14px;\n}\n.mt-stat {\n  display: flex; flex-direction: column; gap: 4px;\n  padding: 12px 14px; border-radius: var(--radius);\n  border: 1px solid var(--color-border-light); background: var(--color-surface);\n}\n.mt-stat-label {\n  display: inline-flex; align-items: center; gap: 5px;\n  font-size: 0.7rem; font-weight: 600; letter-spacing: 0.04em; text-transform: uppercase;\n  color: var(--color-text-light);\n}\n.mt-stat-value { font-size: 1.35rem; font-weight: 700; color: var(--color-text); line-height: 1.1; }\n\n.mt-groups { display: flex; flex-direction: column; gap: 20px; }\n.mt-group-head { display: flex; align-items: center; gap: 8px; margin-bottom: 8px; }\n.mt-group-title {\n  margin: 0; font-size: 0.74rem; font-weight: 700;\n  letter-spacing: 0.07em; text-transform: uppercase; color: var(--color-text-light);\n}\n.mt-group-count {\n  min-width: 18px; padding: 1px 6px; border-radius: 999px;\n  background: var(--color-surface-raised); color: var(--color-text-secondary);\n  font-size: 0.68rem; font-weight: 700; text-align: center;\n}\n.mt-list { padding: 0; overflow: hidden; }\n\n.mt-row {\n  display: flex; align-items: center; gap: 12px;\n  padding: 12px 16px; border-bottom: 1px solid var(--color-border-light);\n  transition: background var(--transition);\n}\n.mt-row:last-child { border-bottom: none; }\n.mt-row:hover { background: var(--color-bg); }\n.mt-row-main {\n  display: flex; flex: 1 1 auto; min-width: 0; align-items: center; gap: 12px;\n  border: none; background: none; padding: 0; text-align: left; cursor: pointer;\n}\n.mt-icon {\n  flex: none; width: 36px; height: 36px; border-radius: var(--radius);\n  display: grid; place-items: center;\n}\n.mt-body { display: flex; flex-direction: column; gap: 3px; min-width: 0; flex: 1 1 auto; }\n.mt-title-row { display: flex; align-items: center; gap: 8px; min-width: 0; }\n.mt-title {\n  font-weight: 600; font-size: 0.93rem; color: var(--color-text);\n  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\n}\n.mt-status {\n  flex: none; padding: 2px 8px; border-radius: 999px;\n  font-size: 0.68rem; font-weight: 700; text-transform: capitalize;\n}\n.mt-meta {\n  display: flex; flex-wrap: wrap; gap: 2px 14px;\n  font-size: 0.78rem; color: var(--color-text-secondary);\n}\n.mt-meta > span { display: inline-flex; align-items: center; gap: 4px; }\n.mt-gaps { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 2px; }\n.mt-when {\n  flex: none; font-size: 0.78rem; font-weight: 600; color: var(--color-text-light);\n  white-space: nowrap; padding-left: 8px;\n}\n.mt-actions { display: flex; align-items: center; gap: 6px; flex: none; }\n.mt-icon-btn {\n  display: grid; place-items: center; width: 30px; height: 30px;\n  border: none; border-radius: var(--radius); background: transparent;\n  color: var(--color-text-light); cursor: pointer;\n  transition: background var(--transition), color var(--transition);\n}\n.mt-icon-btn:hover { background: var(--color-surface-hover); color: var(--color-text); }\n.mt-icon-btn.is-danger:hover { background: var(--color-error-bg, var(--color-surface-hover)); color: var(--color-error); }\n.mt-icon-btn:disabled { cursor: default; opacity: 0.6; }\n\n/* ── Meeting detail ──────────────────────────────────────────────────── */\n.md-summary {\n  margin: 8px 0 0; font-size: 0.88rem; line-height: 1.55;\n  color: var(--color-text-secondary); max-width: 72ch;\n}\n.md-live {\n  display: inline-flex; align-items: center; gap: 6px;\n  font-size: 0.74rem; font-weight: 700; letter-spacing: 0.04em;\n  text-transform: uppercase; color: var(--color-success);\n}\n.md-live-dot {\n  width: 7px; height: 7px; border-radius: 50%;\n  background: var(--color-success); animation: md-pulse 1.8s ease-in-out infinite;\n}\n@keyframes md-pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.25; } }\n@media (prefers-reduced-motion: reduce) { .md-live-dot { animation: none; } }\n/* Static tiles reuse the board hero's stat styling without its click affordance. */\n/* Static tiles pass already-formatted text (\"in 3 days\", \"Live now\"), so the\n   title-casing the board hero applies to raw enum values must not apply here. */\n.bd-stat.as-static { cursor: default; }\n.bd-stat.as-static .bd-stat-text { text-transform: none; }\n.bd-stat.as-static:hover { border-color: var(--color-border-light); background: var(--color-bg); }\n.md-workspace { margin-top: 20px; }\n\n@media (max-width: 700px) {\n  .mt-row { flex-wrap: wrap; }\n  .mt-when { display: none; }\n  .mt-actions { margin-left: auto; }\n}\n\n/* ── Public HCP form (/form/:token) ────────────────────────────────────\n   The only screen people outside the account see, so it carries the mark\n   and reads as a document rather than an app view. */\n.pf-page { min-height: 100vh; background: var(--color-bg); display: flex; flex-direction: column; }\n.pf-bar {\n  display: flex; align-items: center; justify-content: space-between; gap: 12;\n  padding: 14px 24px; border-bottom: 1px solid var(--color-border-light);\n  background: var(--color-surface);\n}\n.pf-main { width: 100%; max-width: 1080px; margin: 0 auto; padding: 32px 24px 120px; flex: 1 1 auto; }\n.pf-main.is-narrow { max-width: 460px; display: grid; place-items: center; }\n\n.pf-head { text-align: center; margin-bottom: 24px; }\n.pf-head h1 { margin: 0 0 8px; font-size: 1.6rem; line-height: 1.25; }\n.pf-head p { margin: 0 auto; max-width: 58ch; color: var(--color-text-secondary); line-height: 1.6; }\n.pf-alert { margin-bottom: 18px; }\n\n/* CV dropzone — horizontal, so it can never stretch into a tall empty column\n   beside the form the way the old two-column layout did. */\n.pf-cv {\n  display: flex; align-items: center; gap: 14px;\n  padding: 16px 18px; margin-bottom: 20px;\n  border: 1.5px dashed var(--color-border-strong); border-radius: var(--radius-lg, 12px);\n  background: var(--color-surface); cursor: pointer;\n  transition: border-color var(--transition), background var(--transition);\n}\n.pf-cv:hover, .pf-cv:focus-visible { border-color: var(--color-primary); background: var(--color-primary-bg); }\n.pf-cv.has-file { border-style: solid; border-color: var(--color-primary); background: var(--color-primary-bg); }\n.pf-cv.is-busy { cursor: progress; }\n.pf-cv-icon {\n  flex: none; width: 44px; height: 44px; border-radius: 50%;\n  display: grid; place-items: center;\n  background: var(--color-primary-bg); color: var(--color-primary-dark);\n}\n.pf-cv.has-file .pf-cv-icon { background: var(--color-surface); color: var(--color-success); }\n.pf-cv-copy { display: flex; flex-direction: column; gap: 2px; min-width: 0; flex: 1 1 auto; }\n.pf-cv-copy strong { font-size: 0.92rem; overflow-wrap: anywhere; }\n.pf-cv-copy span { font-size: 0.8rem; color: var(--color-text-secondary); line-height: 1.5; }\n.pf-cv-clear {\n  flex: none; border: none; background: none; cursor: pointer;\n  color: var(--color-text-light); padding: 4px; border-radius: var(--radius);\n}\n.pf-cv-clear:hover { color: var(--color-error); background: var(--color-surface); }\n\n.pf-section { padding: 20px; margin-bottom: 16px; }\n.pf-section-title {\n  display: flex; align-items: center; gap: 8px;\n  margin: 0 0 16px; font-size: 1rem; font-weight: 700;\n}\n.pf-section-title svg { color: var(--color-primary); }\n.pf-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 14px 16px; }\n/* Column counts are set per section to match the number of fields — auto-fit\n   alone laid the four \"About you\" inputs out 3 + 1, leaving a two-slot hole. */\n.pf-grid.is-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n/* Two-up on a wide screen so the extra width is used rather than left as\n   margin; the odd last field spans both so it does not sit alone. */\n.pf-grid.is-wide { grid-template-columns: repeat(auto-fit, minmax(320px, 1fr)); }\n.pf-grid.is-wide > .pf-field:last-child:nth-child(odd) { grid-column: 1 / -1; }\n.pf-field { display: flex; flex-direction: column; gap: 5px; min-width: 0; }\n.pf-field label {\n  display: flex; align-items: center; gap: 6px;\n  font-size: 0.84rem; font-weight: 600; color: var(--color-text-secondary);\n}\n.pf-field label svg { color: var(--color-text-light); flex: none; }\n.pf-field textarea { resize: vertical; }\n\n.pf-submit {\n  position: sticky; bottom: 16px; z-index: 5;\n  display: flex; align-items: center; justify-content: space-between; gap: 14px;\n  padding: 12px 16px; border-radius: var(--radius-lg, 12px);\n  border: 1px solid var(--color-border); background: var(--color-surface);\n  box-shadow: var(--shadow-lg, 0 8px 24px rgba(0, 0, 0, 0.1));\n}\n.pf-submit-status { font-size: 0.82rem; color: var(--color-text-secondary); min-width: 0; }\n\n.pf-state { text-align: center; padding: 48px 8px; }\n.pf-state h2 { margin: 14px 0 8px; font-size: 1.25rem; }\n.pf-state p { margin: 0; color: var(--color-text-secondary); line-height: 1.6; }\n.pf-state-note { margin-top: 10px !important; font-size: 0.85rem; color: var(--color-text-light) !important; }\n.pf-state-icon {\n  display: inline-grid; place-items: center; width: 56px; height: 56px; border-radius: 50%;\n}\n.pf-state-icon.is-success { background: var(--color-primary-bg); color: var(--color-success); }\n.pf-state-icon.is-error { background: var(--color-surface-raised); color: var(--color-error); }\n\n.pf-foot {\n  padding: 18px 24px 26px; text-align: center;\n  font-size: 0.78rem; color: var(--color-text-light);\n  border-top: 1px solid var(--color-border-light);\n}\n\n@media (max-width: 640px) {\n  .pf-grid.is-2 { grid-template-columns: minmax(0, 1fr); }\n}\n@media (max-width: 560px) {\n  .pf-main { padding: 22px 14px 120px; }\n  .pf-head h1 { font-size: 1.3rem; }\n  .pf-cv { flex-wrap: wrap; }\n  .pf-submit { flex-direction: column; align-items: stretch; gap: 8px; }\n  .pf-submit .btn { justify-content: center; }\n}\n\n/* Form Link tab — submission queue tools sit in the card header. */\n/* One row: no internal wrapping, and the search shrinks instead — wrapping\n   put the field on its own line and left the header visibly lopsided. */\n.fl-tools { display: flex; align-items: center; gap: 10px; margin-left: auto; flex-wrap: nowrap; min-width: 0; }\n.fl-search { min-width: 0; flex: 0 1 240px; }\n.fl-search input { min-width: 0; }\n@media (max-width: 860px) {\n  /* Below this the header genuinely cannot hold both, so it becomes two rows\n     with the tools spanning the full width. */\n  .fl-head { flex-wrap: wrap; row-gap: 12px; }\n  .fl-tools { width: 100%; margin-left: 0; }\n  .fl-search { flex: 1 1 auto; }\n}\n@media (max-width: 560px) {\n  .fl-tools { flex-wrap: wrap; }\n  .filter-pills { flex-wrap: wrap; }\n}\n\n/* Form Link rows — the URL is the point of the row, so it gets its own line\n   at full width instead of being truncated into uselessness. */\n.fl-link { padding: 14px 20px; }\n.fl-link-top { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; }\n.fl-state {\n  display: inline-flex; align-items: center; gap: 6px; flex: none;\n  font-size: 0.72rem; font-weight: 700; letter-spacing: 0.03em;\n  text-transform: uppercase; color: var(--color-text-light);\n}\n.fl-state.is-on { color: var(--color-success); }\n.fl-dot { width: 7px; height: 7px; border-radius: 50%; background: currentColor; }\n.fl-link-title { font-weight: 600; font-size: 0.95rem; min-width: 0; overflow-wrap: anywhere; }\n.fl-link-meta { font-size: 0.8rem; color: var(--color-text-secondary); }\n.fl-link-actions { display: flex; align-items: center; gap: 2px; margin-left: auto; flex: none; }\n.fl-danger:hover { color: var(--color-error); }\n\n.fl-url { display: flex; align-items: center; gap: 8px; margin-top: 10px; }\n.fl-url-input {\n  flex: 1 1 auto; min-width: 0;\n  padding: 7px 10px; border-radius: var(--radius);\n  border: 1px solid var(--color-border-light); background: var(--color-bg);\n  font-family: var(--font-mono, ui-monospace, SFMono-Regular, Menlo, monospace);\n  font-size: 0.78rem; color: var(--color-text-secondary);\n  text-overflow: ellipsis;\n}\n.fl-url-input:focus { outline: 2px solid var(--color-primary); outline-offset: 1px; }\n\n/* Compact and actionable — a one-line message did not need 300px of card. */\n.fl-empty {\n  display: flex; align-items: center; gap: 14px;\n  padding: 20px; color: var(--color-text-secondary);\n}\n.fl-empty > svg { flex: none; color: var(--color-text-light); }\n.fl-empty > div { display: flex; flex-direction: column; gap: 2px; min-width: 0; flex: 1 1 auto; }\n.fl-empty strong { color: var(--color-text); font-size: 0.92rem; }\n.fl-empty span { font-size: 0.83rem; line-height: 1.5; }\n\n@media (max-width: 640px) {\n  .fl-link-actions { margin-left: 0; width: 100%; }\n  .fl-empty { flex-wrap: wrap; }\n}\n\n/* Submission backlog notice + per-row waiting age. */\n.fl-backlog {\n  display: flex; align-items: center; gap: 12px; flex-wrap: wrap;\n  padding: 12px 16px; margin-bottom: 16px; border-radius: var(--radius);\n  border: 1px solid var(--color-warning, #C77700);\n  background: var(--color-warning-bg, var(--color-surface-raised));\n  color: var(--color-warning-text, var(--color-text));\n  font-size: 0.86rem;\n}\n.fl-backlog > svg { flex: none; }\n.fl-backlog > span { flex: 1 1 auto; min-width: 0; }\n.fl-waiting {\n  font-size: 0.72rem; font-weight: 700; padding: 1px 7px; border-radius: 999px;\n  background: var(--color-warning-bg, var(--color-surface-raised));\n  color: var(--color-warning-text, var(--color-text-secondary));\n}\n\n/* Derived \"current post\" on /hcp/new — read-only, filled from the faculty row\n   marked current rather than asked for a second time. */\n.current-post {\n  display: flex; flex-direction: column; gap: 2px;\n  padding: 9px 12px; border-radius: var(--radius);\n  border: 1px dashed var(--color-border); background: var(--color-bg);\n  font-size: 0.86rem; color: var(--color-text-light); min-height: 40px;\n  justify-content: center;\n}\n.current-post.is-set { border-style: solid; background: var(--color-surface); }\n.current-post strong { color: var(--color-text); font-weight: 600; }\n.current-post > span { color: var(--color-text-secondary); font-size: 0.8rem; line-height: 1.5; }\n\n/* ── Account → KOL Tiers ─────────────────────────────────────────────── */\n.tier-head { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; margin-bottom: 16px; flex-wrap: wrap; }\n.tier-title { display: flex; align-items: center; gap: 8px; margin: 0 0 4px; font-size: 1.05rem; }\n.tier-title svg { color: var(--color-primary); }\n.tier-sub { margin: 0; font-size: 0.85rem; color: var(--color-text-secondary); max-width: 62ch; line-height: 1.55; }\n.card.tier-card { padding: 0; overflow-x: auto; }\n/* Explicit colour: something upstream gives tables an inverse text colour, so\n   inheriting here put near-white text (--color-bg) on a white card. */\n.tier-table { width: 100%; border-collapse: collapse; font-size: 0.88rem; color: var(--color-text); }\n.tier-table td { color: var(--color-text); }\n.tier-table th {\n  text-align: left; padding: 11px 16px; font-size: 0.72rem; font-weight: 700;\n  letter-spacing: 0.05em; text-transform: uppercase; color: var(--color-text-light);\n  border-bottom: 1px solid var(--color-border-light); background: var(--color-bg);\n  white-space: nowrap;\n}\n.tier-table td { padding: 12px 16px; border-bottom: 1px solid var(--color-border-light); vertical-align: middle; }\n.tier-table tr:last-child td { border-bottom: none; }\n.tier-table tr.is-off { opacity: 0.55; }\n.tier-name { font-weight: 600; color: var(--color-text); }\n.tier-code {\n  display: block; margin-top: 2px; font-size: 0.7rem; color: var(--color-text-light);\n  font-family: var(--font-mono, ui-monospace, SFMono-Regular, Menlo, monospace);\n}\n.tier-range-cell { white-space: nowrap; font-variant-numeric: tabular-nums; color: var(--color-text); }\n.tier-swatch { display: inline-block; width: 22px; height: 22px; border-radius: 6px; border: 1px solid var(--color-border-light); }\n.tier-pill {\n  border: 1px solid var(--color-border); background: var(--color-bg);\n  color: var(--color-text-secondary); border-radius: 999px;\n  padding: 3px 11px; font-size: 0.75rem; font-weight: 600; cursor: pointer;\n}\n.tier-pill.is-on { border-color: transparent; background: var(--color-primary-bg); color: var(--color-primary-dark); }\n.tier-actions { display: flex; gap: 4px; justify-content: flex-end; }\n.tier-danger:hover:not(:disabled) { color: var(--color-error); }\n.tier-actions .btn:disabled { opacity: 0.35; cursor: not-allowed; }\n.tier-editor td { background: var(--color-primary-bg); }\n.tier-editor .tier-range { display: flex; align-items: center; gap: 6px; }\n.tier-editor .tier-range .form-control { width: 88px; }\n.tier-hint { font-size: 0.72rem; color: var(--color-text-light); margin-top: 4px; }\n.tier-color-input { width: 44px; height: 32px; padding: 2px; border: 1px solid var(--color-border); border-radius: var(--radius); background: var(--color-surface); cursor: pointer; }\n.tier-active { display: inline-flex; align-items: center; gap: 6px; font-size: 0.85rem; }\n.tier-gap { display: flex; align-items: flex-start; gap: 10px; line-height: 1.55; }\n.tier-gap svg { flex: none; margin-top: 2px; }\n\n/* Brand mark in the rail. The full logo carries its own sphere, so the\n   standalone mark would be a duplicate beside it — it appears only when the\n   rail collapses and the wordmark is hidden, leaving the brand with nothing. */\n.logo-mark { display: block; }\n.sidebar-brand-mark { display: none; }\n.sidebar.is-collapsed .sidebar-brand-mark { display: block; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
